import gql from 'graphql-tag'
import type * as ApolloReactCommon from '@apollo/react-common'
import * as ApolloReactHooks from 'legacy/apollo/codegenReactApolloHooks'
export type Maybe<T> = T
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string
  String: string
  Boolean: boolean
  Int: number
  Float: number
  /** The `BigInt` scalar type represents non-fractional signed whole numeric values. */
  BigInt: string
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: any
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: any
  /** An ISO 8601-encoded date */
  ISO8601Date: any
  Time: string
  /** A valid URL, transported as a string */
  Url: any
  True: true
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: any
  LegacyDate: any
}

export type AccessControlAuthorizationAuthorizationCheck = {
  __typename?: 'AccessControlAuthorizationAuthorizationCheck'
  /** Determines whether the current account has access to the given rules */
  authorized: Scalars['Boolean']
}

export type AccessControlConfiguration = {
  __typename?: 'AccessControlConfiguration'
  /** The flippers associated with the account */
  flippers: AccessControlFlippers
  /** The policies associated with the account */
  policies: AccessControlPolicies
  /** The access control details for the retailer */
  retailerDetails: AccessControlRetailerDetails
}

export type AccessControlConfigurationRetailerDetailsArgs = {
  retailerId: Scalars['ID']
}

export type AccessControlFlippers = {
  __typename?: 'AccessControlFlippers'
  /** The modernized version of the enterprise dashboard nav */
  modernNavigation: Scalars['Boolean']
}

export type AccessControlPolicies = {
  __typename?: 'AccessControlPolicies'
  /** Permission to view the admin tools section */
  viewAdminToolsSection: Scalars['Boolean']
  /** Permission to view the retailer dashboard section */
  viewRetailerDashboardSection: Scalars['Boolean']
}

export type AccessControlRetailerDetails = {
  __typename?: 'AccessControlRetailerDetails'
  /** The policies associated with the retailer */
  policies: AccessControlRetailerPolicies
}

export type AccessControlRetailerPolicies = {
  __typename?: 'AccessControlRetailerPolicies'
  /** Permission to modify retailer location groups */
  modifyRetailerLocationGroups: Scalars['Boolean']
  /** Permission to modify retailer reports */
  modifyRetailerReports: Scalars['Boolean']
  /** Permission to view retailer location groups */
  viewRetailerLocationGroups: Scalars['Boolean']
  /** Permission to view retailer reports */
  viewRetailerReports: Scalars['Boolean']
}

export type AccessToken = {
  __typename?: 'AccessToken'
  /** The account associated with the token */
  enterpriseAccount: Maybe<EnterpriseAccount>
  /** A unique token for authentication purposes */
  token: Scalars['ID']
}

export type Aisle = {
  __typename?: 'Aisle'
  id: Maybe<Scalars['BigInt']>
  name: Maybe<Scalars['String']>
  departmentId: Maybe<Scalars['BigInt']>
}

export type AisleOrder = {
  __typename?: 'AisleOrder'
  rank: Maybe<Scalars['BigInt']>
  name: Maybe<Scalars['String']>
  inventoryAreaAisleId: Maybe<Scalars['BigInt']>
}

export type AisleOrderInput = {
  rank?: Maybe<Scalars['BigInt']>
  name?: Maybe<Scalars['String']>
  inventoryAreaAisleId?: Maybe<Scalars['BigInt']>
}

export type AnyRetailerEtaAvailable = {
  __typename?: 'AnyRetailerEtaAvailable'
  id: Maybe<Scalars['BigInt']>
  placementId: Maybe<Scalars['BigInt']>
  retailerIds: Maybe<Array<Maybe<Scalars['BigInt']>>>
}

export type AnyRetailerEtaAvailableInput = {
  id?: Maybe<Scalars['BigInt']>
  placementId?: Maybe<Scalars['BigInt']>
  retailerIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>
}

export type ApiSetting = {
  __typename?: 'ApiSetting'
  id: Maybe<Scalars['BigInt']>
  partnerId: Maybe<Scalars['BigInt']>
  apiType: Maybe<Scalars['String']>
  cron: Maybe<Scalars['String']>
  integrationType: Maybe<Scalars['String']>
  enabled: Maybe<Scalars['Boolean']>
  createdAt: Maybe<Scalars['DateTime']>
}

export type AuditBatch = {
  __typename?: 'AuditBatch'
  batchId: Maybe<GoogleProtobufUInt64Value>
  batchUuid: Maybe<Scalars['String']>
  isExplicitFailedRedrive: Maybe<Scalars['Boolean']>
  batchState: Maybe<Scalars['String']>
  slaDueDate: Maybe<Scalars['DateTime']>
  workflow: Maybe<Scalars['String']>
  version: Maybe<Scalars['BigInt']>
  sampleTasks: Maybe<Array<Maybe<AuditTask>>>
  auditableTaskCount: Maybe<Scalars['BigInt']>
  recommendedSampleSize: Maybe<GoogleProtobufUInt64Value>
  sampleTaskCount: Maybe<GoogleProtobufUInt64Value>
  auditedTaskCount: Maybe<Scalars['BigInt']>
  createdAt: Maybe<Scalars['DateTime']>
  completedAt: Maybe<Scalars['DateTime']>
}

export type AuditTask = {
  __typename?: 'AuditTask'
  taskUuid: Maybe<Scalars['String']>
  taskState: Maybe<Scalars['String']>
  workflow: Maybe<Scalars['String']>
  intComment: Maybe<Scalars['String']>
  extComment: Maybe<Scalars['String']>
  inputData: Maybe<Scalars['String']>
  version: Maybe<Scalars['BigInt']>
  taskComponents: Maybe<Array<Maybe<TaskComponent>>>
  entityId: Maybe<EntityId>
  createdAt: Maybe<Scalars['DateTime']>
  completedAt: Maybe<Scalars['DateTime']>
}

export type AuditWorkflow = {
  __typename?: 'AuditWorkflow'
  name: Maybe<Scalars['String']>
  failOverPct: Maybe<Scalars['Float']>
  defaultSamplePct: Maybe<Scalars['Float']>
  defaultSlaDays: Maybe<Scalars['BigInt']>
  auditableTaskCount: Maybe<GoogleProtobufUInt64Value>
  approvedTaskCount: Maybe<GoogleProtobufUInt64Value>
  rejectedTaskCount: Maybe<GoogleProtobufUInt64Value>
  firstPendingSlaDueDate: Maybe<Scalars['DateTime']>
}

/** The method of authentication associated with an account */
export type AuthenticationInterface = {
  /** Unique authentication identifier */
  authenticationIdentifier: Scalars['ID']
}

export type Banner = {
  __typename?: 'Banner'
  id: Maybe<Scalars['BigInt']>
  variant: Maybe<BannerVariant>
  title: Maybe<Scalars['String']>
  titleColorHex: Maybe<Scalars['String']>
  subTitle: Maybe<Scalars['String']>
  subTitleColorHex: Maybe<Scalars['String']>
  cta: Maybe<Scalars['String']>
  imageUrl: Maybe<Scalars['String']>
  imageMobileUrl: Maybe<Scalars['String']>
  imageAltText: Maybe<Scalars['String']>
  status: Maybe<Status>
  backgroundColorHex: Maybe<Scalars['String']>
  ctaColorHex: Maybe<Scalars['String']>
  action: Maybe<Scalars['String']>
  actionData: Maybe<Scalars['String']>
  tagline: Maybe<Scalars['String']>
  taglineColorHex: Maybe<Scalars['String']>
  buttonStyle: Maybe<ButtonStyle>
  ctaAction: Maybe<BannerAction>
  locale: Maybe<InstacartCustomersSharedV1Locale>
}

export type BannerAction = {
  __typename?: 'BannerAction'
  navigateToUrl: Maybe<NavigateToUrl>
  navigateToStorefront: Maybe<NavigateToStorefront>
  navigateToStoreselector: Maybe<NavigateToStoreSelector>
  navigateToPickupStoreselector: Maybe<NavigateToPickupStoreSelector>
  navigateToContainerPathViaStoreselector: Maybe<NavigateToContainerPathViaStoreSelector>
  navigateToDepartment: Maybe<NavigateToDepartment>
  navigateToProduct: Maybe<NavigateToProduct>
  doNotNavigate: Maybe<DoNotNavigate>
  navigateToCategorySurface: Maybe<NavigateToCategorySurface>
  navigateToRetailerCollection: Maybe<NavigateToRetailerCollection>
  navigateToRetailerCollectionViaStoreselector: Maybe<NavigateToRetailerCollectionViaStoreSelector>
  navigateToPromoModal: Maybe<NavigateToPromoModal>
  navigateToCollection: Maybe<NavigateToCollection>
  navigateToSsaStoreselector: Maybe<NavigateToSsaStoreSelector>
  navigateToCollectionHub: Maybe<NavigateToCollectionHub>
  navigateToCouponRedemption: Maybe<NavigateToCouponRedemption>
}

export type BannerActionInput = {
  navigateToUrl?: Maybe<NavigateToUrlInput>
  navigateToStorefront?: Maybe<NavigateToStorefrontInput>
  navigateToStoreselector?: Maybe<NavigateToStoreSelectorInput>
  navigateToPickupStoreselector?: Maybe<NavigateToPickupStoreSelectorInput>
  navigateToContainerPathViaStoreselector?: Maybe<NavigateToContainerPathViaStoreSelectorInput>
  navigateToDepartment?: Maybe<NavigateToDepartmentInput>
  navigateToProduct?: Maybe<NavigateToProductInput>
  doNotNavigate?: Maybe<DoNotNavigateInput>
  navigateToCategorySurface?: Maybe<NavigateToCategorySurfaceInput>
  navigateToRetailerCollection?: Maybe<NavigateToRetailerCollectionInput>
  navigateToRetailerCollectionViaStoreselector?: Maybe<NavigateToRetailerCollectionViaStoreSelectorInput>
  navigateToPromoModal?: Maybe<NavigateToPromoModalInput>
  navigateToCollection?: Maybe<NavigateToCollectionInput>
  navigateToSsaStoreselector?: Maybe<NavigateToSsaStoreSelectorInput>
  navigateToCollectionHub?: Maybe<NavigateToCollectionHubInput>
  navigateToCouponRedemption?: Maybe<NavigateToCouponRedemptionInput>
}

export type BannerInput = {
  id?: Maybe<Scalars['BigInt']>
  variant?: Maybe<BannerVariant>
  title?: Maybe<Scalars['String']>
  titleColorHex?: Maybe<Scalars['String']>
  subTitle?: Maybe<Scalars['String']>
  subTitleColorHex?: Maybe<Scalars['String']>
  cta?: Maybe<Scalars['String']>
  imageUrl?: Maybe<Scalars['String']>
  imageMobileUrl?: Maybe<Scalars['String']>
  imageAltText?: Maybe<Scalars['String']>
  status?: Maybe<Status>
  backgroundColorHex?: Maybe<Scalars['String']>
  ctaColorHex?: Maybe<Scalars['String']>
  action?: Maybe<Scalars['String']>
  actionData?: Maybe<Scalars['String']>
  tagline?: Maybe<Scalars['String']>
  taglineColorHex?: Maybe<Scalars['String']>
  buttonStyle?: Maybe<ButtonStyle>
  ctaAction?: Maybe<BannerActionInput>
  locale?: Maybe<InstacartCustomersSharedV1Locale>
}

export enum BannerLocaleEnum {
  /** American English */
  EnUs = 'EN_US',
  /** Canadian English */
  EnCa = 'EN_CA',
  /** Canadian French */
  FrCa = 'FR_CA',
}

export type BannerType = {
  __typename?: 'BannerType'
  defaultBanner: Maybe<Banner>
  textWithThumbnail: Maybe<TextWithThumbnail>
  imageForward: Maybe<ImageForward>
  logoWithTextBanner: Maybe<LogoWithTextBanner>
  unknownBanner: Maybe<UnknownBanner>
  textWithThumbnailFlex: Maybe<TextWithThumbnailFlex>
  imageForwardFlex: Maybe<ImageForwardFlex>
  heroBanner: Maybe<HeroBanner>
  secondaryBanner: Maybe<SecondaryBanner>
}

export type BannerTypeInput = {
  defaultBanner?: Maybe<BannerInput>
  textWithThumbnail?: Maybe<TextWithThumbnailInput>
  imageForward?: Maybe<ImageForwardInput>
  logoWithTextBanner?: Maybe<LogoWithTextBannerInput>
  unknownBanner?: Maybe<UnknownBannerInput>
  textWithThumbnailFlex?: Maybe<TextWithThumbnailFlexInput>
  imageForwardFlex?: Maybe<ImageForwardFlexInput>
  heroBanner?: Maybe<HeroBannerInput>
  secondaryBanner?: Maybe<SecondaryBannerInput>
}

export enum BannerVariant {
  Image = 'IMAGE',
  Text = 'TEXT',
  TextWithThumbnail = 'TEXT_WITH_THUMBNAIL',
  Large = 'LARGE',
  ImageForward = 'IMAGE_FORWARD',
  LogoWithText = 'LOGO_WITH_TEXT',
  AsyncImage = 'ASYNC_IMAGE',
  TextWithThumbnailFlex = 'TEXT_WITH_THUMBNAIL_FLEX',
  ImageForwardFlex = 'IMAGE_FORWARD_FLEX',
  HeroBanner = 'HERO_BANNER',
  SecondaryBanner = 'SECONDARY_BANNER',
}

export type BetweenFilterInput = {
  start?: Maybe<InsightsPortalValueInput>
  end?: Maybe<InsightsPortalValueInput>
}

export enum BotAccountAssignableRoleEnum {
  /** Engineer role */
  Engineer = 'ENGINEER',
  /** Admin role */
  NonEngineer = 'NON_ENGINEER',
}

export enum BotAccountOperationTypeEnum {
  /** Account was created */
  Created = 'CREATED',
  /** Account was updated */
  Updated = 'UPDATED',
}

/** Autogenerated return type of BotEnterpriseAccountUpsert */
export type BotEnterpriseAccountUpsertPayload = {
  __typename?: 'BotEnterpriseAccountUpsertPayload'
  /** The newly created or updated account object */
  enterpriseAccount: EnterpriseAccount
  /** What kind of operation was executed */
  operationType: BotAccountOperationTypeEnum
}

export enum ButtonStyle {
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY',
}

export enum ButtonVariantEnum {
  /** Use the primary button style */
  Primary = 'PRIMARY',
}

export type CallbackConfigurationInput = {
  /** The id */
  id: Scalars['ID']
  /** The authentication URI */
  authUri?: Maybe<Scalars['String']>
  /** The client id */
  credentialsClientId?: Maybe<Scalars['String']>
  /** The client id */
  credentialsClientSecret?: Maybe<Scalars['String']>
  /** The callback URI */
  callbackUri?: Maybe<Scalars['String']>
  /** The access token TTL */
  accessTokenTtl?: Maybe<Scalars['Int']>
  /** The enabled statusers */
  statusesOfInterest?: Maybe<Array<Scalars['String']>>
  /** The possible statuses to enable */
  availableStatuses?: Maybe<Array<Scalars['String']>>
}

export type CancelOrderRequestInput = {
  requestContext?: Maybe<InstacartTypesV1RequestContextInput>
  userId?: Maybe<Scalars['BigInt']>
  orderId?: Maybe<Scalars['BigInt']>
  externalId?: Maybe<Scalars['String']>
  partnerId?: Maybe<Scalars['BigInt']>
  retailerId?: Maybe<Scalars['BigInt']>
  modificationEvent?: Maybe<InstacartEnterpriseBobaCoreTypesV1ModificationEventInput>
}

export type CancelOrderResponse = {
  __typename?: 'CancelOrderResponse'
  order: Maybe<InstacartEnterpriseBobaCoreTypesV1Order>
  orderItems: Maybe<Array<Maybe<InstacartEnterpriseBobaCoreTypesV1OrderItem>>>
}

export type CardList = {
  __typename?: 'CardList'
  id: Maybe<Scalars['BigInt']>
  variant: Maybe<CardListVariant>
  title: Maybe<Scalars['String']>
  cta: Maybe<Scalars['String']>
}

export type CardListInput = {
  id?: Maybe<Scalars['BigInt']>
  variant?: Maybe<CardListVariant>
  title?: Maybe<Scalars['String']>
  cta?: Maybe<Scalars['String']>
}

export enum CardListVariant {
  CardList = 'CARD_LIST',
  PillList = 'PILL_LIST',
  GridList = 'GRID_LIST',
}

export type CatalogAisle = {
  __typename?: 'CatalogAisle'
  /** The department associated with this aisle */
  department: CatalogDepartment
  /** A unique identifier for the aisle */
  id: Scalars['ID']
  /** The aisle's name - ('Candy & Chocolates', 'Chips & Pretzels', ...) */
  name: Scalars['String']
}

export type CatalogChangesetNewProductRequest = {
  __typename?: 'CatalogChangesetNewProductRequest'
  /** The aisle for the product - `Candy & Chocolate` */
  aisle: CatalogAisle
  /** Is the product alcoholic? - (true, false) */
  alcoholic: Scalars['Boolean']
  /** The product's brand - `Hershey's` */
  brand: Scalars['String']
  /** The classified code/type associated with the product (contains UPC details) */
  classificationInfo: CatalogClassificationInfo
  /** The cost unit of the product - (`each`, `lb`, ...) */
  costUnit: CostUnitEnum
  /** When the changeset product was created */
  createdAt: Scalars['Time']
  /** The department for the product - `Snacks` */
  department: CatalogDepartment
  /** Details about the product, e.g. `Brown, overripe bananas, suitable for baking` */
  description: Scalars['String']
  /** Is the product fat_free? - (true, false) */
  fatFree: Scalars['Boolean']
  /** Is the product gluten_free? - (true, false) */
  glutenFree: Scalars['Boolean']
  /** A unique identifier for the catalog changeset new product request */
  id: Scalars['ID']
  /** An absolute url representing the 'back' angle - `https://www.example.com/etc` */
  imageUrlBack: Maybe<Scalars['Url']>
  /** An absolute url representing the 'drug facts' angle - `https://www.example.com/etc` */
  imageUrlDrugFacts: Maybe<Scalars['Url']>
  /** An absolute url representing the 'ingredients' angle - `https://www.example.com/etc` */
  imageUrlIngredients: Maybe<Scalars['Url']>
  /** An absolute url representing the 'left' angle - `https://www.example.com/etc` */
  imageUrlLeft: Maybe<Scalars['Url']>
  /** An absolute url representing the 'lifestyle' angle - `https://www.example.com/etc` */
  imageUrlLifestyle: Maybe<Scalars['Url']>
  /** An absolute url representing the 'nutrition' angle - `https://www.example.com/etc` */
  imageUrlNutrition: Maybe<Scalars['Url']>
  /** An absolute url representing the 'primary' angle - `https://www.example.com/etc` */
  imageUrlPrimary: Scalars['Url']
  /** An absolute url representing the 'right' angle - `https://www.example.com/etc` */
  imageUrlRight: Maybe<Scalars['Url']>
  /** An absolute url representing the 'supplement facts' angle - `https://www.example.com/etc` */
  imageUrlSupplementFacts: Maybe<Scalars['Url']>
  /** An absolute url representing the 'top' angle - `https://www.example.com/etc` */
  imageUrlTop: Maybe<Scalars['Url']>
  /** The code-lookup associated with this new product request */
  importProcessCodeLookup: CatalogImportProcessCodeLookup
  /** The id for the code-lookup associated with this new product request */
  importProcessCodeLookupId: Scalars['ID']
  /** Is the product kosher? - (true, false) */
  kosher: Scalars['Boolean']
  /** Is the product low_fat? - (true, false) */
  lowFat: Scalars['Boolean']
  /** The product's name - `Hershey's Extra Large Chocolate Bar` */
  name: Scalars['String']
  /** Is the product organic? - (true, false) */
  organic: Scalars['Boolean']
  /** The price per cost unit of the product - `17.9` */
  pricePerCostUnit: Scalars['Float']
  /** The size of the product - (`12 kg`, `14 oz`, ...) */
  size: Scalars['String']
  /** Is the product sugar_free? - (true, false) */
  sugarFree: Scalars['Boolean']
  /** Is the product taxable? - (true, false) */
  taxable: Scalars['Boolean']
  /** When the changeset product was last updated */
  updatedAt: Scalars['Time']
  /** Is the product vegan? - (true, false) */
  vegan: Scalars['Boolean']
  /** Is the product vegetarian? - (true, false) */
  vegetarian: Scalars['Boolean']
}

/** The connection type for CatalogChangesetNewProductRequest. */
export type CatalogChangesetNewProductRequestConnection = {
  __typename?: 'CatalogChangesetNewProductRequestConnection'
  /** A list of edges. */
  edges: Maybe<Array<Maybe<CatalogChangesetNewProductRequestEdge>>>
  /** Metadata regarding the connection */
  meta: ConnectionMeta
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<CatalogChangesetNewProductRequest>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type CatalogChangesetNewProductRequestEdge = {
  __typename?: 'CatalogChangesetNewProductRequestEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: Maybe<CatalogChangesetNewProductRequest>
}

export type CatalogChangesetProduct = {
  __typename?: 'CatalogChangesetProduct'
  /** The classified code/type associated with the product (contains UPC details) */
  classificationInfo: CatalogClassificationInfo
  /** When the changeset product was created */
  createdAt: Scalars['Time']
  /** A unique identifier for the catalog changeset product */
  id: Scalars['ID']
  /** The actual global product associated with this changeset product */
  product: CatalogProduct
  /** The aisle for the changeset product - 'Candy & Chocolate' */
  specifiedAisle: Maybe<CatalogAisle>
  /** The cost unit of the changeset product - ('each','lb', ...) */
  specifiedCostUnit: Maybe<CostUnitEnum>
  /** The department for the changeset product - 'Snacks' */
  specifiedDepartment: Maybe<CatalogDepartment>
  /** The price per cost unit of the changeset product - '17.9' */
  specifiedPricePerCostUnit: Maybe<Scalars['Float']>
  /** The form-details status of the changeset product - (completed_info, missing_info) */
  status: ChangesetProductStatusEnum
  /** When the changeset product was last updated */
  updatedAt: Scalars['Time']
}

/** The connection type for CatalogChangesetProduct. */
export type CatalogChangesetProductConnection = {
  __typename?: 'CatalogChangesetProductConnection'
  /** A list of edges. */
  edges: Maybe<Array<Maybe<CatalogChangesetProductEdge>>>
  /** Metadata regarding the connection */
  meta: ConnectionMeta
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<CatalogChangesetProduct>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type CatalogChangesetProductEdge = {
  __typename?: 'CatalogChangesetProductEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: Maybe<CatalogChangesetProduct>
}

export type CatalogClassificationInfo = {
  __typename?: 'CatalogClassificationInfo'
  /** The associated code (Could be a UPC - '034000170388', PLU - '1147', or In-House 'AB008') */
  code: Scalars['String']
  /** The associated retailer (for in-house products) */
  retailer: Maybe<Retailer>
  /** The type of classified code (universal, commodity, in-house, ...) */
  type: ClassifiedTypeEnum
}

export type CatalogCodeLookup = {
  __typename?: 'CatalogCodeLookup'
  /** The code-lookup's code - (UPC, PLU, etc. - 034000170388) */
  code: Scalars['String']
  /** The batch with the code-lookup */
  codeLookupBatch: CatalogCodeLookupBatch
  /** The state of the code-lookup - ('PENDING', 'IN_PROGRESS', ...) */
  codeLookupState: CodeLookupStateEnum
  /** The status of the code-lookup - ('NO_MATCHES', 'PERFECT_MATCH', ...) */
  codeLookupStatus: Maybe<CodeLookupStatusEnum>
  /** The type of the code-lookup - ('UPC', 'RRC') */
  codeLookupType: Maybe<CodeLookupTypeEnum>
  /** When the code-lookup was created */
  createdAt: Scalars['Time']
  /** A unique identifier */
  id: Scalars['ID']
  /** An array of product_ids's matching the provided code - (123, 456, ...). */
  productIds: Maybe<Array<Scalars['ID']>>
  /** When the code-lookup was last updated */
  updatedAt: Scalars['Time']
}

export type CatalogCodeLookupBatch = {
  __typename?: 'CatalogCodeLookupBatch'
  /** The owner of the code lookup batch */
  codeLookupBatchOwner: EnterpriseAccount
  /** Wheather all the code lookups in this batch were processed or not */
  codeLookupProcessCompleted: Scalars['Boolean']
  /** List of code lookups that are part of this batch */
  codeLookups: Array<CatalogCodeLookup>
  /** When the code lookup batch was created */
  createdAt: Scalars['Time']
  /** A unique identifier */
  id: Scalars['ID']
  /** The number of code lookups in this batch that perfectly matched with one product */
  perfectMatchCount: Scalars['Int']
  /** Product IDs that perfectly matched with one of the code lookup */
  perfectMatchProductIds: Array<Scalars['ID']>
  /** When the code lookup batch was last updated */
  updatedAt: Scalars['Time']
}

/** Autogenerated return type of CatalogCodeLookupBatchCreate */
export type CatalogCodeLookupBatchCreatePayload = {
  __typename?: 'CatalogCodeLookupBatchCreatePayload'
  /** The newly created code lookup batch */
  catalogCodeLookupBatch: CatalogCodeLookupBatch
}

/** The connection type for CatalogCodeLookup. */
export type CatalogCodeLookupConnection = {
  __typename?: 'CatalogCodeLookupConnection'
  /** A list of edges. */
  edges: Maybe<Array<Maybe<CatalogCodeLookupEdge>>>
  /** Metadata regarding the connection */
  meta: ConnectionMeta
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<CatalogCodeLookup>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type CatalogCodeLookupEdge = {
  __typename?: 'CatalogCodeLookupEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: Maybe<CatalogCodeLookup>
}

export type CatalogDepartment = {
  __typename?: 'CatalogDepartment'
  /** An array of the department's aisles */
  aisles: Array<CatalogAisle>
  /** A unique identifier for the department */
  id: Scalars['ID']
  /** The department's name - ('Snacks', 'Meat & Seafood', ...) */
  name: Scalars['String']
}

export type CatalogImportProcess = {
  __typename?: 'CatalogImportProcess'
  /** When the import process was created */
  createdAt: Scalars['Time']
  /** A unique identifier for the catalog import process */
  id: Scalars['ID']
  /** The owner of the import process */
  importProcessOwner: EnterpriseAccount
  /** The state of the import process */
  importProcessState: ImportProcessStateEnum
  /** The type of the import process */
  importProcessType: ImportProcessTypeEnum
  /** Description or URL of the data source for this import process */
  source: Maybe<Scalars['String']>
  /** When the import process was last updated */
  updatedAt: Scalars['Time']
  /** The workflow associated with the import process */
  workflow: CatalogWorkflow
}

export type CatalogImportProcessCodeLookup = {
  __typename?: 'CatalogImportProcessCodeLookup'
  /** The code-lookup's code - (UPC, PLU, etc. - 034000170388) */
  code: Scalars['String']
  /** When the code-lookup was created */
  createdAt: Scalars['Time']
  /** A unique identifier for the catalog workflow */
  id: Scalars['ID']
  /** The import process associated with the code-lookup */
  importProcess: CatalogImportProcess
  /** The state of the code-lookup - ('PENDING', 'IN_PROGRESS', ...) */
  importProcessCodeLookupState: ImportProcessCodeLookupStateEnum
  /** The status of the code-lookup - ('NO_MATCHES', 'PERFECT_MATCH', ...) */
  importProcessCodeLookupStatus: Maybe<ImportProcessCodeLookupStatusEnum>
  /** The type of the code-lookup - ('UPC', ...) */
  importProcessCodeLookupType: ImportProcessCodeLookupTypeEnum
  /** An array of product_ids's matching the provided code - (123, 456, ...). */
  productIds: Maybe<Array<Scalars['ID']>>
  /** When the code-lookup was last updated */
  updatedAt: Scalars['Time']
}

/** The connection type for CatalogImportProcessCodeLookup. */
export type CatalogImportProcessCodeLookupConnection = {
  __typename?: 'CatalogImportProcessCodeLookupConnection'
  /** A list of edges. */
  edges: Maybe<Array<Maybe<CatalogImportProcessCodeLookupEdge>>>
  /** Metadata regarding the connection */
  meta: ConnectionMeta
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<CatalogImportProcessCodeLookup>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** Autogenerated return type of CatalogImportProcessCodeLookupCreate */
export type CatalogImportProcessCodeLookupCreatePayload = {
  __typename?: 'CatalogImportProcessCodeLookupCreatePayload'
  /** The newly created import process */
  catalogImportProcess: CatalogImportProcess
}

/** An edge in a connection. */
export type CatalogImportProcessCodeLookupEdge = {
  __typename?: 'CatalogImportProcessCodeLookupEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: Maybe<CatalogImportProcessCodeLookup>
}

/** The connection type for CatalogImportProcess. */
export type CatalogImportProcessConnection = {
  __typename?: 'CatalogImportProcessConnection'
  /** A list of edges. */
  edges: Maybe<Array<Maybe<CatalogImportProcessEdge>>>
  /** Metadata regarding the connection */
  meta: ConnectionMeta
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<CatalogImportProcess>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type CatalogImportProcessEdge = {
  __typename?: 'CatalogImportProcessEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: Maybe<CatalogImportProcess>
}

export type CatalogProduct = {
  __typename?: 'CatalogProduct'
  /** The classified code/type associated with the product (contains UPC details) */
  classificationInfo: CatalogClassificationInfo
  /**
   * The classified code associated with the product (Also referred to as UPC - '034000170388')
   * @deprecated Use `classification info` instead, as it has more details than `classified_code`
   */
  classifiedCode: Maybe<Scalars['String']>
  /** Details about the product, e.g. 'Brown, overripe bananas, suitable for baking */
  description: Maybe<Scalars['String']>
  /** The product's name - 'Hershey's Extra Large Chocolate Bar' */
  displayName: Scalars['String']
  /** A unique identifier for the product */
  id: Scalars['ID']
  /**
   * The product's name - 'Hershey's Extra Large Chocolate Bar'
   * @deprecated Use `display name` instead, as it has more details than `name`
   */
  name: Scalars['String']
  /** An absolute url of the primary image associated with the product - 'https://www.example.com/etc' */
  primaryImageUrl: Maybe<Scalars['String']>
}

export type CatalogRetailerProduct = {
  __typename?: 'CatalogRetailerProduct'
  /** The available item count of the retailer product */
  availableItemsCount: Maybe<Scalars['Int']>
  /** The details of the retailer product */
  details: Maybe<Scalars['String']>
  /** The display_name of the retailer product */
  displayName: Maybe<Scalars['String']>
  /** A unique identifier for the retailer product */
  id: Scalars['ID']
  /** The Url of the retailer product's primary image */
  primaryImageUrl: Maybe<Scalars['Url']>
  /** The unique identifier for the associated product */
  productId: Maybe<Scalars['ID']>
  /** The size of the retailer product (e.g., 4 oz) */
  size: Maybe<Scalars['String']>
  /** The unit count of the retailer product */
  unitCount: Maybe<Scalars['Int']>
}

/** The connection type for CatalogRetailerProduct. */
export type CatalogRetailerProductConnection = {
  __typename?: 'CatalogRetailerProductConnection'
  /** A list of edges. */
  edges: Maybe<Array<Maybe<CatalogRetailerProductEdge>>>
  /** Metadata regarding the connection */
  meta: ConnectionMeta
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<CatalogRetailerProduct>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type CatalogRetailerProductEdge = {
  __typename?: 'CatalogRetailerProductEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: Maybe<CatalogRetailerProduct>
}

export type CatalogSearchDownloadsCatalogSearchDownloadSignedUrl = {
  __typename?: 'CatalogSearchDownloadsCatalogSearchDownloadSignedUrl'
  /** Signed url for the object */
  signedUrl: Scalars['String']
}

export type CatalogTaxonomyNode = {
  __typename?: 'CatalogTaxonomyNode'
  /** A unique identifier for the taxonomy node */
  id: Scalars['ID']
  /** The taxonomy nodes's name - ('Food', 'Meat', ...) */
  name: Scalars['String']
  /** The parent taxonomy node */
  parentId: Scalars['ID']
}

export type CatalogWorkflow = {
  __typename?: 'CatalogWorkflow'
  /** The number of associated new-changeset-product-requests with */
  changesetNewProductRequestsCount: Scalars['Int']
  /** The associated changeset products */
  changesetProducts: CatalogChangesetProductConnection
  /** The number of associated changeset products */
  changesetProductsCount: Scalars['Int']
  /** The number of associated changeset products with completed info */
  completedInfoChangesetProductsCount: Scalars['Int']
  /** When the workflow was created */
  createdAt: Scalars['Time']
  /** A unique identifier for the catalog workflow */
  id: Scalars['ID']
  /** The number of associated code lookups */
  importProcessCodeLookupsCount: Scalars['Int']
  /** The associated import processes */
  importProcesses: CatalogImportProcessConnection
  /** The most recent update time for any associated changeset/products/requests */
  latestRelatedUpdateTime: Scalars['Time']
  /** The number of associated changeset products with missing info */
  missingInfoChangesetProductsCount: Scalars['Int']
  /** The number of associated pending code lookups */
  pendingImportProcessCodeLookupsCount: Scalars['Int']
  /** The number of associated pending match code lookups */
  perfectMatchImportProcessCodeLookupsCount: Scalars['Int']
  /** The retailer that this workflow belongs to */
  retailer: Retailer
  /** The number of associated unmatched code lookups */
  unmatchedImportProcessCodeLookupsCount: Scalars['Int']
  /** When the workflow was last updated */
  updatedAt: Scalars['Time']
  /** The owner of the workflow */
  workflowOwner: EnterpriseAccount
  /** The state of the workflow */
  workflowState: WorkflowStateEnum
  /** The type of the workflow */
  workflowType: WorkflowTypeEnum
}

export type CatalogWorkflowChangesetProductsArgs = {
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export type CatalogWorkflowImportProcessesArgs = {
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

/** The connection type for CatalogWorkflow. */
export type CatalogWorkflowConnection = {
  __typename?: 'CatalogWorkflowConnection'
  /** A list of edges. */
  edges: Maybe<Array<Maybe<CatalogWorkflowEdge>>>
  /** Metadata regarding the connection */
  meta: ConnectionMeta
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<CatalogWorkflow>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** Autogenerated return type of CatalogWorkflowCreate */
export type CatalogWorkflowCreatePayload = {
  __typename?: 'CatalogWorkflowCreatePayload'
  /** The newly created workflow */
  catalogWorkflow: CatalogWorkflow
}

/** Autogenerated return type of CatalogWorkflowDelete */
export type CatalogWorkflowDeletePayload = {
  __typename?: 'CatalogWorkflowDeletePayload'
  /** Whether the deletion succeeded or not */
  success: Scalars['True']
}

/** An edge in a connection. */
export type CatalogWorkflowEdge = {
  __typename?: 'CatalogWorkflowEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: Maybe<CatalogWorkflow>
}

/** Autogenerated return type of CatalogWorkflowEventCreateBulkRemoveChangesetNewProductRequests */
export type CatalogWorkflowEventCreateBulkRemoveChangesetNewProductRequestsPayload = {
  __typename?: 'CatalogWorkflowEventCreateBulkRemoveChangesetNewProductRequestsPayload'
  /** A status which is true if no errors were encountered when processing the workflow event */
  success: Scalars['True']
}

/** Autogenerated return type of CatalogWorkflowEventCreateBulkRemoveChangesetProducts */
export type CatalogWorkflowEventCreateBulkRemoveChangesetProductsPayload = {
  __typename?: 'CatalogWorkflowEventCreateBulkRemoveChangesetProductsPayload'
  /** A status which is true if no errors were encountered when processing the workflow event */
  success: Scalars['True']
}

/** Autogenerated return type of CatalogWorkflowEventCreateBulkRemoveImportProcessCodeLookups */
export type CatalogWorkflowEventCreateBulkRemoveImportProcessCodeLookupsPayload = {
  __typename?: 'CatalogWorkflowEventCreateBulkRemoveImportProcessCodeLookupsPayload'
  /** A status which is true if no errors were encountered when processing the workflow event */
  success: Scalars['True']
}

/** Autogenerated return type of CatalogWorkflowEventCreateBulkUpdateChangesetProducts */
export type CatalogWorkflowEventCreateBulkUpdateChangesetProductsPayload = {
  __typename?: 'CatalogWorkflowEventCreateBulkUpdateChangesetProductsPayload'
  /** A status which is true if no errors were encountered when processing the workflow event */
  success: Scalars['True']
}

/** Autogenerated return type of CatalogWorkflowEventCreate */
export type CatalogWorkflowEventCreatePayload = {
  __typename?: 'CatalogWorkflowEventCreatePayload'
  /** A status which is true if no errors were encountered when creating/processing the workflow event */
  success: Scalars['True']
}

/** Autogenerated return type of CatalogWorkflowSubmit */
export type CatalogWorkflowSubmitPayload = {
  __typename?: 'CatalogWorkflowSubmitPayload'
  /** Whether the submission succeeded or not */
  success: Scalars['Boolean']
}

export enum CategorySurfaceType {
  AlcoholSurface = 'ALCOHOL_SURFACE',
  RetailerRecommendation = 'RETAILER_RECOMMENDATION',
}

export enum ChangesetProductStatusEnum {
  /** This changeset product has all the necessary information for submission */
  CompletedInfo = 'COMPLETED_INFO',
  /** This changeset product is missing some details that are required for submission */
  MissingInfo = 'MISSING_INFO',
}

export type ClassificationInfoInput = {
  /** The associated code (Could be a UPC - '034000170388', PLU - '1147', or In-House 'AB008') */
  code: Scalars['String']
  /** The type of classified code (universal, commodity, in-house, ...) */
  type: ClassifiedTypeEnum
  /** The id for the associated retailer (for in-house products) */
  retailerId?: Maybe<Scalars['ID']>
}

export enum ClassifiedTypeEnum {
  /** A universal product (standard product with a UPC) */
  Universal = 'UNIVERSAL',
  /** A commodity (bananas, apples, ...) */
  Commodity = 'COMMODITY',
  /** A product that is specific to a retailer (not universal) */
  InHouse = 'IN_HOUSE',
  /** The classification type is not known */
  Unknown = 'UNKNOWN',
}

export type ClientVisibilityCondition = {
  __typename?: 'ClientVisibilityCondition'
  timeOfDay: Maybe<TimeOfDay>
  matchesAnyRetailerId: Maybe<MatchesAnyRetailerId>
  anyRetailerEtaAvailable: Maybe<AnyRetailerEtaAvailable>
}

export type ClientVisibilityConditionInput = {
  timeOfDay?: Maybe<TimeOfDayInput>
  matchesAnyRetailerId?: Maybe<MatchesAnyRetailerIdInput>
  anyRetailerEtaAvailable?: Maybe<AnyRetailerEtaAvailableInput>
}

/** Attributes for creating a code lookup */
export type CodeLookupDataInput = {
  /** The lookup code of the product */
  code: Scalars['String']
  /** The lookup type (e.g., upc, rrc) for search */
  codeLookupType?: Maybe<CodeLookupTypeEnum>
  /** The retailer ID for code lookup */
  retailerId?: Maybe<Scalars['ID']>
  /** The locale code for the code lookup */
  localeCode?: Maybe<Scalars['String']>
}

export enum CodeLookupStateEnum {
  /** A brand new CodeLookup which hasn't been processed yet (no product_ids have been fetched) */
  Pending = 'PENDING',
  /** The CodeLookup is being processed (we are fetching the associated product_ids) */
  InProgress = 'IN_PROGRESS',
  /** The CodeLookup was processed successfully, returning zero or more product_ids */
  Completed = 'COMPLETED',
  /** Something went wrong when trying to fetch the associated product_ids for the CodeLookup */
  Failed = 'FAILED',
}

export enum CodeLookupStatusEnum {
  /** We haven't tried to match this code lookup yet, so we don't know the match status */
  Pending = 'PENDING',
  /** There was exactly one product matching the provided lookup code */
  PerfectMatch = 'PERFECT_MATCH',
  /** There was not exactly one product matching the provided lookup code (either 0 or 2+ items were found) */
  Unmatched = 'UNMATCHED',
}

export enum CodeLookupTypeEnum {
  /** A UPC code */
  Upc = 'UPC',
  /** A RRC code */
  Rrc = 'RRC',
}

export enum CollectionContentTypeEnum {
  /** Collection contains other child collections */
  Collections = 'COLLECTIONS',
  /** Collection contains subjects */
  Rules = 'RULES',
}

/** Autogenerated return type of CollectionCreate */
export type CollectionCreatePayload = {
  __typename?: 'CollectionCreatePayload'
  /** The newly created collection */
  collection: CollectionsCollection
}

/** Autogenerated return type of CollectionDelete */
export type CollectionDeletePayload = {
  __typename?: 'CollectionDeletePayload'
  /** Boolean response that the collection was deleted */
  response: Scalars['Boolean']
}

export type CollectionHeaderInput = {
  /** Title of the collection header */
  title?: Maybe<Scalars['String']>
  /** Description of the collection header */
  description?: Maybe<Scalars['String']>
  /** Display style */
  displayStyle?: Maybe<Scalars['String']>
  /** Hex color for header text */
  color?: Maybe<Scalars['String']>
  /** Hex color for header background */
  backgroundColor?: Maybe<Scalars['String']>
  /** Header image web */
  imageWeb?: Maybe<Scalars['String']>
  /** Header image mobile */
  imageMobile?: Maybe<Scalars['String']>
}

export type CollectionsCollection = {
  __typename?: 'CollectionsCollection'
  /** Whether or not the collection is active */
  active: Scalars['Boolean']
  /** Whether or not the collection is active only for internal admins */
  activeAdminOnly: Scalars['Boolean']
  /** Whether the collection can be edited by the current user */
  canEdit: Scalars['Boolean']
  /** Children collections of the collection */
  children: Maybe<Array<CollectionsCollection>>
  /** Type of collection */
  collectionType: Maybe<CollectionTypeEnum>
  /** End date of collection */
  endDate: Maybe<Scalars['Time']>
  /** Header for the collection */
  header: Maybe<CollectionsHeader>
  /** A unique identifier for the collection */
  id: Scalars['ID']
  /** Path of the collection image */
  imagePath: Maybe<Scalars['String']>
  /** URL of the collection image */
  imageUrl: Maybe<Scalars['String']>
  /** The name of the collection */
  name: Maybe<Scalars['String']>
  /** A unique identifier for the parent collection */
  parentId: Maybe<Scalars['ID']>
  /** Whitelisted retailers for this collection */
  requiredRetailerIds: Maybe<Array<Scalars['ID']>>
  /** The slug of the collection */
  slug: Maybe<Scalars['String']>
  /** Start date of collection */
  startDate: Maybe<Scalars['Time']>
  /** Storefront banner for the collection */
  storefrontBanner: Maybe<CollectionsStorefrontBanner>
  /** Rules for the collection */
  subjects: Maybe<Array<CollectionsSubject>>
}

/** The connection type for CollectionsCollection. */
export type CollectionsCollectionConnection = {
  __typename?: 'CollectionsCollectionConnection'
  /** A list of edges. */
  edges: Maybe<Array<Maybe<CollectionsCollectionEdge>>>
  /** Metadata regarding the connection */
  meta: ConnectionMeta
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<CollectionsCollection>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type CollectionsCollectionEdge = {
  __typename?: 'CollectionsCollectionEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: Maybe<CollectionsCollection>
}

export type CollectionsHeader = {
  __typename?: 'CollectionsHeader'
  /** Color hex value of the header background */
  backgroundColor: Maybe<Scalars['String']>
  /** Collection id associated to the header */
  collectionId: Scalars['ID']
  /** Color hex value of the header */
  color: Maybe<Scalars['String']>
  /** Description of the header */
  description: Maybe<Scalars['String']>
  /** Display style of the header */
  displayStyle: Maybe<Scalars['String']>
  /** A unique identifier for the header */
  id: Scalars['ID']
  /** Image url of the header */
  imageUrl: Maybe<Scalars['String']>
  /** Mobile image url of the header */
  mobileImageUrl: Maybe<Scalars['String']>
  /** Title of the header */
  title: Scalars['String']
}

export type CollectionsStorefrontBanner = {
  __typename?: 'CollectionsStorefrontBanner'
  /** Whether the banner is active */
  active: Maybe<Scalars['Boolean']>
  /** Background color of the storefront banner */
  backgroundColor: Maybe<Scalars['String']>
  /** Collection id associated to the header */
  collectionId: Scalars['ID']
  /** CTA of the storefront banner */
  cta: Maybe<Scalars['String']>
  /** Heading content of the storefront banner */
  heading: Maybe<Scalars['String']>
  /** Hex value heading color of the storefront banner */
  headingColor: Maybe<Scalars['String']>
  /** A unique identifier for the header */
  id: Scalars['ID']
  /** Image url of the storefront banner */
  image: Maybe<Scalars['String']>
  /** Sub heading content of the storefront banner */
  subHeading: Maybe<Scalars['String']>
  /** Sub heading color of the storefront banner */
  subHeadingColor: Maybe<Scalars['String']>
  /** Tag of the storefront banner */
  tag: Maybe<Scalars['String']>
  /** Tag color of the storefront banner */
  tagColor: Maybe<Scalars['String']>
}

export type CollectionsSubject = {
  __typename?: 'CollectionsSubject'
  /** The id of the collection the subject belongs to */
  collectionId: Scalars['ID']
  /** Filter for on sale items if true */
  criteriaOnSale: Maybe<Scalars['Boolean']>
  /** List of product ids for the subject */
  criteriaProductIds: Maybe<Array<Scalars['ID']>>
  /** List of search terms for the subject */
  criteriaTerms: Maybe<Array<Scalars['String']>>
  /** A unique identifier for the subject */
  id: Maybe<Scalars['ID']>
  /** L1 Product Category IDs */
  l1CategoryId: Maybe<Array<Scalars['ID']>>
  /** L2 Product Category IDs */
  l2CategoryId: Maybe<Array<Scalars['ID']>>
  /** L3 Product Category IDs */
  l3CategoryId: Maybe<Array<Scalars['ID']>>
  /** L4 Product Category IDs */
  l4CategoryId: Maybe<Array<Scalars['ID']>>
  /** L5 Product Category IDs */
  l5CategoryId: Maybe<Array<Scalars['ID']>>
  /** L6 Product Category IDs */
  l6CategoryId: Maybe<Array<Scalars['ID']>>
  /** Name of the subject */
  subjectName: Scalars['String']
}

export type CollectionStorefrontBannerInput = {
  /** Background color of the storefront banner */
  backgroundColor?: Maybe<Scalars['String']>
  /** CTA of the storefront banner */
  cta: Scalars['String']
  /** Heading of the storefront banner */
  heading: Scalars['String']
  /** Hex value for the heading color of the storefront banner */
  headingColor: Scalars['String']
  /** Image reference path of the storefront banner */
  image: Scalars['String']
  /** Sub heading of the storefront banner */
  subHeading: Scalars['String']
  /** Sub heading hex color value of the storefront banner */
  subHeadingColor: Scalars['String']
  /** Tag for the storefront banner */
  tag?: Maybe<Scalars['String']>
  /** Hex color value for the tag of the storefront banner */
  tagColor?: Maybe<Scalars['String']>
  /** Whether the storefront banner is active or not */
  active: Scalars['Boolean']
}

export type CollectionSubjectInput = {
  /** Id of the subject when updating */
  subjectId?: Maybe<Scalars['ID']>
  /** Name of the subject */
  subjectName: Scalars['String']
  /** Product ids to add to the collection */
  criteriaProductIds?: Maybe<Array<Scalars['ID']>>
  /** Search term criteria to add to the collection */
  criteriaTerms?: Maybe<Array<Scalars['String']>>
  /** Filter for on sale items */
  criteriaOnSale?: Maybe<Scalars['Boolean']>
}

export enum CollectionTypeEnum {
  /** DESCRIPTION TODO */
  Holiday = 'HOLIDAY',
  /** DESCRIPTION TODO */
  Department = 'DEPARTMENT',
  /** DESCRIPTION TODO */
  Explore = 'EXPLORE',
  /** DESCRIPTION TODO */
  CardList = 'CARD_LIST',
  /** DESCRIPTION TODO */
  Dynamic = 'DYNAMIC',
}

/** Autogenerated return type of CollectionUpdate */
export type CollectionUpdatePayload = {
  __typename?: 'CollectionUpdatePayload'
  /** The updated collection */
  collection: CollectionsCollection
}

export type ConfigurableButtonInput = {
  /** The button style to use */
  styleVariant?: Maybe<ButtonVariantEnum>
  /** The button text */
  label: Scalars['String']
  /** Color of the button text */
  color?: Maybe<Scalars['String']>
  /** Background color of the button */
  backgroundColor?: Maybe<Scalars['String']>
}

export type ConfigurableTextInput = {
  /** The color of the text (Eg. #FFFFFF) */
  color: Scalars['String']
  /** The text to display */
  text: Scalars['String']
}

export type ConnectionMeta = {
  __typename?: 'ConnectionMeta'
  /** The total number of connection elements */
  totalCount: Scalars['Int']
}

export type ContentManagementAnnouncementBannerGenericImages = {
  __typename?: 'ContentManagementAnnouncementBannerGenericImages'
  /** The foreground image url in the placement to be used on desktop clients */
  desktop: Maybe<Scalars['Url']>
  /** The foreground image url in the placement to be used on mobile clients */
  mobile: Scalars['Url']
}

export type ContentManagementAnnouncementBannerImageForwardImages = {
  __typename?: 'ContentManagementAnnouncementBannerImageForwardImages'
  /** The foreground image url in the placement to be used on desktop clients */
  desktop: Scalars['Url']
  /** The foreground image url in the placement to be used on mobile clients */
  mobile: Scalars['Url']
}

export type ContentManagementAnnouncementBannerTextWithThumbnailImages = {
  __typename?: 'ContentManagementAnnouncementBannerTextWithThumbnailImages'
  /** The background image url of the placement */
  background: Scalars['Url']
  /** The image url of the placement to display for the logo image */
  logo: Scalars['Url']
}

export type ContentManagementConfigurableButton = {
  __typename?: 'ContentManagementConfigurableButton'
  /** The background color of the button (Eg. #FFFFFF) */
  backgroundColor: Maybe<Scalars['String']>
  /** Color of the button text (Eg. #000000) */
  color: Maybe<Scalars['String']>
  /** The button text */
  label: Scalars['String']
  /** The button style to use */
  styleVariant: ButtonVariantEnum
}

export type ContentManagementConfigurableText = {
  __typename?: 'ContentManagementConfigurableText'
  /** The color of the text (Eg. #FFFFFF) */
  color: Scalars['String']
  /** The text to display */
  text: Maybe<Scalars['String']>
}

export type ContentManagementHeroBannerPlacement = {
  __typename?: 'ContentManagementHeroBannerPlacement'
  /** The color of the background for text images (Eg. #FFFFFF) */
  backgroundColor: Maybe<Scalars['String']>
  /** A unique identifier of the banner associated with the placement */
  bannerId: Maybe<Scalars['ID']>
  /** The style and text of the button within the placement */
  button: Maybe<ContentManagementConfigurableButton>
  /** When the placement was created */
  createdAt: Scalars['Time']
  /** Where interacting with the placement leads */
  destination: Maybe<ContentManagementPlacementDestination>
  /** If the placement is enabled */
  enabled: Scalars['Boolean']
  /** Experiment associated with the placement */
  experiment: Maybe<ContentManagementPlacementExperiment>
  /** The style and text of the heading */
  headingText: ContentManagementConfigurableText
  /** A unique identifier for the placement */
  id: Scalars['ID']
  /** The possible images to display */
  images: ContentManagementAnnouncementBannerGenericImages
  /** The name of the placement */
  name: Scalars['String']
  /** The platform which this placement should be displayed */
  platform: Array<PlacementPlatformEnum>
  /** The priority rank of the placement */
  rank: Scalars['Int']
  /** When the placement begins and ends */
  scheduling: ContentManagementPlacementSchedule
  /** The current status of the placement */
  status: PlacementStatusEnum
  /** The style and text of the subheading */
  subheadingText: ContentManagementConfigurableText
  /** The color of the text area (Eg. #FFFFFF) */
  textareaColor: Maybe<Scalars['String']>
  /** The type of this placement */
  type: PlacementTypeEnum
  /** When the placement was last edited */
  updatedAt: Scalars['Time']
}

export type ContentManagementImageForwardFlexPlacement = {
  __typename?: 'ContentManagementImageForwardFlexPlacement'
  /** The color of the background for text images (Eg. #FFFFFF) */
  backgroundColor: Maybe<Scalars['String']>
  /** A unique identifier of the banner associated with the placement */
  bannerId: Maybe<Scalars['ID']>
  /** The style and text of the button within the placement */
  button: Maybe<ContentManagementConfigurableButton>
  /** When the placement was created */
  createdAt: Scalars['Time']
  /** Where interacting with the placement leads */
  destination: Maybe<ContentManagementPlacementDestination>
  /** If the placement is enabled */
  enabled: Scalars['Boolean']
  /** Experiment associated with the placement */
  experiment: Maybe<ContentManagementPlacementExperiment>
  /** The style and text of the heading */
  headingText: ContentManagementConfigurableText
  /** A unique identifier for the placement */
  id: Scalars['ID']
  /** The possible images to display */
  images: ContentManagementAnnouncementBannerImageForwardImages
  /** The name of the placement */
  name: Scalars['String']
  /** The platform which this placement should be displayed */
  platform: Array<PlacementPlatformEnum>
  /** The priority rank of the placement */
  rank: Scalars['Int']
  /** When the placement begins and ends */
  scheduling: ContentManagementPlacementSchedule
  /** The current status of the placement */
  status: PlacementStatusEnum
  /** The style and text of the subheading */
  subheadingText: ContentManagementConfigurableText
  /** The type of this placement */
  type: PlacementTypeEnum
  /** When the placement was last edited */
  updatedAt: Scalars['Time']
}

export type ContentManagementImageForwardPlacement = {
  __typename?: 'ContentManagementImageForwardPlacement'
  /** The color of the background for text images (Eg. #FFFFFF) */
  backgroundColor: Maybe<Scalars['String']>
  /** A unique identifier of the banner associated with the placement */
  bannerId: Maybe<Scalars['ID']>
  /** The style and text of the button within the placement */
  button: Maybe<ContentManagementConfigurableButton>
  /** When the placement was created */
  createdAt: Scalars['Time']
  /** Where interacting with the placement leads */
  destination: Maybe<ContentManagementPlacementDestination>
  /** If the placement is enabled */
  enabled: Scalars['Boolean']
  /** Experiment associated with the placement */
  experiment: Maybe<ContentManagementPlacementExperiment>
  /** The style and text of the heading */
  headingText: ContentManagementConfigurableText
  /** A unique identifier for the placement */
  id: Scalars['ID']
  /** The possible images to display */
  images: ContentManagementAnnouncementBannerImageForwardImages
  /** The name of the placement */
  name: Scalars['String']
  /** The platform which this placement should be displayed */
  platform: Array<PlacementPlatformEnum>
  /** The priority rank of the placement */
  rank: Scalars['Int']
  /** When the placement begins and ends */
  scheduling: ContentManagementPlacementSchedule
  /** The current status of the placement */
  status: PlacementStatusEnum
  /** The style and text of the subheading */
  subheadingText: ContentManagementConfigurableText
  /** The type of this placement */
  type: PlacementTypeEnum
  /** When the placement was last edited */
  updatedAt: Scalars['Time']
}

export type ContentManagementPbiConfiguration = {
  __typename?: 'ContentManagementPbiConfiguration'
  /** The url for the retailer's pbi instance */
  domainName: Scalars['String']
  /** The unique slug for the retailer */
  slug: Scalars['String']
}

export type ContentManagementPlacementDestination = {
  __typename?: 'ContentManagementPlacementDestination'
  /** The human readable value of the target */
  displayValue: Maybe<Scalars['String']>
  /** The target destination of interacting with the placement. Can be an ID of a product/collection/department, or a URL */
  target: Scalars['String']
  /** What the corresponding target refers to */
  type: PlacementDestinationTypeEnum
}

export type ContentManagementPlacementExperiment = {
  __typename?: 'ContentManagementPlacementExperiment'
  /** Experiment Assignment or Lookup */
  accessMethod: Maybe<PlacementExperimentMethodEnum>
  /** Name of the Experiment */
  name: Maybe<Scalars['String']>
  /** Variant of the Experiment for which placement should be visible */
  variant: Maybe<Scalars['String']>
}

export type ContentManagementPlacementImages = {
  __typename?: 'ContentManagementPlacementImages'
  /** The image url of the placement to display for large viewports */
  large: Scalars['Url']
  /** The image url of the placement to display for small viewports */
  small: Scalars['Url']
}

export type ContentManagementPlacementSchedule = {
  __typename?: 'ContentManagementPlacementSchedule'
  /** When the placement should stop being active */
  endDate: Maybe<Scalars['Time']>
  /** When the placement should become active */
  startDate: Scalars['Time']
  /** The timezone in which the banner will stop being active at midnight */
  timezone: Maybe<Scalars['String']>
}

export type ContentManagementSecondaryBannerPlacement = {
  __typename?: 'ContentManagementSecondaryBannerPlacement'
  /** The color of the background for text images (Eg. #FFFFFF) */
  backgroundColor: Maybe<Scalars['String']>
  /** A unique identifier of the banner associated with the placement */
  bannerId: Maybe<Scalars['ID']>
  /** The style and text of the button within the placement */
  button: Maybe<ContentManagementConfigurableButton>
  /** When the placement was created */
  createdAt: Scalars['Time']
  /** Where interacting with the placement leads */
  destination: Maybe<ContentManagementPlacementDestination>
  /** If the placement is enabled */
  enabled: Scalars['Boolean']
  /** Experiment associated with the placement */
  experiment: Maybe<ContentManagementPlacementExperiment>
  /** The style and text of the heading */
  headingText: ContentManagementConfigurableText
  /** A unique identifier for the placement */
  id: Scalars['ID']
  /** The possible images to display */
  images: ContentManagementAnnouncementBannerGenericImages
  /** The name of the placement */
  name: Scalars['String']
  /** The platform which this placement should be displayed */
  platform: Array<PlacementPlatformEnum>
  /** The priority rank of the placement */
  rank: Scalars['Int']
  /** When the placement begins and ends */
  scheduling: ContentManagementPlacementSchedule
  /** The style and text of the secondary text */
  secondaryText: Maybe<ContentManagementConfigurableText>
  /** The current status of the placement */
  status: PlacementStatusEnum
  /** The style and text of the subheading */
  subheadingText: ContentManagementConfigurableText
  /** The type of this placement */
  type: PlacementTypeEnum
  /** When the placement was last edited */
  updatedAt: Scalars['Time']
}

export type ContentManagementStorefrontPlacement = {
  __typename?: 'ContentManagementStorefrontPlacement'
  /** The color of the background for text images (Eg. #FFFFFF) */
  backgroundColor: Maybe<Scalars['String']>
  /** A unique identifier of the banner associated with the placement */
  bannerId: Maybe<Scalars['ID']>
  /** The banners configured to the placement */
  banners: Array<ContentManagementStorefrontPlacementBanner>
  /** The style and text of the button within the placement */
  button: Maybe<ContentManagementConfigurableButton>
  /** When the placement was created */
  createdAt: Scalars['Time']
  /** The style and text of the description */
  descriptionText: ContentManagementConfigurableText
  /** Where interacting with the placement leads */
  destination: Maybe<ContentManagementPlacementDestination>
  /** Whether or not the placement can be dismissed */
  dismissable: Scalars['Boolean']
  /** The style and text of the heading */
  headingText: ContentManagementConfigurableText
  /** A unique identifier for the placement */
  id: Scalars['ID']
  /** the alt text for the placement images */
  imageAltText: Scalars['String']
  /** The possible placement images to display */
  images: ContentManagementPlacementImages
  /** The name of the placement */
  name: Scalars['String']
  /** The platform which this placement should be displayed */
  platform: Array<PlacementPlatformEnum>
  /** A unique identifier for the retailer */
  retailerId: Scalars['ID']
  /** When the placement begins and ends */
  scheduling: ContentManagementPlacementSchedule
  /** The current status of the placement */
  status: PlacementStatusEnum
  /** The style and text of the subheading */
  subheadingText: ContentManagementConfigurableText
  /** The type of this placement */
  type: PlacementTypeEnum
  /** When the placement was last edited */
  updatedAt: Scalars['Time']
}

export type ContentManagementStorefrontPlacementBanner = {
  __typename?: 'ContentManagementStorefrontPlacementBanner'
  /** The color of the background for text placements (Eg. #FFFFFF) */
  backgroundColor: Maybe<Scalars['String']>
  /** The style and text of the button within the placement */
  button: Maybe<ContentManagementConfigurableButton>
  /** The style and text of the description */
  descriptionText: ContentManagementConfigurableText
  /** The style and text of the heading */
  headingText: ContentManagementConfigurableText
  /** A unique identifier of the banner associated with the placement */
  id: Maybe<Scalars['ID']>
  /** the alt text for the placement images */
  imageAltText: Scalars['String']
  /** The possible placement images to display */
  images: ContentManagementPlacementImages
  /** The banner's locale */
  locale: Maybe<BannerLocaleEnum>
  /** The style and text of the subheading */
  subheadingText: ContentManagementConfigurableText
}

/** The connection type for ContentManagementStorefrontPlacement. */
export type ContentManagementStorefrontPlacementConnection = {
  __typename?: 'ContentManagementStorefrontPlacementConnection'
  /** A list of edges. */
  edges: Maybe<Array<Maybe<ContentManagementStorefrontPlacementEdge>>>
  /** Metadata regarding the connection */
  meta: ConnectionMeta
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<ContentManagementStorefrontPlacement>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type ContentManagementStorefrontPlacementEdge = {
  __typename?: 'ContentManagementStorefrontPlacementEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: Maybe<ContentManagementStorefrontPlacement>
}

export type ContentManagementTextWithThumbnailFlexPlacement = {
  __typename?: 'ContentManagementTextWithThumbnailFlexPlacement'
  /** The color of the background for text images (Eg. #FFFFFF) */
  backgroundColor: Maybe<Scalars['String']>
  /** A unique identifier of the banner associated with the placement */
  bannerId: Maybe<Scalars['ID']>
  /** The style and text of the button within the placement */
  button: Maybe<ContentManagementConfigurableButton>
  /** When the placement was created */
  createdAt: Scalars['Time']
  /** Where interacting with the placement leads */
  destination: Maybe<ContentManagementPlacementDestination>
  /** If the placement is enabled */
  enabled: Scalars['Boolean']
  /** Experiment associated with the placement */
  experiment: Maybe<ContentManagementPlacementExperiment>
  /** The style and text of the heading */
  headingText: ContentManagementConfigurableText
  /** A unique identifier for the placement */
  id: Scalars['ID']
  /** The possible images to display */
  images: ContentManagementAnnouncementBannerTextWithThumbnailImages
  /** The name of the placement */
  name: Scalars['String']
  /** The platform which this placement should be displayed */
  platform: Array<PlacementPlatformEnum>
  /** The priority rank of the placement */
  rank: Scalars['Int']
  /** When the placement begins and ends */
  scheduling: ContentManagementPlacementSchedule
  /** The current status of the placement */
  status: PlacementStatusEnum
  /** The style and text of the subheading */
  subheadingText: ContentManagementConfigurableText
  /** The type of this placement */
  type: PlacementTypeEnum
  /** When the placement was last edited */
  updatedAt: Scalars['Time']
}

export type ContentManagementTextWithThumbnailPlacement = {
  __typename?: 'ContentManagementTextWithThumbnailPlacement'
  /** The color of the background for text images (Eg. #FFFFFF) */
  backgroundColor: Maybe<Scalars['String']>
  /** A unique identifier of the banner associated with the placement */
  bannerId: Maybe<Scalars['ID']>
  /** The style and text of the button within the placement */
  button: Maybe<ContentManagementConfigurableButton>
  /** When the placement was created */
  createdAt: Scalars['Time']
  /** Where interacting with the placement leads */
  destination: Maybe<ContentManagementPlacementDestination>
  /** If the placement is enabled */
  enabled: Scalars['Boolean']
  /** Experiment associated with the placement */
  experiment: Maybe<ContentManagementPlacementExperiment>
  /** The style and text of the heading */
  headingText: ContentManagementConfigurableText
  /** A unique identifier for the placement */
  id: Scalars['ID']
  /** The possible images to display */
  images: ContentManagementAnnouncementBannerTextWithThumbnailImages
  /** The name of the placement */
  name: Scalars['String']
  /** The platform which this placement should be displayed */
  platform: Array<PlacementPlatformEnum>
  /** The priority rank of the placement */
  rank: Scalars['Int']
  /** When the placement begins and ends */
  scheduling: ContentManagementPlacementSchedule
  /** The current status of the placement */
  status: PlacementStatusEnum
  /** The style and text of the subheading */
  subheadingText: ContentManagementConfigurableText
  /** The type of this placement */
  type: PlacementTypeEnum
  /** When the placement was last edited */
  updatedAt: Scalars['Time']
}

export type ContentManagementUnknownBannerPlacement = {
  __typename?: 'ContentManagementUnknownBannerPlacement'
  /** When the placement was created */
  createdAt: Scalars['Time']
  /** If the placement is enabled */
  enabled: Scalars['Boolean']
  /** Experiment associated with the placement */
  experiment: Maybe<ContentManagementPlacementExperiment>
  /** A unique identifier for the placement */
  id: Scalars['ID']
  /** The name of the placement */
  name: Scalars['String']
  /** The platform which this placement should be displayed */
  platform: Array<PlacementPlatformEnum>
  /** The priority rank of the placement */
  rank: Scalars['Int']
  /** When the placement begins and ends */
  scheduling: ContentManagementPlacementSchedule
  /** The current status of the placement */
  status: PlacementStatusEnum
  /** The type of this placement */
  type: PlacementTypeEnum
  /** When the placement was last edited */
  updatedAt: Scalars['Time']
}

export type ContentManagementVisibilityConditionDayOfWeek = {
  __typename?: 'ContentManagementVisibilityConditionDayOfWeek'
  /** list of days within the week */
  days: Array<Scalars['String']>
  /** A unique identifier for the visibility condition */
  id: Scalars['ID']
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID']
}

export type ContentManagementVisibilityConditionExpressMembership = {
  __typename?: 'ContentManagementVisibilityConditionExpressMembership'
  /** A unique identifier for the visibility condition */
  id: Scalars['ID']
  /** Whether the user should be an express member */
  membershipStatus: Scalars['Boolean']
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Maybe<Scalars['ID']>
}

export type ContentManagementVisibilityConditionExpressNonmemberLongTermHoldout = {
  __typename?: 'ContentManagementVisibilityConditionExpressNonmemberLongTermHoldout'
  /** A unique identifier for the visibility condition */
  id: Scalars['ID']
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Maybe<Scalars['ID']>
}

export type ContentManagementVisibilityConditionMinimumPlatformVersion = {
  __typename?: 'ContentManagementVisibilityConditionMinimumPlatformVersion'
  /** A unique identifier for the visibility condition */
  id: Scalars['ID']
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID']
  /** The platform the version is being checked for */
  platform: PlacementPlatformEnum
  /** Version used for the check */
  version: Scalars['String']
}

export type ContentManagementVisibilityConditionShopped = {
  __typename?: 'ContentManagementVisibilityConditionShopped'
  /** Id of the country where the check is to be performed */
  countryId: Scalars['Int']
  /** Whether the user should have shopped at the retailer */
  hasShopped: Scalars['Boolean']
  /** A unique identifier for the visibility condition */
  id: Scalars['ID']
  /** Number of days in the past to check */
  numberOfDays: Scalars['Int']
  /** Number of times in the past to check */
  numberOfTimes: Scalars['Int']
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID']
  /** Id of the store configuraiton for which the check is to be performed */
  storeConfigurationId: Scalars['Int']
}

export type ContentManagementVisibilityConditionShoppedAtRetailer = {
  __typename?: 'ContentManagementVisibilityConditionShoppedAtRetailer'
  /** Id of the country where the check is to be performed */
  countryId: Scalars['Int']
  /** Whether the user should have shopped at the retailer */
  hasShopped: Scalars['Boolean']
  /** A unique identifier for the visibility condition */
  id: Scalars['ID']
  /** Number of days in the past to check */
  numberOfDays: Scalars['Int']
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID']
  /** Id of the Retailer */
  retailerId: Scalars['Int']
  /** Id of the store configuraiton for which the check is to be performed */
  storeConfigurationId: Scalars['Int']
}

export type ContentManagementVisibilityConditionUnknownVisibilityCondition = {
  __typename?: 'ContentManagementVisibilityConditionUnknownVisibilityCondition'
  /** A unique identifier for the visibility condition */
  id: Scalars['ID']
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID']
}

export type ContentManagementVisibilityConditionWhitelistedPostalCodes = {
  __typename?: 'ContentManagementVisibilityConditionWhitelistedPostalCodes'
  /** A unique identifier for the visibility condition */
  id: Scalars['ID']
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID']
  /** List of postal codes */
  postalCodes: Array<Scalars['String']>
}

export enum CostUnitEnum {
  /** The `each` cost unit */
  Each = 'EACH',
  /** The `lb` cost unit */
  Pound = 'POUND',
  /** The `kg` cost unit */
  Kilogram = 'KILOGRAM',
}

export type CreateLastmileOrderFromDashboardRequestInput = {
  requestContext?: Maybe<InstacartTypesV1RequestContextInput>
  order?: Maybe<InstacartEnterpriseBobaCoreTypesV1LastMileOrderDashboardCreationParamsInput>
  partnerId?: Maybe<Scalars['BigInt']>
  retailerId?: Maybe<Scalars['BigInt']>
  modificationEvent?: Maybe<InstacartEnterpriseBobaCoreTypesV1ModificationEventInput>
}

export type CreateLastmileOrderFromDashboardResponse = {
  __typename?: 'CreateLastmileOrderFromDashboardResponse'
  order: Maybe<InstacartEnterpriseBobaCoreTypesV1Order>
}

export type CreatePlacementRequestInput = {
  placement?: Maybe<PlacementInput>
}

export type CreatePlacementResponse = {
  __typename?: 'CreatePlacementResponse'
  placement: Maybe<Placement>
}

export type CreateValueBasedOverrideRequestInput = {
  valueBasedOverride?: Maybe<ValueBasedOverrideRequestInput>
}

export type CreateValueBasedOverrideResponse = {
  __typename?: 'CreateValueBasedOverrideResponse'
  valueBasedOverride: Maybe<ValueBasedOverrideResponse>
}

export type CustomersContext = {
  __typename?: 'CustomersContext'
  storeConfigurationId: Maybe<Scalars['Int']>
  clientConfigurationId: Maybe<Scalars['Int']>
  countryId: Maybe<Scalars['Int']>
}

/** Attributes for a date range filter */
export type DateRange = {
  /** Start date of date range */
  startDate: Scalars['ISO8601Date']
  /** End date of date range */
  endDate: Scalars['ISO8601Date']
}

export type DateRangeInput = {
  fromDate?: Maybe<Scalars['DateTime']>
  toDate?: Maybe<Scalars['DateTime']>
  from?: Maybe<Scalars['DateTime']>
  to?: Maybe<Scalars['DateTime']>
}

export type DateTimeRangeInput = {
  from?: Maybe<Scalars['DateTime']>
  to?: Maybe<Scalars['DateTime']>
}

export type DayOfWeekInput = {
  /** A unique identifier of the visibility condition */
  id?: Maybe<Scalars['ID']>
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID']
  /** list of days within the week */
  days: Array<Scalars['String']>
}

/** Autogenerated return type of DayOfWeekVisibilityConditionCreate */
export type DayOfWeekVisibilityConditionCreatePayload = {
  __typename?: 'DayOfWeekVisibilityConditionCreatePayload'
  /** The newly created express_membership visibility condition */
  dayOfWeekVisibilityCondition: ContentManagementVisibilityConditionDayOfWeek
}

/** Autogenerated return type of DayOfWeekVisibilityConditionUpdate */
export type DayOfWeekVisibilityConditionUpdatePayload = {
  __typename?: 'DayOfWeekVisibilityConditionUpdatePayload'
  /** The newly created shopped_at_retailer visibility condition */
  dayOfWeekVisibilityCondition: ContentManagementVisibilityConditionDayOfWeek
}

export type DeleteApiSettingRequestInput = {
  id?: Maybe<Scalars['BigInt']>
  partnerId?: Maybe<Scalars['BigInt']>
}

export type DeleteApiSettingResponse = {
  __typename?: 'DeleteApiSettingResponse'
  success: Maybe<Scalars['Boolean']>
}

export type DeleteImageRequestInput = {
  retailerLocationId?: Maybe<Scalars['BigInt']>
  imageId?: Maybe<Scalars['Int']>
}

export type DeleteImageResponse = {
  __typename?: 'DeleteImageResponse'
  _: Maybe<Scalars['Boolean']>
}

export type Department = {
  __typename?: 'Department'
  id: Maybe<Scalars['BigInt']>
  name: Maybe<Scalars['String']>
}

export enum DeviceTypeEnum {
  /** Phone plan */
  Phone = 'phone',
  /** Wi-Fi */
  Wifi = 'wifi',
}

export enum Direction {
  Asc = 'ASC',
  Desc = 'DESC',
}

export type DoNotNavigate = {
  __typename?: 'DoNotNavigate'
  recordClickAttempt: Maybe<Scalars['Boolean']>
}

export type DoNotNavigateInput = {
  recordClickAttempt?: Maybe<Scalars['Boolean']>
}

export type DownloadCatalogSearchResultsRequestInput = {
  requestProductData?: Maybe<Scalars['Boolean']>
  requestItemData?: Maybe<Scalars['Boolean']>
  productFilename?: Maybe<Scalars['String']>
  itemFilename?: Maybe<Scalars['String']>
  aisleIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>
  departmentIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>
  primaryImageUrl?: Maybe<Scalars['Boolean']>
  storeBrandProduct?: Maybe<Scalars['Boolean']>
  creationDate?: Maybe<DateRangeInput>
  productAvailability?: Maybe<Scalars['Boolean']>
  itemsOnSaleDateRange?: Maybe<DateRangeInput>
  itemsOnPromoDateRange?: Maybe<DateRangeInput>
  loyaltyPricing?: Maybe<Scalars['Boolean']>
  snapEbtEligible?: Maybe<Scalars['Boolean']>
  costUnitType?: Maybe<Array<Maybe<Scalars['String']>>>
  isParWeighted?: Maybe<Scalars['Boolean']>
  retailerReferenceCodes?: Maybe<Array<Maybe<Scalars['String']>>>
  productCodes?: Maybe<Array<Maybe<Scalars['String']>>>
  productIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>
  query?: Maybe<Scalars['String']>
  localeCode?: Maybe<InstacartCustomersSharedV1Locale>
  retailerId?: Maybe<Scalars['BigInt']>
  partnerId?: Maybe<Scalars['BigInt']>
}

export type DownloadCatalogSearchResultsResponse = {
  __typename?: 'DownloadCatalogSearchResultsResponse'
  filename: Maybe<Scalars['String']>
}

export type EnterpriseAccount = {
  __typename?: 'EnterpriseAccount'
  /** Whether or not the user is fully set up */
  accountStateValid: Maybe<Scalars['Boolean']>
  /** Whether account must use SSO/auth service for authentication */
  authServiceRequired: Scalars['Boolean']
  /** The associated authentication */
  authentication: Maybe<AuthenticationInterface>
  /** The external unique identifier for the enterprise account */
  canonicalId: Scalars['ID']
  /** When the account was created */
  createdAt: Scalars['Time']
  /** Whether account is active */
  disabled: Scalars['Boolean']
  /** The email associated with the account */
  email: Maybe<Scalars['String']>
  /** The flippers associated with the account */
  flippers: AccessControlFlippers
  /** Given name of user */
  givenName: Maybe<Scalars['String']>
  /** The internal unique identifier for the enterprise account */
  id: Scalars['ID']
  /** The associated internal access configuration for the account */
  internalAccessConfiguration: EnterpriseInternalAccessConfiguration
  /** Whether account is an internal account */
  isInternal: Scalars['Boolean']
  /** The permissions associated with this account */
  permissions: Array<EnterprisePermission>
  /** Phone number for the user */
  phone: Maybe<Scalars['String']>
  /** The policies associated with the account */
  policies: AccessControlPolicies
  /** The roles associated with this account */
  roles: Array<EnterpriseRole>
  /** Surname of user */
  surname: Maybe<Scalars['String']>
  /** The title of the user */
  title: Maybe<Scalars['String']>
}

/** Autogenerated return type of EnterpriseAccountAccountSetup */
export type EnterpriseAccountAccountSetupPayload = {
  __typename?: 'EnterpriseAccountAccountSetupPayload'
  /** The AuthenticationToken token to be used for future requests */
  accessToken: AccessToken
}

/** Autogenerated return type of EnterpriseAccountAuthenticateEmailPassword */
export type EnterpriseAccountAuthenticateEmailPasswordPayload = {
  __typename?: 'EnterpriseAccountAuthenticateEmailPasswordPayload'
  /** The AuthenticationToken token to be used for future requests */
  accessToken: AccessToken
}

/** Autogenerated return type of EnterpriseAccountAuthenticatePreflight */
export type EnterpriseAccountAuthenticatePreflightPayload = {
  __typename?: 'EnterpriseAccountAuthenticatePreflightPayload'
  useAuthService: Scalars['Boolean']
}

/** The connection type for EnterpriseAccount. */
export type EnterpriseAccountConnection = {
  __typename?: 'EnterpriseAccountConnection'
  /** A list of edges. */
  edges: Maybe<Array<Maybe<EnterpriseAccountEdge>>>
  /** Metadata regarding the connection */
  meta: ConnectionMeta
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<EnterpriseAccount>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** Autogenerated return type of EnterpriseAccountCreate */
export type EnterpriseAccountCreatePayload = {
  __typename?: 'EnterpriseAccountCreatePayload'
  /** The newly created account object */
  enterpriseAccount: EnterpriseAccount
}

/** An edge in a connection. */
export type EnterpriseAccountEdge = {
  __typename?: 'EnterpriseAccountEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: Maybe<EnterpriseAccount>
}

/** Autogenerated return type of EnterpriseAccountRequestAccountSetupEmail */
export type EnterpriseAccountRequestAccountSetupEmailPayload = {
  __typename?: 'EnterpriseAccountRequestAccountSetupEmailPayload'
  /** A status which is true if no errors were encountered */
  success: Scalars['True']
}

/** Autogenerated return type of EnterpriseAccountRequestEmailVerification */
export type EnterpriseAccountRequestEmailVerificationPayload = {
  __typename?: 'EnterpriseAccountRequestEmailVerificationPayload'
  /** A status which is true if no errors were encountered */
  success: Scalars['True']
}

/** Autogenerated return type of EnterpriseAccountRequestPasswordReset */
export type EnterpriseAccountRequestPasswordResetPayload = {
  __typename?: 'EnterpriseAccountRequestPasswordResetPayload'
  /** A status which is true if no errors were encountered */
  success: Scalars['True']
}

/** Autogenerated return type of EnterpriseAccountResetPassword */
export type EnterpriseAccountResetPasswordPayload = {
  __typename?: 'EnterpriseAccountResetPasswordPayload'
  /** The AuthenticationToken token to be used for future requests */
  accessToken: AccessToken
}

/** Autogenerated return type of EnterpriseAccountSetDisabled */
export type EnterpriseAccountSetDisabledPayload = {
  __typename?: 'EnterpriseAccountSetDisabledPayload'
  /** The updated account object */
  enterpriseAccount: EnterpriseAccount
}

/** Autogenerated return type of EnterpriseAccountSignUpEmailPassword */
export type EnterpriseAccountSignUpEmailPasswordPayload = {
  __typename?: 'EnterpriseAccountSignUpEmailPasswordPayload'
  /** The newly created Account */
  enterpriseAccount: EnterpriseAccount
}

/** Autogenerated return type of EnterpriseAccountUpdate */
export type EnterpriseAccountUpdatePayload = {
  __typename?: 'EnterpriseAccountUpdatePayload'
  /** The updated account object */
  enterpriseAccount: EnterpriseAccount
}

/** Autogenerated return type of EnterpriseAccountVerifyEmail */
export type EnterpriseAccountVerifyEmailPayload = {
  __typename?: 'EnterpriseAccountVerifyEmailPayload'
  /** The AuthenticationToken token to be used for future requests */
  accessToken: AccessToken
}

export type EnterpriseAuthenticationEmailPassword = AuthenticationInterface & {
  __typename?: 'EnterpriseAuthenticationEmailPassword'
  /** Unique authentication identifier */
  authenticationIdentifier: Scalars['ID']
  /** Whether or not the email has been verified */
  emailVerified: Scalars['Boolean']
  /** Whether or not the password has been set */
  passwordSet: Scalars['Boolean']
}

export type EnterpriseFeatureTour = {
  __typename?: 'EnterpriseFeatureTour'
  lastShownAt: Maybe<Scalars['String']>
  /** The name of the feature tour */
  name: Scalars['String']
  /** The current completion status of the feature tour */
  status: Scalars['String']
}

export type EnterpriseInternalAccessConfiguration = {
  __typename?: 'EnterpriseInternalAccessConfiguration'
  /** The associated assigned partners */
  assignedPartners: Array<Partner>
  /** The associated assigned retailer locations */
  assignedRetailerLocations: Array<RetailerLocation>
  /** The associated assigned retailers */
  assignedRetailers: Array<Retailer>
  /** Whether access is granted for every partner, retailer and location */
  hasAllPartnersFullAccess: Scalars['Boolean']
  /** Whether access is granted for every retailer and location for partners assigned */
  hasFullPartnerAccess: Scalars['Boolean']
  /** Whether access is granted for every location for retailers assigned */
  hasFullRetailerAccess: Scalars['Boolean']
  /** Whether access is not granted to any partner, retailer or location */
  hasNothingAccessible: Scalars['Boolean']
}

export type EnterprisePermission = {
  __typename?: 'EnterprisePermission'
  /** A description of the permission */
  description: Maybe<Scalars['String']>
  /** A unique identifier for the permission */
  slug: Scalars['ID']
}

export type EnterpriseRole = {
  __typename?: 'EnterpriseRole'
  /** A description of the role */
  description: Maybe<Scalars['String']>
  /** The role ID */
  id: Scalars['ID']
  /** Whether this role is managed internally or not */
  internallyManaged: Scalars['Boolean']
  /** The name of the role */
  name: Scalars['String']
  /** The permissions associated with this role */
  permissions: Array<EnterprisePermission>
  /** A unique identifier for the role */
  slug: Scalars['ID']
}

export type EnterpriseWelcomeModal = {
  __typename?: 'EnterpriseWelcomeModal'
  /** slug identifying type of welcome modal to be shown. */
  slug: Scalars['String']
}

export type EntityId = {
  __typename?: 'EntityId'
  retailerProductId: Maybe<RetailerProductId>
  productId: Maybe<ProductId>
  localeProduct: Maybe<LocaleProduct>
  productRetailerFileData: Maybe<ProductRetailerFileData>
}

export type EntityIdInput = {
  retailerProductId?: Maybe<RetailerProductIdInput>
  productId?: Maybe<ProductIdInput>
}

export type EqualFilterInput = {
  value?: Maybe<InsightsPortalValueInput>
}

export enum ExperimentMethod {
  ExperimentMethodUnspecified = 'EXPERIMENT_METHOD_UNSPECIFIED',
  Assign = 'ASSIGN',
  Lookup = 'LOOKUP',
  Preview = 'PREVIEW',
}

export type ExpressMembershipInput = {
  /** A unique identifier of the visibility condition */
  id?: Maybe<Scalars['ID']>
  /** A unique identifier of the placement associated with the visibility condition */
  placementId?: Maybe<Scalars['ID']>
  /** Whether the user should be an express member */
  membershipStatus: Scalars['Boolean']
}

/** Autogenerated return type of ExpressMembershipVisibilityConditionCreate */
export type ExpressMembershipVisibilityConditionCreatePayload = {
  __typename?: 'ExpressMembershipVisibilityConditionCreatePayload'
  /** The newly created express_membership visibility condition */
  expressMembershipVisibilityCondition: ContentManagementVisibilityConditionExpressMembership
}

/** Autogenerated return type of ExpressMembershipVisibilityConditionUpdate */
export type ExpressMembershipVisibilityConditionUpdatePayload = {
  __typename?: 'ExpressMembershipVisibilityConditionUpdatePayload'
  /** The newly created express_membership visibility condition */
  expressMembershipVisibilityCondition: ContentManagementVisibilityConditionExpressMembership
}

export type ExpressNonmemberLongTermHoldoutInput = {
  /** A unique identifier of the visibility condition */
  id?: Maybe<Scalars['ID']>
  /** A unique identifier of the placement associated with the visibility condition */
  placementId?: Maybe<Scalars['ID']>
}

/** Autogenerated return type of ExpressNonmemberLongTermHoldoutVisibilityConditionCreate */
export type ExpressNonmemberLongTermHoldoutVisibilityConditionCreatePayload = {
  __typename?: 'ExpressNonmemberLongTermHoldoutVisibilityConditionCreatePayload'
  /** The newly created ExpressNonmemberLongTermHoldout visibility condition */
  expressNonmemberLongTermHoldoutVisibilityCondition: ContentManagementVisibilityConditionExpressNonmemberLongTermHoldout
}

/** Autogenerated return type of FeatureTourUpdate */
export type FeatureTourUpdatePayload = {
  __typename?: 'FeatureTourUpdatePayload'
  /** A status which is true if no errors were encountered while performing the update */
  success: Scalars['True']
}

export type FilterOptions = {
  __typename?: 'FilterOptions'
  name: Maybe<Scalars['String']>
  options: Maybe<Array<Maybe<InsightsPortalFilterOption>>>
}

export type FilterSetInput = {
  query?: Maybe<Scalars['String']>
  fulfillmentDateRange?: Maybe<DateRangeInput>
  creationDateRange?: Maybe<DateRangeInput>
  retailerLocationId?: Maybe<Scalars['BigInt']>
  retailerId?: Maybe<Scalars['BigInt']>
  serviceType?: Maybe<InstacartCustomersSharedV1ServiceType>
  orderStatusCriteria?: Maybe<Array<Maybe<OrderStatusCriteria>>>
  retailerLocationIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>
}

export enum FilterType {
  Unknown = 'UNKNOWN',
  Equal = 'EQUAL',
  Between = 'BETWEEN',
  In = 'IN',
}

export enum FulfillmentModelEnum {
  /** Partner managed */
  Retailer = 'RETAILER',
  /** Locker */
  Locker = 'LOCKER',
  /** In store shoppers */
  Iss = 'ISS',
}

export type GenericImagesInput = {
  /** The image url of the placement to display for small viewports */
  mobile: Scalars['Url']
  /** The image url of the placement to display for large viewports */
  desktop?: Maybe<Scalars['Url']>
}

export type GetApiSettingsRequestInput = {
  partnerId?: Maybe<Scalars['BigInt']>
  retailerId?: Maybe<Scalars['BigInt']>
  apiType?: Maybe<Scalars['String']>
  integrationType?: Maybe<Scalars['String']>
  enabled?: Maybe<Scalars['Boolean']>
}

export type GetApiSettingsResponse = {
  __typename?: 'GetApiSettingsResponse'
  apiSettings: Maybe<Array<Maybe<ApiSetting>>>
}

export type GetAuditBatchRequestInput = {
  client?: Maybe<Scalars['String']>
  batchUuid?: Maybe<Scalars['String']>
  returnSampleTasks?: Maybe<Scalars['Boolean']>
  page?: Maybe<PaginationInput>
}

export type GetAuditBatchResponse = {
  __typename?: 'GetAuditBatchResponse'
  auditBatch: Maybe<AuditBatch>
}

export type GetAuditTaskRequestInput = {
  client?: Maybe<Scalars['String']>
  taskUuid?: Maybe<Scalars['String']>
}

export type GetAuditTaskResponse = {
  __typename?: 'GetAuditTaskResponse'
  auditTask: Maybe<AuditTask>
}

export type GetAuthenticationUrlRequestInput = {
  partnerId?: Maybe<Scalars['BigInt']>
  retailerId?: Maybe<Scalars['BigInt']>
  integrationType?: Maybe<Scalars['String']>
  successRedirectUrl?: Maybe<Scalars['String']>
  errorRedirectUrl?: Maybe<Scalars['String']>
}

export type GetAuthenticationUrlResponse = {
  __typename?: 'GetAuthenticationUrlResponse'
  authenticationUrl: Maybe<Scalars['String']>
}

export type GetCustomersContextRequestInput = {
  parameters?: Maybe<GetCustomersContextRequestParametersInput>
  timeoutMs?: Maybe<Scalars['BigInt']>
}

export type GetCustomersContextRequestParametersInput = {
  partnerId?: Maybe<Scalars['Int']>
}

export type GetCustomersContextResponse = {
  __typename?: 'GetCustomersContextResponse'
  context: Maybe<CustomersContext>
}

export type GetDashboardOrderRequestInput = {
  userId?: Maybe<Scalars['BigInt']>
  orderId?: Maybe<Scalars['BigInt']>
  externalId?: Maybe<Scalars['String']>
  partnerId?: Maybe<Scalars['BigInt']>
  retailerId?: Maybe<Scalars['BigInt']>
}

export type GetDashboardOrderResponse = {
  __typename?: 'GetDashboardOrderResponse'
  dashboardOrder: Maybe<InstacartEnterpriseBobaCoreTypesV1DashboardOrder>
}

export type GetIsGrocerRequestInput = {
  retailerLocationId?: Maybe<Scalars['BigInt']>
}

export type GetIsGrocerResponse = {
  __typename?: 'GetIsGrocerResponse'
  isGrocer: Maybe<Scalars['Boolean']>
}

export type GetItemsRequestInput = {
  parameters?: Maybe<GetItemsRequestParametersInput>
  timeoutMs?: Maybe<Scalars['BigInt']>
}

export type GetItemsRequestParametersInput = {
  aisleIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>
  limit?: Maybe<Scalars['BigInt']>
  localeCode?: Maybe<InstacartCustomersSharedV1Locale>
  offset?: Maybe<Scalars['BigInt']>
  inventoryAreaId?: Maybe<Scalars['BigInt']>
  retailerId?: Maybe<Scalars['BigInt']>
  primaryAisleId?: Maybe<Scalars['BigInt']>
  primaryDepartmentId?: Maybe<Scalars['BigInt']>
  departmentIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>
}

export type GetItemsResponse = {
  __typename?: 'GetItemsResponse'
  results: Maybe<Array<Maybe<Item>>>
  totalCount: Maybe<Scalars['BigInt']>
}

export type GetLegacyElasticsearchRequestInput = {
  inventoryAreaId?: Maybe<Scalars['BigInt']>
  itemIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>
  select?: Maybe<Array<Maybe<Scalars['String']>>>
  localeCode?: Maybe<InstacartCustomersSharedV1Locale>
}

export type GetLegacyProductsRequestInput = {
  aisleIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>
  departmentIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>
  productIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>
  limit?: Maybe<Scalars['BigInt']>
  offset?: Maybe<Scalars['BigInt']>
  retailerIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>
  select?: Maybe<Array<Maybe<Scalars['String']>>>
  source?: Maybe<Scalars['String']>
  query?: Maybe<Scalars['String']>
  inventoryAreaIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>
  availableInventoryAreaIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>
  regionIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>
}

export type GetLocalesByRetailerRequestInput = {
  retailerId?: Maybe<Scalars['BigInt']>
}

export type GetLocalesByRetailerResponse = {
  __typename?: 'GetLocalesByRetailerResponse'
  retailerLocales: Maybe<Array<Maybe<RetailerLocale>>>
}

export type GetManagedAttributeDefinitionsRequestInput = {
  entityId?: Maybe<EntityIdInput>
}

export type GetManagedAttributeDefinitionsResponse = {
  __typename?: 'GetManagedAttributeDefinitionsResponse'
  count: Maybe<Scalars['BigInt']>
  defs: Maybe<Array<Maybe<ManagedAttributeDefinition>>>
}

export type GetOrderLocationRequestInput = {
  requestContext?: Maybe<InstacartTypesV1RequestContextInput>
  orderId?: Maybe<Scalars['BigInt']>
  externalId?: Maybe<Scalars['String']>
  partnerId?: Maybe<Scalars['BigInt']>
  retailerId?: Maybe<Scalars['BigInt']>
}

export type GetOrderLocationResponse = {
  __typename?: 'GetOrderLocationResponse'
  shopperCoordinates: Maybe<GoogleTypeLatLng>
}

export type GetOrderRequestInput = {
  requestContext?: Maybe<InstacartTypesV1RequestContextInput>
  userId?: Maybe<Scalars['BigInt']>
  orderId?: Maybe<Scalars['BigInt']>
  externalId?: Maybe<Scalars['String']>
}

export type GetOrderResponse = {
  __typename?: 'GetOrderResponse'
  order: Maybe<InstacartEnterpriseBobaCoreTypesV1Order>
  orderItems: Maybe<Array<Maybe<InstacartEnterpriseBobaCoreTypesV1OrderItem>>>
}

export type GetParkingSettingsRequestInput = {
  retailerLocationId?: Maybe<Scalars['BigInt']>
  type?: Maybe<PickupType>
}

export type GetParkingSettingsResponse = {
  __typename?: 'GetParkingSettingsResponse'
  retailerLocationConfig: Maybe<RetailerLocationInfo>
  instruction: Maybe<Scalars['String']>
  imageConfigs: Maybe<Array<Maybe<ImageConfig>>>
  errors: Maybe<Array<Maybe<Scalars['String']>>>
}

export type GetPickupSettingsMetadataRequestInput = {
  retailerLocationId?: Maybe<Scalars['BigInt']>
}

export type GetPickupSettingsMetadataResponse = {
  __typename?: 'GetPickupSettingsMetadataResponse'
  isReadyForPickup: Maybe<Scalars['Boolean']>
  isCurbsidePickupEnabled: Maybe<Scalars['Boolean']>
  isSettingsOnboardingComplete: Maybe<Scalars['Boolean']>
  pickupEnableDate: Maybe<GoogleTypeDate>
  errors: Maybe<Array<Maybe<Scalars['String']>>>
}

export type GetPlacementsRequestInput = {
  placementId?: Maybe<Scalars['BigInt']>
  userId?: Maybe<Scalars['BigInt']>
  retailerId?: Maybe<Scalars['BigInt']>
  platform?: Maybe<Array<Maybe<PlatformType>>>
  variant?: Maybe<Array<Maybe<BannerVariant>>>
  sortBy?: Maybe<Scalars['String']>
  sortDirection?: Maybe<Direction>
  limit?: Maybe<Scalars['BigInt']>
  searchTerm?: Maybe<Scalars['String']>
  status?: Maybe<Array<Maybe<Status>>>
  type?: Maybe<Scalars['String']>
  enabledOnly?: Maybe<Scalars['Boolean']>
}

export type GetProductSourcesRequestInput = {
  sourceLevel?: Maybe<SourceLevel>
}

export type GetProductSourcesResponse = {
  __typename?: 'GetProductSourcesResponse'
  sourceCount: Maybe<Scalars['BigInt']>
  sources: Maybe<Array<Maybe<ProductSource>>>
}

export type GetRetailerAisleTemplateRequestInput = {
  retailerLocationId?: Maybe<Scalars['BigInt']>
  shopperType?: Maybe<ShopperType>
}

export type GetRetailerAisleTemplateResponse = {
  __typename?: 'GetRetailerAisleTemplateResponse'
  layoutId: Maybe<Scalars['String']>
  aisleTemplateId: Maybe<Scalars['BigInt']>
  activeAt: Maybe<Scalars['DateTime']>
  aisleOrders: Maybe<Array<Maybe<AisleOrder>>>
}

export type GetRetailerLocationByLayoutRequestInput = {
  layoutId?: Maybe<Scalars['String']>
  retailerLocationId?: Maybe<Scalars['BigInt']>
}

export type GetRetailerLocationByLayoutResponse = {
  __typename?: 'GetRetailerLocationByLayoutResponse'
  retailerLocationAisles: Maybe<Array<Maybe<RetailerLocationAisle>>>
}

export type GetRetailerProductDataRequestInput = {
  retailerId?: Maybe<Scalars['BigInt']>
  productIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>
}

export type GetRetailerProductDataResponse = {
  __typename?: 'GetRetailerProductDataResponse'
  retailerProductData: Maybe<Array<Maybe<RetailerProductData>>>
}

export type GetRetailerProductsRequestInput = {
  parameters?: Maybe<GetRetailerProductsRequestParametersInput>
  timeoutMs?: Maybe<Scalars['BigInt']>
}

export type GetRetailerProductsRequestParametersInput = {
  aisleIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>
  departmentIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>
  limit?: Maybe<Scalars['BigInt']>
  localeCode?: Maybe<InstacartCustomersSharedV1Locale>
  offset?: Maybe<Scalars['BigInt']>
  orderBy?: Maybe<InstacartCustomersSharedV1OrderInput>
  primaryAisleId?: Maybe<Scalars['BigInt']>
  primaryDepartmentId?: Maybe<Scalars['BigInt']>
  productCodes?: Maybe<Array<Maybe<Scalars['String']>>>
  query?: Maybe<Scalars['String']>
  retailerId?: Maybe<Scalars['BigInt']>
  retailerProductIds?: Maybe<Array<Maybe<RetailerProductIdInput>>>
  retailerReferenceCodes?: Maybe<Array<Maybe<Scalars['String']>>>
  select?: Maybe<Array<Maybe<Scalars['String']>>>
  hasPrimaryImageUrl?: Maybe<Scalars['Boolean']>
  isStoreBrandProduct?: Maybe<Scalars['Boolean']>
  productCreationDateRange?: Maybe<DateTimeRangeInput>
}

export type GetRetailerProductsResponse = {
  __typename?: 'GetRetailerProductsResponse'
  results: Maybe<Array<Maybe<RetailerProduct>>>
  totalCount: Maybe<Scalars['BigInt']>
}

export type GetRppConfigurableItemsRequestInput = {
  retailerId?: Maybe<Scalars['BigInt']>
  productId?: Maybe<Scalars['BigInt']>
  inventoryAreaId?: Maybe<Scalars['BigInt']>
  userId?: Maybe<Scalars['BigInt']>
}

export type GetRppConfigurableItemsResponse = {
  __typename?: 'GetRppConfigurableItemsResponse'
  configurableProducts: Maybe<Scalars['String']>
}

export type GetStagingSettingsRequestInput = {
  retailerLocationId?: Maybe<Scalars['BigInt']>
}

export type GetStagingSettingsResponse = {
  __typename?: 'GetStagingSettingsResponse'
  retailerLocationConfig: Maybe<RetailerLocationInfo>
  shelf: Maybe<Array<Maybe<Scalars['String']>>>
  fridge: Maybe<Array<Maybe<Scalars['String']>>>
  freezer: Maybe<Array<Maybe<Scalars['String']>>>
  imageUrl: Maybe<Scalars['String']>
  instruction: Maybe<Scalars['String']>
  errors: Maybe<Array<Maybe<Scalars['String']>>>
}

export type GetStoreHoursByDateRequestInput = {
  retailerLocationIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>
  startDate?: Maybe<GoogleTypeDateInput>
  endDate?: Maybe<GoogleTypeDateInput>
}

export type GetStoreHoursByDateResponse = {
  __typename?: 'GetStoreHoursByDateResponse'
  storeHours: Maybe<Array<Maybe<StoreHoursByDate>>>
}

export type GetStoreHoursByDayOfWeekRequestInput = {
  retailerLocationIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>
  daysOfWeek?: Maybe<Array<Maybe<GoogleTypeDayOfWeek>>>
}

export type GetStoreHoursByDayOfWeekResponse = {
  __typename?: 'GetStoreHoursByDayOfWeekResponse'
  storeHours: Maybe<Array<Maybe<StoreHoursByDayOfWeek>>>
}

export type GetStoreHoursRequestInput = {
  retailerLocationIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>
  serviceTypes?: Maybe<Array<Maybe<RetailerServiceType>>>
  startDate?: Maybe<GoogleTypeDateInput>
  endDate?: Maybe<GoogleTypeDateInput>
}

export type GetStoreHoursResponse = {
  __typename?: 'GetStoreHoursResponse'
  storeHours: Maybe<Array<Maybe<StoreHours>>>
}

export type GetStoreHoursUpdateTasksRequestInput = {
  retailerLocationIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>
  startDate?: Maybe<GoogleTypeDateInput>
}

export type GetStoreHoursUpdateTasksResponse = {
  __typename?: 'GetStoreHoursUpdateTasksResponse'
  tasks: Maybe<Array<Maybe<StoreHoursUpdateTask>>>
}

export type GetValueBasedOverridesRequestInput = {
  entityId?: Maybe<EntityIdInput>
}

export type GetValueBasedOverridesResponse = {
  __typename?: 'GetValueBasedOverridesResponse'
  entityId: Maybe<EntityId>
  valueBasedOverride: Maybe<Array<Maybe<ValueBasedOverrideResponse>>>
}

export type GoogleProtobufInt32Value = {
  __typename?: 'GoogleProtobufInt32Value'
  value: Maybe<Scalars['Int']>
}

export type GoogleProtobufUInt64Value = {
  __typename?: 'GoogleProtobufUInt64Value'
  value: Maybe<Scalars['BigInt']>
}

export type GoogleProtobufUInt64ValueInput = {
  value?: Maybe<Scalars['BigInt']>
}

export type GoogleTypeDate = {
  __typename?: 'GoogleTypeDate'
  year: Maybe<Scalars['Int']>
  month: Maybe<Scalars['Int']>
  day: Maybe<Scalars['Int']>
}

export type GoogleTypeDateInput = {
  year?: Maybe<Scalars['Int']>
  month?: Maybe<Scalars['Int']>
  day?: Maybe<Scalars['Int']>
}

export enum GoogleTypeDayOfWeek {
  DayOfWeekUnspecified = 'DAY_OF_WEEK_UNSPECIFIED',
  Monday = 'MONDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY',
  Thursday = 'THURSDAY',
  Friday = 'FRIDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
}

export type GoogleTypeLatLng = {
  __typename?: 'GoogleTypeLatLng'
  latitude: Maybe<Scalars['Float']>
  longitude: Maybe<Scalars['Float']>
}

export type GoogleTypeMoney = {
  __typename?: 'GoogleTypeMoney'
  currencyCode: Maybe<Scalars['String']>
  units: Maybe<Scalars['BigInt']>
  nanos: Maybe<Scalars['Int']>
}

export type GoogleTypeTimeOfDay = {
  __typename?: 'GoogleTypeTimeOfDay'
  hours: Maybe<Scalars['Int']>
  minutes: Maybe<Scalars['Int']>
  seconds: Maybe<Scalars['Int']>
  nanos: Maybe<Scalars['Int']>
}

export type GoogleTypeTimeOfDayInput = {
  hours?: Maybe<Scalars['Int']>
  minutes?: Maybe<Scalars['Int']>
  seconds?: Maybe<Scalars['Int']>
  nanos?: Maybe<Scalars['Int']>
}

export type GroupMetricValue = {
  __typename?: 'GroupMetricValue'
  groupValue: Maybe<InsightsPortalValue>
  metricValue: Maybe<InsightsPortalValue>
  secondaryMetricValues: Maybe<Array<Maybe<InsightsPortalMetricValue>>>
}

export type HealthCheck = {
  __typename?: 'HealthCheck'
  /** Server health status */
  alive: Scalars['True']
  /** Postgresql health status */
  postgresql: Maybe<Scalars['Boolean']>
  /** Redis health status */
  redis: Maybe<Scalars['Boolean']>
  /** Snowflake health status */
  snowflake: Maybe<Scalars['Boolean']>
}

export type HeroBanner = {
  __typename?: 'HeroBanner'
  id: Maybe<Scalars['BigInt']>
  variant: Maybe<BannerVariant>
  title: Maybe<Scalars['String']>
  titleColorHex: Maybe<Scalars['String']>
  subTitle: Maybe<Scalars['String']>
  subTitleColorHex: Maybe<Scalars['String']>
  cta: Maybe<Scalars['String']>
  mobileImageUrl: Maybe<Scalars['String']>
  desktopImageUrl: Maybe<Scalars['String']>
  placementId: Maybe<Scalars['BigInt']>
  ctaAction: Maybe<BannerAction>
  backgroundColorHex: Maybe<Scalars['String']>
  ctaColorHex: Maybe<Scalars['String']>
  ctaBackgroundColorHex: Maybe<Scalars['String']>
  textAreaColorHex: Maybe<Scalars['String']>
  clientVisibilityConditions: Maybe<Array<Maybe<ClientVisibilityCondition>>>
}

export type HeroBannerInput = {
  id?: Maybe<Scalars['BigInt']>
  variant?: Maybe<BannerVariant>
  title?: Maybe<Scalars['String']>
  titleColorHex?: Maybe<Scalars['String']>
  subTitle?: Maybe<Scalars['String']>
  subTitleColorHex?: Maybe<Scalars['String']>
  cta?: Maybe<Scalars['String']>
  mobileImageUrl?: Maybe<Scalars['String']>
  desktopImageUrl?: Maybe<Scalars['String']>
  placementId?: Maybe<Scalars['BigInt']>
  ctaAction?: Maybe<BannerActionInput>
  backgroundColorHex?: Maybe<Scalars['String']>
  ctaColorHex?: Maybe<Scalars['String']>
  ctaBackgroundColorHex?: Maybe<Scalars['String']>
  textAreaColorHex?: Maybe<Scalars['String']>
  clientVisibilityConditions?: Maybe<Array<Maybe<ClientVisibilityConditionInput>>>
}

/** Autogenerated return type of HeroBannerPlacementCreate */
export type HeroBannerPlacementCreatePayload = {
  __typename?: 'HeroBannerPlacementCreatePayload'
  /** The newly created hero_banner placement */
  heroBannerPlacement: ContentManagementHeroBannerPlacement
}

export type HeroBannerPlacementInput = {
  /** The name of the placement */
  name: Scalars['String']
  /** The images on the banner */
  images: GenericImagesInput
  /** Where interacting with the placement leads */
  destination?: Maybe<PlacementDestinationInput>
  /** When the placement begins and ends */
  scheduling: PlacementScheduleInput
  /** The style and text of the button within the placement */
  button: ConfigurableButtonInput
  /** The style and text of the heading */
  headingText: ConfigurableTextInput
  /** The style and text of the subheading */
  subheadingText: ConfigurableTextInput
  /** The platform which this placement should be displayed */
  platform: Array<PlacementPlatformEnum>
  /** The type of this placement */
  type: PlacementTypeEnum
  /** The color of the background for text placements (Eg. #FFFFFF) */
  backgroundColor: Scalars['String']
  /** The color of the text area for placements (Eg. #FFFFFF) */
  textareaColor?: Maybe<Scalars['String']>
  /** The priority rank of the placement */
  rank?: Maybe<Scalars['Int']>
  /** Information of Experiment associated with the placement */
  experiment?: Maybe<PlacementExperimentInput>
  enabled?: Maybe<Scalars['Boolean']>
}

/** Autogenerated return type of HeroBannerPlacementUpdate */
export type HeroBannerPlacementUpdatePayload = {
  __typename?: 'HeroBannerPlacementUpdatePayload'
  /** The updated hero_banner placement */
  heroBannerPlacement: ContentManagementHeroBannerPlacement
}

export type HistoricalPerformanceOverviewRecord = {
  __typename?: 'HistoricalPerformanceOverviewRecord'
  metricType: Maybe<MetricType>
  currentValue: Maybe<InstacartTypesV1BigDecimal>
  pastValue: Maybe<InstacartTypesV1BigDecimal>
}

export type HistoricalStorePerformanceRecord = {
  __typename?: 'HistoricalStorePerformanceRecord'
  warehouseLocationId: Maybe<Scalars['BigInt']>
  scheduledHours: Maybe<InstacartTypesV1BigDecimal>
  recommendedHours: Maybe<InstacartTypesV1BigDecimal>
  scheduledGaps: Maybe<Scalars['Int']>
  matchRate: Maybe<InstacartTypesV1BigDecimal>
  utilizationRate: Maybe<InstacartTypesV1BigDecimal>
  fiveHourAvailabilityRate: Maybe<InstacartTypesV1BigDecimal>
  partnerPickOrdersCount: Maybe<Scalars['Int']>
  fssOrdersCount: Maybe<Scalars['Int']>
  dedicatedMatchRate: Maybe<InstacartTypesV1BigDecimal>
  dedicatedUtilizationRate: Maybe<InstacartTypesV1BigDecimal>
  name: Maybe<Scalars['String']>
}

export type HistoricalStorePerformanceRequestInput = {
  warehouseId?: Maybe<Scalars['BigInt']>
  startDate?: Maybe<GoogleTypeDateInput>
  endDate?: Maybe<GoogleTypeDateInput>
  metricThresholds?: Maybe<Array<Maybe<MetricThresholdInput>>>
  warehouseLocationIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>
  devicePrioritizationEnabled?: Maybe<Scalars['Boolean']>
}

export type HistoricalStorePerformanceResponse = {
  __typename?: 'HistoricalStorePerformanceResponse'
  warehouseId: Maybe<Scalars['BigInt']>
  updatedAt: Maybe<Scalars['DateTime']>
  overviewMetrics: Maybe<Array<Maybe<HistoricalPerformanceOverviewRecord>>>
  metrics: Maybe<Array<Maybe<HistoricalStorePerformanceRecord>>>
}

/** Types of Home Placements which may be returned */
export type HomePlacement =
  | ContentManagementHeroBannerPlacement
  | ContentManagementImageForwardFlexPlacement
  | ContentManagementImageForwardPlacement
  | ContentManagementSecondaryBannerPlacement
  | ContentManagementTextWithThumbnailFlexPlacement
  | ContentManagementTextWithThumbnailPlacement
  | ContentManagementUnknownBannerPlacement

export type HubPaginationMeta = {
  __typename?: 'HubPaginationMeta'
  perPage: Scalars['Int']
  totalCount: Scalars['Int']
  totalPages: Scalars['Int']
}

export type ImageConfig = {
  __typename?: 'ImageConfig'
  id: Maybe<Scalars['Int']>
  url: Maybe<Scalars['String']>
  caption: Maybe<Scalars['String']>
}

export type ImageConfigInput = {
  id?: Maybe<Scalars['Int']>
  url?: Maybe<Scalars['String']>
  caption?: Maybe<Scalars['String']>
}

export type ImageForward = {
  __typename?: 'ImageForward'
  id: Maybe<Scalars['BigInt']>
  variant: Maybe<BannerVariant>
  title: Maybe<Scalars['String']>
  titleColorHex: Maybe<Scalars['String']>
  subTitle: Maybe<Scalars['String']>
  subTitleColorHex: Maybe<Scalars['String']>
  cta: Maybe<Scalars['String']>
  mobileImageUrl: Maybe<Scalars['String']>
  desktopImageUrl: Maybe<Scalars['String']>
  placementId: Maybe<Scalars['BigInt']>
  ctaAction: Maybe<BannerAction>
  backgroundColorHex: Maybe<Scalars['String']>
  ctaColorHex: Maybe<Scalars['String']>
  ctaBackgroundColorHex: Maybe<Scalars['String']>
}

export type ImageForwardFlex = {
  __typename?: 'ImageForwardFlex'
  id: Maybe<Scalars['BigInt']>
  variant: Maybe<BannerVariant>
  title: Maybe<Scalars['String']>
  titleColorHex: Maybe<Scalars['String']>
  subTitle: Maybe<Scalars['String']>
  subTitleColorHex: Maybe<Scalars['String']>
  cta: Maybe<Scalars['String']>
  mobileImageUrl: Maybe<Scalars['String']>
  desktopImageUrl: Maybe<Scalars['String']>
  placementId: Maybe<Scalars['BigInt']>
  ctaAction: Maybe<BannerAction>
  backgroundColorHex: Maybe<Scalars['String']>
  ctaColorHex: Maybe<Scalars['String']>
  ctaBackgroundColorHex: Maybe<Scalars['String']>
  visibilityConditions: Maybe<Array<Maybe<ClientVisibilityCondition>>>
}

export type ImageForwardFlexInput = {
  id?: Maybe<Scalars['BigInt']>
  variant?: Maybe<BannerVariant>
  title?: Maybe<Scalars['String']>
  titleColorHex?: Maybe<Scalars['String']>
  subTitle?: Maybe<Scalars['String']>
  subTitleColorHex?: Maybe<Scalars['String']>
  cta?: Maybe<Scalars['String']>
  mobileImageUrl?: Maybe<Scalars['String']>
  desktopImageUrl?: Maybe<Scalars['String']>
  placementId?: Maybe<Scalars['BigInt']>
  ctaAction?: Maybe<BannerActionInput>
  backgroundColorHex?: Maybe<Scalars['String']>
  ctaColorHex?: Maybe<Scalars['String']>
  ctaBackgroundColorHex?: Maybe<Scalars['String']>
  visibilityConditions?: Maybe<Array<Maybe<ClientVisibilityConditionInput>>>
}

/** Autogenerated return type of ImageForwardFlexPlacementCreate */
export type ImageForwardFlexPlacementCreatePayload = {
  __typename?: 'ImageForwardFlexPlacementCreatePayload'
  /** The newly created image_forward_flex placement */
  imageForwardFlexPlacement: ContentManagementImageForwardFlexPlacement
}

export type ImageForwardFlexPlacementInput = {
  /** The name of the placement */
  name: Scalars['String']
  /** The images on the banner */
  images: ImageForwardImagesInput
  /** Where interacting with the placement leads */
  destination?: Maybe<PlacementDestinationInput>
  /** When the placement begins and ends */
  scheduling: PlacementScheduleInput
  /** The style and text of the button within the placement */
  button: ConfigurableButtonInput
  /** The style and text of the heading */
  headingText: ConfigurableTextInput
  /** The style and text of the subheading */
  subheadingText: ConfigurableTextInput
  /** The platform which this placement should be displayed */
  platform: Array<PlacementPlatformEnum>
  /** The type of this placement */
  type: PlacementTypeEnum
  /** The color of the background for text placements (Eg. #FFFFFF) */
  backgroundColor: Scalars['String']
  /** The priority rank of the placement */
  rank?: Maybe<Scalars['Int']>
  /** Information of Experiment associated with the placement */
  experiment?: Maybe<PlacementExperimentInput>
  enabled?: Maybe<Scalars['Boolean']>
}

/** Autogenerated return type of ImageForwardFlexPlacementUpdate */
export type ImageForwardFlexPlacementUpdatePayload = {
  __typename?: 'ImageForwardFlexPlacementUpdatePayload'
  /** The updated image_forward_flex placement */
  imageForwardFlexPlacement: ContentManagementImageForwardFlexPlacement
}

export type ImageForwardImagesInput = {
  /** The image url of the placement to display for small viewports */
  mobile: Scalars['Url']
  /** The image url of the placement to display for large viewports */
  desktop?: Maybe<Scalars['Url']>
}

export type ImageForwardInput = {
  id?: Maybe<Scalars['BigInt']>
  variant?: Maybe<BannerVariant>
  title?: Maybe<Scalars['String']>
  titleColorHex?: Maybe<Scalars['String']>
  subTitle?: Maybe<Scalars['String']>
  subTitleColorHex?: Maybe<Scalars['String']>
  cta?: Maybe<Scalars['String']>
  mobileImageUrl?: Maybe<Scalars['String']>
  desktopImageUrl?: Maybe<Scalars['String']>
  placementId?: Maybe<Scalars['BigInt']>
  ctaAction?: Maybe<BannerActionInput>
  backgroundColorHex?: Maybe<Scalars['String']>
  ctaColorHex?: Maybe<Scalars['String']>
  ctaBackgroundColorHex?: Maybe<Scalars['String']>
}

/** Autogenerated return type of ImageForwardPlacementCreate */
export type ImageForwardPlacementCreatePayload = {
  __typename?: 'ImageForwardPlacementCreatePayload'
  /** The newly created image_forward placement */
  imageForwardPlacement: ContentManagementImageForwardPlacement
}

export type ImageForwardPlacementInput = {
  /** The name of the placement */
  name: Scalars['String']
  /** The images on the banner */
  images: ImageForwardImagesInput
  /** Where interacting with the placement leads */
  destination?: Maybe<PlacementDestinationInput>
  /** When the placement begins and ends */
  scheduling: PlacementScheduleInput
  /** The style and text of the button within the placement */
  button: ConfigurableButtonInput
  /** The style and text of the heading */
  headingText: ConfigurableTextInput
  /** The style and text of the subheading */
  subheadingText: ConfigurableTextInput
  /** The platform which this placement should be displayed */
  platform: Array<PlacementPlatformEnum>
  /** The type of this placement */
  type: PlacementTypeEnum
  /** The color of the background for text placements (Eg. #FFFFFF) */
  backgroundColor: Scalars['String']
  /** The priority rank of the placement */
  rank?: Maybe<Scalars['Int']>
  /** Information of Experiment associated with the placement */
  experiment?: Maybe<PlacementExperimentInput>
  enabled?: Maybe<Scalars['Boolean']>
}

/** Autogenerated return type of ImageForwardPlacementUpdate */
export type ImageForwardPlacementUpdatePayload = {
  __typename?: 'ImageForwardPlacementUpdatePayload'
  /** The updated image_forward placement */
  imageForwardPlacement: ContentManagementImageForwardPlacement
}

export type ImageInfo = {
  __typename?: 'ImageInfo'
  imageType: Maybe<Scalars['String']>
  imageId: Maybe<Scalars['String']>
  imageUrl: Maybe<Scalars['String']>
  sourceType: Maybe<Scalars['String']>
}

/** Attributes for creating a code lookup */
export type ImportProcessCodeLookupDataInput = {
  /** The lookup code of the product */
  code: Scalars['String']
  /** The price per cost unit of the product */
  pricePerCostUnit?: Maybe<Scalars['Float']>
}

export enum ImportProcessCodeLookupStateEnum {
  /** A brand new ImportProcessCodeLookup which hasn't been processed yet (no product_ids have been fetched) */
  Pending = 'PENDING',
  /** The ImportProcessCodeLookup is being processed (we are fetching the associated product_ids) */
  InProgress = 'IN_PROGRESS',
  /** The ImportProcessCodeLookup was processed successfully, returning zero or more product_ids */
  Completed = 'COMPLETED',
  /** Something went wrong when trying to fetch the associated product_ids for the ImportProcessCodeLookup */
  Failed = 'FAILED',
}

export enum ImportProcessCodeLookupStatusEnum {
  /** We haven't tried to match this code lookup yet, so we don't know the match status */
  Pending = 'PENDING',
  /** There was exactly one product matching the provided lookup code */
  PerfectMatch = 'PERFECT_MATCH',
  /** There was not exactly one product matching the provided lookup code (either 0 or 2+ items were found) */
  Unmatched = 'UNMATCHED',
}

export enum ImportProcessCodeLookupTypeEnum {
  /** A UPC code */
  Upc = 'UPC',
}

export enum ImportProcessStateEnum {
  /** A new import process with no associated ImportProcessCodeLookups */
  Pending = 'PENDING',
  /** The associated ImportProcessCodeLookups have started to be created */
  InProgress = 'IN_PROGRESS',
  /** The associated ImportProcessCodeLookups have all been created */
  Completed = 'COMPLETED',
  /** Something went wrong when trying to create the ImportProcessCodeLookups */
  Failed = 'FAILED',
}

export enum ImportProcessTypeEnum {
  /** A code-lookup type import process */
  CodeLookup = 'CODE_LOOKUP',
}

export type InFilterInput = {
  values?: Maybe<Array<Maybe<InsightsPortalValueInput>>>
}

export type InsightsPortalAuthorizationContextInput = {
  partnerIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>
  retailerIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>
  retailerLocationIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>
}

export type InsightsPortalFilterDefinition = {
  __typename?: 'InsightsPortalFilterDefinition'
  name: Maybe<Scalars['String']>
  type: Maybe<FilterType>
}

export type InsightsPortalFilterOption = {
  __typename?: 'InsightsPortalFilterOption'
  displayValue: Maybe<Scalars['String']>
  rawValue: Maybe<InsightsPortalValue>
}

export type InsightsPortalFilterOptionsRequestInput = {
  schema?: Maybe<InsightsPortalSchema>
  authorizationContext?: Maybe<InsightsPortalAuthorizationContextInput>
  filters?: Maybe<Array<Maybe<InsightsPortalFilterSelectionInput>>>
}

export type InsightsPortalFilterOptionsResponse = {
  __typename?: 'InsightsPortalFilterOptionsResponse'
  filterOptions: Maybe<Array<Maybe<FilterOptions>>>
}

export type InsightsPortalFilterSelectionInput = {
  name?: Maybe<Scalars['String']>
  equalFilter?: Maybe<EqualFilterInput>
  betweenFilter?: Maybe<BetweenFilterInput>
  inFilter?: Maybe<InFilterInput>
}

export type InsightsPortalGroupComparisonDatasetInput = {
  schema?: Maybe<InsightsPortalSchema>
  filters?: Maybe<Array<Maybe<InsightsPortalFilterSelectionInput>>>
  metric?: Maybe<Scalars['String']>
  groupBy?: Maybe<Scalars['String']>
  secondaryMetrics?: Maybe<Array<Maybe<Scalars['String']>>>
}

export type InsightsPortalGroupComparisonRequestInput = {
  authorizationContext?: Maybe<InsightsPortalAuthorizationContextInput>
  primaryDataset?: Maybe<InsightsPortalGroupComparisonDatasetInput>
  comparisonDataset?: Maybe<InsightsPortalGroupComparisonDatasetInput>
  joinBy?: Maybe<JoinBy>
  orderBy?: Maybe<OrderBy>
  orderDirection?: Maybe<OrderDirection>
  limit?: Maybe<Scalars['BigInt']>
  offset?: Maybe<Scalars['BigInt']>
}

export type InsightsPortalGroupComparisonResponse = {
  __typename?: 'InsightsPortalGroupComparisonResponse'
  values: Maybe<Array<Maybe<InsightsPortalGroupComparisonValues>>>
}

export type InsightsPortalGroupComparisonValues = {
  __typename?: 'InsightsPortalGroupComparisonValues'
  metricName: Maybe<Scalars['String']>
  primaryGroupValue: Maybe<InsightsPortalValue>
  comparisonGroupValue: Maybe<InsightsPortalValue>
  primaryMetricValue: Maybe<InsightsPortalValue>
  comparisonMetricValue: Maybe<InsightsPortalValue>
  primarySecondaryMetricValues: Maybe<Array<Maybe<InsightsPortalMetricValue>>>
  comparisonSecondaryMetricValues: Maybe<Array<Maybe<InsightsPortalMetricValue>>>
  growth: Maybe<Scalars['Float']>
  growthPercentage: Maybe<Scalars['Float']>
}

export type InsightsPortalGroupMetricValueRequestInput = {
  schema?: Maybe<InsightsPortalSchema>
  authorizationContext?: Maybe<InsightsPortalAuthorizationContextInput>
  primaryMetric?: Maybe<Scalars['String']>
  secondaryMetrics?: Maybe<Array<Maybe<Scalars['String']>>>
  filters?: Maybe<Array<Maybe<InsightsPortalFilterSelectionInput>>>
  groupBy?: Maybe<Scalars['String']>
  orderDirection?: Maybe<OrderDirection>
  limit?: Maybe<Scalars['BigInt']>
  offset?: Maybe<Scalars['BigInt']>
}

export type InsightsPortalGroupMetricValueResponse = {
  __typename?: 'InsightsPortalGroupMetricValueResponse'
  values: Maybe<Array<Maybe<GroupMetricValue>>>
}

export type InsightsPortalMetricValue = {
  __typename?: 'InsightsPortalMetricValue'
  metric: Maybe<Scalars['String']>
  value: Maybe<InsightsPortalValue>
}

export type InsightsPortalMetricValuesRequestInput = {
  schema?: Maybe<InsightsPortalSchema>
  authorizationContext?: Maybe<InsightsPortalAuthorizationContextInput>
  metrics?: Maybe<Array<Maybe<Scalars['String']>>>
  filters?: Maybe<Array<Maybe<InsightsPortalFilterSelectionInput>>>
}

export type InsightsPortalMetricValuesResponse = {
  __typename?: 'InsightsPortalMetricValuesResponse'
  metricValues: Maybe<Array<Maybe<InsightsPortalMetricValue>>>
}

export enum InsightsPortalSchema {
  Unknown = 'UNKNOWN',
  OrderDelivery = 'ORDER_DELIVERY',
  OrderItem = 'ORDER_ITEM',
  SearchTerm = 'SEARCH_TERM',
  ProductByCategoryBenchmark = 'PRODUCT_BY_CATEGORY_BENCHMARK',
  ProductByPartnerBenchmark = 'PRODUCT_BY_PARTNER_BENCHMARK',
  SearchTermByPartnerBenchmark = 'SEARCH_TERM_BY_PARTNER_BENCHMARK',
  SearchTermByTermBenchmark = 'SEARCH_TERM_BY_TERM_BENCHMARK',
  ImageCoverage = 'IMAGE_COVERAGE',
  ImageCoverageDemo = 'IMAGE_COVERAGE_DEMO',
  OrderDeliveryDemo = 'ORDER_DELIVERY_DEMO',
  OrderItemDemo = 'ORDER_ITEM_DEMO',
  SearchTermDemo = 'SEARCH_TERM_DEMO',
  AdsSponsoredProduct = 'ADS_SPONSORED_PRODUCT',
}

export type InsightsPortalSchemaMetadataRequestInput = {
  schema?: Maybe<InsightsPortalSchema>
  authorizationContext?: Maybe<InsightsPortalAuthorizationContextInput>
}

export type InsightsPortalSchemaMetadataResponse = {
  __typename?: 'InsightsPortalSchemaMetadataResponse'
  name: Maybe<Scalars['String']>
  metrics: Maybe<Array<Maybe<Scalars['String']>>>
  filters: Maybe<Array<Maybe<InsightsPortalFilterDefinition>>>
}

export type InsightsPortalSnowflakeHeartbeatRequestInput = {
  token?: Maybe<Scalars['String']>
}

export type InsightsPortalSnowflakeHeartbeatResponse = {
  __typename?: 'InsightsPortalSnowflakeHeartbeatResponse'
  authenticated: Maybe<Scalars['Boolean']>
}

export type InsightsPortalValue = {
  __typename?: 'InsightsPortalValue'
  stringValue: Maybe<Scalars['String']>
  intValue: Maybe<Scalars['BigInt']>
  doubleValue: Maybe<Scalars['Float']>
  timestampValue: Maybe<Scalars['DateTime']>
}

export type InsightsPortalValueInput = {
  stringValue?: Maybe<Scalars['String']>
  intValue?: Maybe<Scalars['BigInt']>
  doubleValue?: Maybe<Scalars['Float']>
  timestampValue?: Maybe<Scalars['DateTime']>
}

export enum InstacartCustomersSharedV1FulfillmentTypeWrapperFulfillmentType {
  FulfillmentTypeUnspecified = 'FULFILLMENT_TYPE_UNSPECIFIED',
  Pickup = 'PICKUP',
  Delivery = 'DELIVERY',
  OneHour = 'ONE_HOUR',
  TwoHour = 'TWO_HOUR',
  ThreeHour = 'THREE_HOUR',
  FiveHour = 'FIVE_HOUR',
  LimitedAvailability = 'LIMITED_AVAILABILITY',
  Eta = 'ETA',
  Asap = 'ASAP',
  Scheduled = 'SCHEDULED',
  DeliveryOnly = 'DELIVERY_ONLY',
  RetailerInstore = 'RETAILER_INSTORE',
  DirectToConsumer = 'DIRECT_TO_CONSUMER',
  RetailerManaged = 'RETAILER_MANAGED',
  HyperFast = 'HYPER_FAST',
  PriorityEta = 'PRIORITY_ETA',
  PickupEta = 'PICKUP_ETA',
  VirtualExpress = 'VIRTUAL_EXPRESS',
  AffordableDelivery = 'AFFORDABLE_DELIVERY',
}

export enum InstacartCustomersSharedV1Locale {
  LocaleUnspecified = 'LOCALE_UNSPECIFIED',
  EnUs = 'EN_US',
  EnCa = 'EN_CA',
  FrCa = 'FR_CA',
  EnAu = 'EN_AU',
}

export enum InstacartCustomersSharedV1OrderAttributeDirection {
  Asc = 'ASC',
  Desc = 'DESC',
}

export type InstacartCustomersSharedV1OrderAttributeInput = {
  name?: Maybe<Scalars['String']>
  direction?: Maybe<InstacartCustomersSharedV1OrderAttributeDirection>
}

export type InstacartCustomersSharedV1OrderInput = {
  attributes?: Maybe<Array<Maybe<InstacartCustomersSharedV1OrderAttributeInput>>>
}

export type InstacartCustomersSharedV1PageInfo = {
  __typename?: 'InstacartCustomersSharedV1PageInfo'
  endCursor: Maybe<Scalars['String']>
  hasNextPage: Maybe<Scalars['Boolean']>
}

export type InstacartCustomersSharedV1PaginationInput = {
  after?: Maybe<Scalars['String']>
  limit?: Maybe<Scalars['Int']>
}

export type InstacartCustomersSharedV1RequestContextInput = {
  storeConfigurationId?: Maybe<Scalars['Int']>
  clientConfigurationId?: Maybe<Scalars['Int']>
  countryId?: Maybe<Scalars['Int']>
}

export enum InstacartCustomersSharedV1ServiceType {
  ServiceTypeUnspecified = 'SERVICE_TYPE_UNSPECIFIED',
  Delivery = 'DELIVERY',
  Pickup = 'PICKUP',
  Virtual = 'VIRTUAL',
}

export type InstacartEnterpriseBobaCoreTypesV1AddressDashboardCreationParamsInput = {
  addressLineOne?: Maybe<Scalars['String']>
  addressLineTwo?: Maybe<Scalars['String']>
  addressType?: Maybe<Scalars['String']>
  postalCode?: Maybe<Scalars['String']>
}

export type InstacartEnterpriseBobaCoreTypesV1AddressInformation = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1AddressInformation'
  streetName: Maybe<Scalars['String']>
  unitNumber: Maybe<Scalars['String']>
  city: Maybe<Scalars['String']>
  zipCode: Maybe<Scalars['String']>
}

export type InstacartEnterpriseBobaCoreTypesV1CustomerInformation = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1CustomerInformation'
  customerFirstName: Maybe<Scalars['String']>
  customerLastName: Maybe<Scalars['String']>
  customerFullName: Maybe<Scalars['String']>
  customerPhoneNumber: Maybe<Scalars['String']>
}

export type InstacartEnterpriseBobaCoreTypesV1DashboardOrder = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1DashboardOrder'
  id: Maybe<Scalars['BigInt']>
  orderDeliveryId: Maybe<Scalars['BigInt']>
  displayId: Maybe<Scalars['BigInt']>
  userId: Maybe<Scalars['BigInt']>
  warehouseId: Maybe<Scalars['Int']>
  warehouseLocationId: Maybe<Scalars['BigInt']>
  retailerProvidedAmounts: Maybe<InstacartEnterpriseBobaCoreTypesV1RetailerProvidedAmounts>
  alcoholic: Maybe<Scalars['Boolean']>
  initialTip: Maybe<Scalars['Float']>
  fulfillmentDetails: Maybe<InstacartEnterpriseBobaCoreTypesV1FulfillmentDetails>
  dashboardOptions: Maybe<InstacartEnterpriseBobaCoreTypesV1DashboardOrderOptions>
  shopperFirstName: Maybe<Scalars['String']>
  customerInformation: Maybe<InstacartEnterpriseBobaCoreTypesV1CustomerInformation>
  addressInformation: Maybe<InstacartEnterpriseBobaCoreTypesV1AddressInformation>
  workflowState: Maybe<Scalars['String']>
  estimatedPickupTime: Maybe<Scalars['DateTime']>
  estimatedDeliveryTime: Maybe<Scalars['DateTime']>
  shopperAvatarUrl: Maybe<Scalars['String']>
  addressLatitude: Maybe<Scalars['Float']>
  addressLongitude: Maybe<Scalars['Float']>
  customerContext: Maybe<InstacartEnterpriseBobaCoreTypesV1DashboardOrderCustomerContext>
  formattedTipAmount: Maybe<Scalars['String']>
  warehouseLocationName: Maybe<Scalars['String']>
  externalId: Maybe<Scalars['String']>
  cancellationReason: Maybe<Scalars['String']>
  previouslyRescheduled: Maybe<Scalars['Boolean']>
  carModelAndColor: Maybe<Scalars['String']>
}

export type InstacartEnterpriseBobaCoreTypesV1DashboardOrderCustomerContext = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1DashboardOrderCustomerContext'
  storeConfigurationId: Maybe<Scalars['Int']>
  clientConfigurationId: Maybe<Scalars['Int']>
  countryId: Maybe<Scalars['Int']>
}

export type InstacartEnterpriseBobaCoreTypesV1DashboardOrderOptions = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1DashboardOrderOptions'
  leaveUnattended: Maybe<Scalars['Boolean']>
  specialInstructions: Maybe<Scalars['String']>
}

export type InstacartEnterpriseBobaCoreTypesV1FulfillmentDetails = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1FulfillmentDetails'
  fulfillmentType: Maybe<Scalars['String']>
  serviceOptionId: Maybe<Scalars['BigInt']>
  windowStartsAt: Maybe<Scalars['DateTime']>
  windowEndsAt: Maybe<Scalars['DateTime']>
  warehouseLocationId: Maybe<Scalars['BigInt']>
  addressId: Maybe<Scalars['BigInt']>
  numOfBags: Maybe<Scalars['BigInt']>
}

export type InstacartEnterpriseBobaCoreTypesV1ItemReplacement = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1ItemReplacement'
  itemUpc: Maybe<Scalars['String']>
  itemRrc: Maybe<Scalars['String']>
}

export type InstacartEnterpriseBobaCoreTypesV1LastMileOrderDashboardCreationParamsInput = {
  locationCode?: Maybe<Scalars['String']>
  serviceOptionId?: Maybe<Scalars['BigInt']>
  startAt?: Maybe<Scalars['String']>
  endAt?: Maybe<Scalars['String']>
  initialTip?: Maybe<Scalars['Float']>
  externalData?: Maybe<InstacartEnterpriseBobaCoreTypesV1OrderExternalDataInput>
  retailerProvidedAmounts?: Maybe<InstacartEnterpriseBobaCoreTypesV1RetailerProvidedAmountsInput>
  options?: Maybe<InstacartEnterpriseBobaCoreTypesV1OrderOptionsInput>
  userBirthday?: Maybe<Scalars['String']>
  userPhone?: Maybe<Scalars['String']>
  alcoholic?: Maybe<Scalars['Boolean']>
  locale?: Maybe<Scalars['String']>
  addressCreationParams?: Maybe<InstacartEnterpriseBobaCoreTypesV1AddressDashboardCreationParamsInput>
  userCreationParams?: Maybe<InstacartEnterpriseBobaCoreTypesV1UserDashboardCreationParamsInput>
}

export type InstacartEnterpriseBobaCoreTypesV1ModificationEventInput = {
  userId?: Maybe<Scalars['String']>
  userType?: Maybe<InstacartEnterpriseBobaCoreTypesV1ModificationEventUserType>
  reason?: Maybe<Scalars['String']>
  reasonDetailed?: Maybe<Scalars['String']>
}

export enum InstacartEnterpriseBobaCoreTypesV1ModificationEventUserType {
  UserTypeUnspecified = 'USER_TYPE_UNSPECIFIED',
  Rpp = 'RPP',
}

export type InstacartEnterpriseBobaCoreTypesV1Order = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1Order'
  id: Maybe<Scalars['BigInt']>
  orderDeliveryId: Maybe<Scalars['BigInt']>
  displayId: Maybe<Scalars['BigInt']>
  userId: Maybe<Scalars['BigInt']>
  warehouseId: Maybe<Scalars['BigInt']>
  loyaltyCardId: Maybe<Scalars['BigInt']>
  workflowState: Maybe<Scalars['String']>
  createdAt: Maybe<Scalars['DateTime']>
  updatedAt: Maybe<Scalars['DateTime']>
  canceledAt: Maybe<Scalars['DateTime']>
  completedAt: Maybe<Scalars['DateTime']>
  deliveredAt: Maybe<Scalars['DateTime']>
  fulfillmentDetails: Maybe<InstacartEnterpriseBobaCoreTypesV1FulfillmentDetails>
  externalData: Maybe<InstacartEnterpriseBobaCoreTypesV1OrderExternalData>
  statusUrl: Maybe<Scalars['String']>
  timezone: Maybe<Scalars['String']>
  cancellationReason: Maybe<Scalars['String']>
  postCheckoutLink: Maybe<Scalars['String']>
  locale: Maybe<Scalars['String']>
  warnings: Maybe<Array<Maybe<InstacartEnterpriseBobaCoreTypesV1OrderWarning>>>
  deliveryEta: Maybe<Scalars['DateTime']>
  isExpress: Maybe<Scalars['Boolean']>
}

export type InstacartEnterpriseBobaCoreTypesV1OrderExternalData = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1OrderExternalData'
  externalId: Maybe<Scalars['String']>
}

export type InstacartEnterpriseBobaCoreTypesV1OrderExternalDataInput = {
  externalId?: Maybe<Scalars['String']>
}

export type InstacartEnterpriseBobaCoreTypesV1OrderItem = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1OrderItem'
  id: Maybe<Scalars['BigInt']>
  orderId: Maybe<Scalars['BigInt']>
  itemId: Maybe<Scalars['BigInt']>
  substituteId: Maybe<Scalars['BigInt']>
  quantity: Maybe<InstacartEnterpriseBobaCoreTypesV1OrderItemQuantity>
  status: Maybe<Scalars['String']>
  itemProperties: Maybe<InstacartEnterpriseBobaCoreTypesV1OrderItemProperties>
  externalData: Maybe<InstacartEnterpriseBobaCoreTypesV1OrderItemExternalData>
  createdAt: Maybe<Scalars['DateTime']>
  updatedAt: Maybe<Scalars['DateTime']>
  pickedAt: Maybe<Scalars['DateTime']>
  replacementPolicy: Maybe<Scalars['String']>
  replacementItem: Maybe<InstacartEnterpriseBobaCoreTypesV1ItemReplacement>
  isAddOnItem: Maybe<Scalars['Boolean']>
  itemCodes: Maybe<InstacartEnterpriseBobaCoreTypesV1OrderItemCodes>
}

export type InstacartEnterpriseBobaCoreTypesV1OrderItemCodes = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1OrderItemCodes'
  requestedUpc: Maybe<Scalars['String']>
  requestedRrc: Maybe<Scalars['String']>
  deliveredUpc: Maybe<Scalars['String']>
  deliveredRrc: Maybe<Scalars['String']>
}

export type InstacartEnterpriseBobaCoreTypesV1OrderItemExternalData = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1OrderItemExternalData'
  lineNum: Maybe<Scalars['String']>
  itemUpc: Maybe<Scalars['String']>
  itemRrc: Maybe<Scalars['String']>
  scanCode: Maybe<Scalars['String']>
}

export type InstacartEnterpriseBobaCoreTypesV1OrderItemProperties = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1OrderItemProperties'
  productId: Maybe<Scalars['BigInt']>
  name: Maybe<Scalars['String']>
  productType: Maybe<Scalars['String']>
}

export type InstacartEnterpriseBobaCoreTypesV1OrderItemQuantity = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1OrderItemQuantity'
  unit: Maybe<Scalars['String']>
  weightOrdered: Maybe<Scalars['Float']>
  countOrdered: Maybe<Scalars['Int']>
  weightDelivered: Maybe<Scalars['Float']>
  countDelivered: Maybe<Scalars['Int']>
}

export type InstacartEnterpriseBobaCoreTypesV1OrderOptionsInput = {
  leaveUnattended?: Maybe<Scalars['Boolean']>
  smsOptIn?: Maybe<Scalars['Boolean']>
  specialInstructions?: Maybe<Scalars['String']>
}

export type InstacartEnterpriseBobaCoreTypesV1OrderWarning = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1OrderWarning'
  message: Maybe<Scalars['String']>
  errorCode: Maybe<Scalars['Int']>
  itemCodes: Maybe<Array<Maybe<Scalars['String']>>>
}

export type InstacartEnterpriseBobaCoreTypesV1ReopenLastmileOrderParamsInput = {
  canceledOrderId?: Maybe<Scalars['BigInt']>
  canceledExternalOrderId?: Maybe<Scalars['String']>
  serviceOptionId?: Maybe<Scalars['BigInt']>
  startAt?: Maybe<Scalars['String']>
  endAt?: Maybe<Scalars['String']>
  externalData?: Maybe<InstacartEnterpriseBobaCoreTypesV1OrderExternalDataInput>
}

export type InstacartEnterpriseBobaCoreTypesV1RescheduleOrderParamsInput = {
  id?: Maybe<Scalars['BigInt']>
  serviceOptionId?: Maybe<Scalars['BigInt']>
  startAt?: Maybe<Scalars['String']>
  endAt?: Maybe<Scalars['String']>
  externalData?: Maybe<InstacartEnterpriseBobaCoreTypesV1OrderExternalDataInput>
}

export type InstacartEnterpriseBobaCoreTypesV1RetailerProvidedAmounts = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1RetailerProvidedAmounts'
  cartTotal: Maybe<Scalars['Float']>
  itemsCount: Maybe<Scalars['Int']>
  itemsWeight: Maybe<Scalars['Float']>
  bagsCount: Maybe<Scalars['Int']>
}

export type InstacartEnterpriseBobaCoreTypesV1RetailerProvidedAmountsInput = {
  cartTotal?: Maybe<Scalars['Float']>
  itemsCount?: Maybe<Scalars['Int']>
  itemsWeight?: Maybe<Scalars['Float']>
  bagsCount?: Maybe<Scalars['Int']>
}

export type InstacartEnterpriseBobaCoreTypesV1UserDashboardCreationParamsInput = {
  firstName?: Maybe<Scalars['String']>
  lastName?: Maybe<Scalars['String']>
  userPhone?: Maybe<Scalars['String']>
}

export type InstacartTypesV1BigDecimal = {
  __typename?: 'InstacartTypesV1BigDecimal'
  units: Maybe<Scalars['BigInt']>
  nanos: Maybe<Scalars['Int']>
}

export type InstacartTypesV1RequestContextInput = {
  storeConfigurationId?: Maybe<Scalars['Int']>
  clientConfigurationId?: Maybe<Scalars['Int']>
  countryId?: Maybe<Scalars['Int']>
  applicationId?: Maybe<Scalars['Int']>
}

export type Item = {
  __typename?: 'Item'
  localeCode: Maybe<Scalars['String']>
  primaryAisleId: Maybe<Scalars['BigInt']>
  primaryImageUrl: Maybe<Scalars['String']>
  productCodes: Maybe<Array<Maybe<Scalars['String']>>>
  productDisplayName: Maybe<Scalars['String']>
  productId: Maybe<Scalars['BigInt']>
  retailerId: Maybe<Scalars['BigInt']>
  retailerReferenceCode: Maybe<Scalars['String']>
  primaryDepartmentId: Maybe<Scalars['BigInt']>
}

export enum JoinBy {
  Unknown = 'UNKNOWN',
  RowNumber = 'ROW_NUMBER',
  GroupValue = 'GROUP_VALUE',
  CustomJoinProductToCategory = 'CUSTOM_JOIN_PRODUCT_TO_CATEGORY',
}

export enum Layout {
  Storefront = 'STOREFRONT',
  Home = 'HOME',
  HomeHero = 'HOME_HERO',
  HomeSecondary = 'HOME_SECONDARY',
  EntStorefront = 'ENT_STOREFRONT',
  StorefrontHero = 'STOREFRONT_HERO',
}

export type LegacyBaseImageType = {
  __typename?: 'LegacyBaseImageType'
  /** The image url */
  url: Maybe<Scalars['String']>
}

export type LegacyConfigurationType = {
  __typename?: 'LegacyConfigurationType'
  knowledgeOwl: LegacyKnowledgeOwlType
}

export type LegacyCountryType = {
  __typename?: 'LegacyCountryType'
  /** Unique identifier */
  id: Scalars['ID']
  /** country name */
  name: Scalars['String']
}

export type LegacyDeliveryHoursType = {
  __typename?: 'LegacyDeliveryHoursType'
  /** Date of Delivery Hours */
  date: Scalars['LegacyDate']
  /** Ending hour of Delivery Hours on specified date */
  endsAtHour: Scalars['Int']
  /** Starting hour of Delivery Hours on specified date */
  startsAtHour: Scalars['Int']
  /** The associated warehouse of the delivery hours */
  warehouse: LegacyWarehouseType
}

export type LegacyElasticsearchResponse = {
  __typename?: 'LegacyElasticsearchResponse'
  docs: Maybe<Array<Maybe<Scalars['JSONObject']>>>
}

export enum LegacyFulfillmentMethodEnum {
  /** Partner managed */
  Retailer = 'RETAILER',
  /** Locker */
  Locker = 'LOCKER',
  /** In store shoppers */
  Iss = 'ISS',
}

export type LegacyHealthCheckType = {
  __typename?: 'LegacyHealthCheckType'
  /** Server health status */
  ok: Scalars['Boolean']
}

export type LegacyKnowledgeOwlType = {
  __typename?: 'LegacyKnowledgeOwlType'
  /** Knowledge Base Domain */
  domain: Scalars['String']
  /** OAuth Token */
  oauthToken: Scalars['String']
  /** Knowledge Base Project ID */
  projectId: Scalars['String']
}

export enum LegacyOrderSource {
  /** Orders from the Instacart Marketplace. */
  Marketplace = 'MARKETPLACE',
  /** Orders from a retailer via API. */
  Api = 'API',
  /** Orders from a Powered by Instacart whitelabel site. */
  Pbi = 'PBI',
  /** Orders from a Unata site. */
  Unata = 'UNATA',
}

/** Information about pagination in a connection. */
export type LegacyPageInfo = {
  __typename?: 'LegacyPageInfo'
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']>
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']>
}

export type LegacyPartnerType = {
  __typename?: 'LegacyPartnerType'
  /** The Partner's unique identifier  */
  id: Scalars['ID']
  /** The name of the Partner */
  name: Scalars['String']
  /** The associated Warehouses */
  warehouses: Array<LegacyWarehouseType>
}

export type LegacyPartnerUserType = {
  __typename?: 'LegacyPartnerUserType'
  /** The way the PartnerUser was created */
  createdVia: Maybe<Scalars['String']>
  /** The user's email */
  email: Scalars['String']
  /** The user's given name */
  firstName: Scalars['String']
  /** The user's list of enabled flippers */
  flippers: Array<Scalars['String']>
  /** The user's surname */
  lastName: Scalars['String']
  /** The Partners which can be accessed */
  partners: Array<LegacyPartnerType>
  /** The user's list of permissions */
  permissions: Array<Scalars['String']>
  /** The user's phone number */
  phone: Maybe<Scalars['String']>
  /** The user's list of roles */
  roles: Array<Scalars['String']>
  /** A unique external identifier for the PartnerUser */
  uuid: Scalars['ID']
  /** The Warehouses which can be accessed */
  warehouses: Array<LegacyWarehouseType>
}

export enum LegacyPickingLaborEnum {
  /** Partner managed */
  Retailer = 'RETAILER',
  /** Full service shoppers */
  FullService = 'FULL_SERVICE',
  /** In store shoppers */
  Iss = 'ISS',
}

export type LegacyProducts = {
  __typename?: 'LegacyProducts'
  totalCount: Maybe<Scalars['BigInt']>
  totalPages: Maybe<Scalars['BigInt']>
  items: Maybe<Array<Maybe<Scalars['JSONObject']>>>
}

export type LegacySearchImpressionImageCoverageType = {
  __typename?: 'LegacySearchImpressionImageCoverageType'
  /** Array of datapoints associated to query */
  data: Array<LegacyTimeSeriesDatumType>
}

export type LegacySearchImpressionMissingImagesReportType = {
  __typename?: 'LegacySearchImpressionMissingImagesReportType'
  /** URL to generated missing images report */
  url: Scalars['String']
}

export enum LegacyShopperStateEnum {
  /** Active */
  Active = 'ACTIVE',
  /** Resigned (deactivated) */
  Resigned = 'RESIGNED',
}

export type LegacyShopperType = {
  __typename?: 'LegacyShopperType'
  /** The shopper's email */
  email: Scalars['String']
  /** The shopper's given name */
  firstName: Scalars['String']
  /** Unique identifier */
  id: Scalars['ID']
  /** The shopper's surname */
  lastName: Scalars['String']
  /** The shoppers's phone number */
  phone: Scalars['String']
  /** The shopper's status */
  state: LegacyShopperStateEnum
}

/** The connection type for ShopperType. */
export type LegacyShopperTypeConnection = {
  __typename?: 'LegacyShopperTypeConnection'
  /** A list of edges. */
  edges: Maybe<Array<Maybe<LegacyShopperTypeEdge>>>
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<LegacyShopperType>>>
  /** Information to aid in pagination. */
  pageInfo: LegacyPageInfo
}

/** An edge in a connection. */
export type LegacyShopperTypeEdge = {
  __typename?: 'LegacyShopperTypeEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: Maybe<LegacyShopperType>
}

export type LegacyTimeSeriesDatumType = {
  __typename?: 'LegacyTimeSeriesDatumType'
  /** Date associated to value */
  x: Scalars['LegacyDate']
  /** Value associated to date */
  y: Scalars['Float']
}

export type LegacyWarehouseLocationConfigType = {
  __typename?: 'LegacyWarehouseLocationConfigType'
  /** Hybrid Picking setting for the Warehouse Location indicates combined ISS and Partner Pick */
  hybridPickingEnabled: Maybe<Scalars['Boolean']>
}

export type LegacyWarehouseLocationType = {
  __typename?: 'LegacyWarehouseLocationType'
  /** The active status for the warehouse location */
  active: Scalars['Boolean']
  /** The city */
  city: Maybe<Scalars['String']>
  /** Configuration Settings for this Warehouse Location */
  configValues: Maybe<LegacyWarehouseLocationConfigType>
  /** The delivery hours of the Warehouse Location */
  deliveryHours: Array<LegacyDeliveryHoursType>
  /** The pickup model handoff labor */
  fulfillmentMethods: Maybe<Array<LegacyFulfillmentMethodEnum>>
  /** The unique ID */
  id: Scalars['ID']
  /** The retailer-assigned location code */
  locationCode: Maybe<Scalars['String']>
  /** The name */
  name: Maybe<Scalars['String']>
  /** Identifies if the location does partner run alcohol delivery */
  partnerAlcoholDelivery: Scalars['Boolean']
  /** The pickup model picking labor */
  pickingLabor: Maybe<LegacyPickingLaborEnum>
  /** Identifies if pickup is enabled */
  pickup: Scalars['Boolean']
  /** The associated shoppers */
  shoppers: Array<LegacyShopperType>
  /** The associated shoppers collection */
  shoppersCollection: LegacyShopperTypeConnection
  /** The state */
  state: Maybe<Scalars['String']>
  /** The street (including street #) */
  street: Maybe<Scalars['String']>
  /** The associated Warehouse */
  warehouse: LegacyWarehouseType
  /** The zip code or postal code */
  zipCode: Maybe<Scalars['String']>
  /** The zip_plus_four */
  zipPlusFour: Maybe<Scalars['String']>
  /** The zones of the Warehouse Location */
  zones: Array<LegacyZoneType>
}

export type LegacyWarehouseLocationTypeDeliveryHoursArgs = {
  dates: Array<Scalars['LegacyDate']>
}

export type LegacyWarehouseLocationTypeShoppersArgs = {
  states?: Maybe<Array<LegacyShopperStateEnum>>
}

export type LegacyWarehouseLocationTypeShoppersCollectionArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
  ids?: Maybe<Array<Scalars['ID']>>
  states?: Maybe<Array<LegacyShopperStateEnum>>
}

export type LegacyWarehouseLogoType = {
  __typename?: 'LegacyWarehouseLogoType'
  /** A header-specific version of the logo */
  header: Maybe<LegacyBaseImageType>
  /** A tiny version of the logo */
  tiny: Maybe<LegacyBaseImageType>
  /** The image url */
  url: Maybe<Scalars['String']>
  /** The whitelabeled logo */
  whiteLabelLandingPage: Maybe<LegacyBaseImageType>
}

export type LegacyWarehouseType = {
  __typename?: 'LegacyWarehouseType'
  /** Country of Warehouse */
  country: Maybe<LegacyCountryType>
  /** Warehouse early picking hour [if one is set] */
  earlyPickingHour: Maybe<Scalars['Int']>
  /** The warehouse's list of enabled flippers */
  flippers: Array<Scalars['String']>
  /** The Warehouse's unique identifier */
  id: Scalars['ID']
  /** The associated inactive WarehouseLocations */
  inactiveWarehouseLocations: Maybe<Array<LegacyWarehouseLocationType>>
  /** The Warehouses' logo */
  logo: Maybe<LegacyWarehouseLogoType>
  /** The name of the Warehouse */
  name: Maybe<Scalars['String']>
  /** The warehouse's order sources. */
  orderSources: Maybe<Array<LegacyOrderSource>>
  /** The associated Partner */
  partner: Maybe<LegacyPartnerType>
  /** The associated active WarehouseLocations */
  warehouseLocations: Maybe<Array<LegacyWarehouseLocationType>>
}

export type LegacyZoneType = {
  __typename?: 'LegacyZoneType'
  /** The unique identifier */
  id: Scalars['ID']
}

export type ListAuditBatchesRequestInput = {
  client?: Maybe<Scalars['String']>
  workflows?: Maybe<Array<Maybe<Scalars['String']>>>
  fromDate?: Maybe<Scalars['DateTime']>
  toDate?: Maybe<Scalars['DateTime']>
  batchStatuses?: Maybe<Array<Maybe<Scalars['String']>>>
  page?: Maybe<PaginationInput>
}

export type ListAuditBatchesResponse = {
  __typename?: 'ListAuditBatchesResponse'
  auditBatches: Maybe<Array<Maybe<AuditBatch>>>
  totalResultCount: Maybe<Scalars['BigInt']>
}

export type ListAuditWorkflowsRequestInput = {
  client?: Maybe<Scalars['String']>
  workflows?: Maybe<Array<Maybe<Scalars['String']>>>
  returnTaskInformation?: Maybe<Scalars['Boolean']>
  fromDate?: Maybe<Scalars['DateTime']>
  toDate?: Maybe<Scalars['DateTime']>
  batchStatuses?: Maybe<Array<Maybe<Scalars['String']>>>
}

export type ListAuditWorkflowsResponse = {
  __typename?: 'ListAuditWorkflowsResponse'
  auditWorkflows: Maybe<Array<Maybe<AuditWorkflow>>>
}

export type ListOrdersRequestInput = {
  requestContext?: Maybe<InstacartCustomersSharedV1RequestContextInput>
  pagination?: Maybe<InstacartCustomersSharedV1PaginationInput>
  userId?: Maybe<Scalars['BigInt']>
  adminAllUsers?: Maybe<Scalars['Boolean']>
  filters?: Maybe<FilterSetInput>
}

export type ListOrdersResponse = {
  __typename?: 'ListOrdersResponse'
  pageInfo: Maybe<InstacartCustomersSharedV1PageInfo>
  orderSummaries: Maybe<Array<Maybe<OrderSummary>>>
  orders: Maybe<Array<Maybe<Order>>>
}

export type LocaleProduct = {
  __typename?: 'LocaleProduct'
  localeId: Maybe<Scalars['String']>
  productId: Maybe<Scalars['String']>
}

export type LogoWithTextBanner = {
  __typename?: 'LogoWithTextBanner'
  id: Maybe<Scalars['BigInt']>
  variant: Maybe<BannerVariant>
  title: Maybe<Scalars['String']>
  titleColorHex: Maybe<Scalars['String']>
  subTitle: Maybe<Scalars['String']>
  subTitleColorHex: Maybe<Scalars['String']>
  ctaAction: Maybe<BannerAction>
  imageUrl: Maybe<Scalars['String']>
  imageMobileUrl: Maybe<Scalars['String']>
  imageAltText: Maybe<Scalars['String']>
  backgroundColorHex: Maybe<Scalars['String']>
  placementId: Maybe<Scalars['BigInt']>
}

export type LogoWithTextBannerInput = {
  id?: Maybe<Scalars['BigInt']>
  variant?: Maybe<BannerVariant>
  title?: Maybe<Scalars['String']>
  titleColorHex?: Maybe<Scalars['String']>
  subTitle?: Maybe<Scalars['String']>
  subTitleColorHex?: Maybe<Scalars['String']>
  ctaAction?: Maybe<BannerActionInput>
  imageUrl?: Maybe<Scalars['String']>
  imageMobileUrl?: Maybe<Scalars['String']>
  imageAltText?: Maybe<Scalars['String']>
  backgroundColorHex?: Maybe<Scalars['String']>
  placementId?: Maybe<Scalars['BigInt']>
}

export type ManagedAttributeDefinition = {
  __typename?: 'ManagedAttributeDefinition'
  name: Maybe<Scalars['String']>
  displayName: Maybe<Scalars['String']>
  attributeType: Maybe<Scalars['String']>
  isEnum: Maybe<Scalars['Boolean']>
  emaOptions: Maybe<Array<Maybe<Scalars['String']>>>
}

export type MatchesAnyRetailerId = {
  __typename?: 'MatchesAnyRetailerId'
  id: Maybe<Scalars['BigInt']>
  placementId: Maybe<Scalars['BigInt']>
  retailerIds: Maybe<Array<Maybe<Scalars['BigInt']>>>
}

export type MatchesAnyRetailerIdInput = {
  id?: Maybe<Scalars['BigInt']>
  placementId?: Maybe<Scalars['BigInt']>
  retailerIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>
}

export enum MergeableReportTypeEnum {
  /** Retailer Tax Logs */
  RetailerTaxLogs = 'RETAILER_TAX_LOGS',
  /** Taxes Paid at POS */
  TaxesPaidAtPos = 'TAXES_PAID_AT_POS',
}

export type MetricThresholdInput = {
  metricType?: Maybe<MetricType>
  threshold?: Maybe<Scalars['BigInt']>
}

export enum MetricType {
  Default = 'DEFAULT',
  ScheduledHours = 'SCHEDULED_HOURS',
  RecommendedHours = 'RECOMMENDED_HOURS',
  ScheduledGaps = 'SCHEDULED_GAPS',
  StaffingRate = 'STAFFING_RATE',
  MatchRate = 'MATCH_RATE',
  UtilizationRate = 'UTILIZATION_RATE',
  FiveHourAvailabilityRate = 'FIVE_HOUR_AVAILABILITY_RATE',
  FulfilledOrders = 'FULFILLED_ORDERS',
  DedicatedMatchRate = 'DEDICATED_MATCH_RATE',
  DedicatedUtilizationRate = 'DEDICATED_UTILIZATION_RATE',
}

export type MinimumPlatformVersionInput = {
  /** A unique identifier of the visibility condition */
  id?: Maybe<Scalars['ID']>
  /** A unique identifier of the placement associated with the visibility condition */
  placementId?: Maybe<Scalars['ID']>
  /** The platform the version is being checked for */
  platform: PlacementPlatformEnum
  /** Version used for the check */
  version: Scalars['String']
}

/** Autogenerated return type of MinimumPlatformVersionVisibilityConditionCreate */
export type MinimumPlatformVersionVisibilityConditionCreatePayload = {
  __typename?: 'MinimumPlatformVersionVisibilityConditionCreatePayload'
  /** The newly created minimum_platform_version visibility condition */
  minimumPlatformVersionVisibilityCondition: ContentManagementVisibilityConditionMinimumPlatformVersion
}

/** Autogenerated return type of MinimumPlatformVersionVisibilityConditionUpdate */
export type MinimumPlatformVersionVisibilityConditionUpdatePayload = {
  __typename?: 'MinimumPlatformVersionVisibilityConditionUpdatePayload'
  /** The newly created minimum_platform_version visibility condition */
  minimumPlatformVersionVisibilityCondition: ContentManagementVisibilityConditionMinimumPlatformVersion
}

export type Mutation = {
  __typename?: 'Mutation'
  retailerAislesUpdateRetailerAisleTemplate: Maybe<UpdateRetailerAisleTemplateResponse>
  retailerStoreHoursUpdateStoreHours: Maybe<UpdateStoreHoursResponse>
  contentManagementServiceCreatePlacement: Maybe<CreatePlacementResponse>
  retailerSettingsServiceUpdateStagingSettings: Maybe<UpdateStagingSettingsResponse>
  retailerSettingsServiceUpdateParkingSettings: Maybe<UpdateParkingSettingsResponse>
  retailerSettingsServiceDeleteImage: Maybe<DeleteImageResponse>
  valueBasedOverrideServiceCreateValueBasedOverride: Maybe<CreateValueBasedOverrideResponse>
  configurableItemsServicePublishRppConfigurableItems: Maybe<PublishRppConfigurableItemsResponse>
  demeterServiceUpdateAuditTask: Maybe<UpdateAuditTaskResponse>
  demeterServiceUpdateAuditBatch: Maybe<UpdateAuditBatchResponse>
  apiIntegrationsServiceUpdateApiSetting: Maybe<UpdateApiSettingResponse>
  apiIntegrationsServiceDeleteApiSetting: Maybe<DeleteApiSettingResponse>
  availabilityUpsertStoreHoursByDayOfWeek: Maybe<UpsertStoreHoursByDayOfWeekResponse>
  availabilityUpdateStoreHoursByDate: Maybe<UpdateStoreHoursByDateResponse>
  orderServiceCancelOrder: Maybe<CancelOrderResponse>
  orderServiceRescheduleOrder: Maybe<RescheduleOrderResponse>
  orderServiceCreateLastmileOrderFromDashboard: Maybe<CreateLastmileOrderFromDashboardResponse>
  orderServiceReopenLastmileOrder: Maybe<ReopenLastmileOrderResponse>
  /** Create/update a new enterprise account by its email */
  botEnterpriseAccountUpsert: Maybe<BotEnterpriseAccountUpsertPayload>
  /** Update an existing callback configuration */
  callbackConfigurationUpdate: Maybe<PartnerCallbackConfigurationUpdatePayload>
  /** Create a new catalog 'code lookup batch' and add the given codes to it */
  catalogCodeLookupBatchCreate: Maybe<CatalogCodeLookupBatchCreatePayload>
  /** Create a new catalog 'code lookup' import process and add the given codes to it */
  catalogImportProcessCodeLookupCreate: Maybe<CatalogImportProcessCodeLookupCreatePayload>
  /** Create a new catalog workflow */
  catalogWorkflowCreate: Maybe<CatalogWorkflowCreatePayload>
  /** Delete an existing workflow (only workflows in the `draft` state can be deleted) */
  catalogWorkflowDelete: Maybe<CatalogWorkflowDeletePayload>
  /** Create a new catalog workflow */
  catalogWorkflowEventCreate: Maybe<CatalogWorkflowEventCreatePayload>
  /** Create a new 'BulkRemoveChangesetProducts' catalog workflow event */
  catalogWorkflowEventCreateBulkRemoveChangesetNewProductRequests: Maybe<CatalogWorkflowEventCreateBulkRemoveChangesetNewProductRequestsPayload>
  /** Create a new 'BulkRemoveChangesetProducts' catalog workflow event */
  catalogWorkflowEventCreateBulkRemoveChangesetProducts: Maybe<CatalogWorkflowEventCreateBulkRemoveChangesetProductsPayload>
  /** Create a new 'BulkRemoveImportProcessCodeLookups' catalog workflow event */
  catalogWorkflowEventCreateBulkRemoveImportProcessCodeLookups: Maybe<CatalogWorkflowEventCreateBulkRemoveImportProcessCodeLookupsPayload>
  /** Create a new 'BulkUpdateChangesetProducts' catalog workflow event */
  catalogWorkflowEventCreateBulkUpdateChangesetProducts: Maybe<CatalogWorkflowEventCreateBulkUpdateChangesetProductsPayload>
  /** Submit a workflow to the catalog */
  catalogWorkflowSubmit: Maybe<CatalogWorkflowSubmitPayload>
  /** Create a new collection */
  collectionCreate: Maybe<CollectionCreatePayload>
  /** Delete an existing collection */
  collectionDelete: Maybe<CollectionDeletePayload>
  /** Update an existing collection */
  collectionUpdate: Maybe<CollectionUpdatePayload>
  /** Create a ExpressMembership visibility condition */
  dayOfWeekVisibilityConditionCreate: Maybe<DayOfWeekVisibilityConditionCreatePayload>
  /** Update an existing ShoppedAtRetailer visibility condition */
  dayOfWeekVisibilityConditionUpdate: Maybe<DayOfWeekVisibilityConditionUpdatePayload>
  /** Set up a new account using an account setup token */
  enterpriseAccountAccountSetup: Maybe<EnterpriseAccountAccountSetupPayload>
  /** Authenticate an account using an email and password */
  enterpriseAccountAuthenticateEmailPassword: Maybe<EnterpriseAccountAuthenticateEmailPasswordPayload>
  /** Preflight authentication info per email address */
  enterpriseAccountAuthenticatePreflight: Maybe<EnterpriseAccountAuthenticatePreflightPayload>
  /** Create a new enterprise account */
  enterpriseAccountCreate: Maybe<EnterpriseAccountCreatePayload>
  /** Request that an account setup email be sent to an Account's email address */
  enterpriseAccountRequestAccountSetupEmail: Maybe<EnterpriseAccountRequestAccountSetupEmailPayload>
  /** Request that a verification email be sent to an Account's email address */
  enterpriseAccountRequestEmailVerification: Maybe<EnterpriseAccountRequestEmailVerificationPayload>
  /** Request that a password reset email be sent to an Account's email address */
  enterpriseAccountRequestPasswordReset: Maybe<EnterpriseAccountRequestPasswordResetPayload>
  /** Set/Reset an account's password using a password reset token */
  enterpriseAccountResetPassword: Maybe<EnterpriseAccountResetPasswordPayload>
  /** Sets the disabled flag on an account to true/false */
  enterpriseAccountSetDisabled: Maybe<EnterpriseAccountSetDisabledPayload>
  /** Sign up for an account using an email */
  enterpriseAccountSignUpEmailPassword: Maybe<EnterpriseAccountSignUpEmailPasswordPayload>
  /** Update an enterprise account */
  enterpriseAccountUpdate: Maybe<EnterpriseAccountUpdatePayload>
  /** Verify an account's email using a verification token */
  enterpriseAccountVerifyEmail: Maybe<EnterpriseAccountVerifyEmailPayload>
  /** Create a ExpressMembership visibility condition */
  expressMembershipVisibilityConditionCreate: Maybe<ExpressMembershipVisibilityConditionCreatePayload>
  /** Update an existing ExpressMembership visibility condition */
  expressMembershipVisibilityConditionUpdate: Maybe<ExpressMembershipVisibilityConditionUpdatePayload>
  /** Create an ExpressNonmemberLongTermHoldout visibility condition */
  expressNonmemberLongTermHoldoutVisibilityConditionCreate: Maybe<ExpressNonmemberLongTermHoldoutVisibilityConditionCreatePayload>
  /** Update the feature tour status for the currently logged in account */
  featureTourUpdate: Maybe<FeatureTourUpdatePayload>
  /** Create a new home placement with HeroBanner banner */
  heroBannerPlacementCreate: Maybe<HeroBannerPlacementCreatePayload>
  /** Update an existing hero_banner placement placement */
  heroBannerPlacementUpdate: Maybe<HeroBannerPlacementUpdatePayload>
  /** Create a new home placement with ImageForwardFlex banner */
  imageForwardFlexPlacementCreate: Maybe<ImageForwardFlexPlacementCreatePayload>
  /** Update an existing image_forward_flex placement placement */
  imageForwardFlexPlacementUpdate: Maybe<ImageForwardFlexPlacementUpdatePayload>
  /** Create a new home placement */
  imageForwardPlacementCreate: Maybe<ImageForwardPlacementCreatePayload>
  /** Update an existing image_forward placement placement */
  imageForwardPlacementUpdate: Maybe<ImageForwardPlacementUpdatePayload>
  /** Create a MinimumPlatformVersion visibility condition */
  minimumPlatformVersionVisibilityConditionCreate: Maybe<MinimumPlatformVersionVisibilityConditionCreatePayload>
  /** Update an existing MinimumPlatformVersion visibility condition */
  minimumPlatformVersionVisibilityConditionUpdate: Maybe<MinimumPlatformVersionVisibilityConditionUpdatePayload>
  /** Merges two or more normalized-reports by combining their contents into one file */
  normalizedReportsMerge: Maybe<NormalizedReportsMergePayload>
  /** Subscribe an account to a notification type for a retailer */
  notificationSubscriptionCreate: Maybe<NotificationSubscriptionCreatePayload>
  /** Unsubscribe an account to a notification type for a retailer */
  notificationSubscriptionDelete: Maybe<NotificationSubscriptionDeletePayload>
  /** Sends a test callback for a partner */
  partnerCallbackCreate: Maybe<PartnerCallbackCreatePayload>
  /** Create a new partner pick device */
  partnerPickDeviceCreate: Maybe<PartnerPickDeviceCreatePayload>
  /** Update an existing partner pick device's status */
  partnerPickDeviceSetStatus: Maybe<PartnerPickDeviceSetStatusPayload>
  /** Update an existing partner pick device */
  partnerPickDeviceUpdate: Maybe<PartnerPickDeviceUpdatePayload>
  /** Create a new partner pick recurring shift */
  partnerPickRecurringShiftCreate: Maybe<PartnerPickRecurringShiftCreatePayload>
  /** Delete a partner pick recurring shift by id, from some date onward */
  partnerPickRecurringShiftDelete: Maybe<PartnerPickRecurringShiftDeletePayload>
  /** Update an existing partner pick recurring shift */
  partnerPickRecurringShiftUpdate: Maybe<PartnerPickRecurringShiftUpdatePayload>
  /** Create a new report request */
  reportRequestCreate: Maybe<ReportRequestCreatePayload>
  /** Create a new retailer location group */
  retailerLocationGroupCreate: Maybe<RetailerLocationGroupCreatePayload>
  /** Delete an existing retailer location group */
  retailerLocationGroupDelete: Maybe<RetailerLocationGroupDeletePayload>
  /** Update an existing retailer location group */
  retailerLocationGroupUpdate: Maybe<RetailerLocationGroupUpdatePayload>
  /** Simulate an event for an existing sandbox order */
  sandboxOrderSimulateEvent: Maybe<PartnerSandboxOrderSimulateEventPayload>
  /** Create a new home placement with SecondaryBanner banner */
  secondaryBannerPlacementCreate: Maybe<SecondaryBannerPlacementCreatePayload>
  /** Update an existing secondary_banner placement placement */
  secondaryBannerPlacementUpdate: Maybe<SecondaryBannerPlacementUpdatePayload>
  /** Create a ShoppedAtRetailer visibility condition */
  shoppedAtRetailerVisibilityConditionCreate: Maybe<ShoppedAtRetailerVisibilityConditionCreatePayload>
  /** Update an existing ShoppedAtRetailer visibility condition */
  shoppedAtRetailerVisibilityConditionUpdate: Maybe<ShoppedAtRetailerVisibilityConditionUpdatePayload>
  /** Create a shopped visibility condition */
  shoppedVisibilityConditionCreate: Maybe<ShoppedVisibilityConditionCreatePayload>
  /** Update an existing Shopped visibility condition */
  shoppedVisibilityConditionUpdate: Maybe<ShoppedVisibilityConditionUpdatePayload>
  /** Create a new storefront placement */
  storefrontPlacementCreate: Maybe<StorefrontPlacementCreatePayload>
  /** Delete an existing storefront placement */
  storefrontPlacementDelete: Maybe<StorefrontPlacementDeletePayload>
  /** Update an existing storefront placement placement */
  storefrontPlacementUpdate: Maybe<StorefrontPlacementUpdatePayload>
  /** Create a new TextWithThumbnailFlex home placement */
  textWithThumbnailFlexPlacementCreate: Maybe<TextWithThumbnailFlexPlacementCreatePayload>
  /** Update an existing text_with_thumbnail_flex placement placement */
  textWithThumbnailFlexPlacementUpdate: Maybe<TextWithThumbnailFlexPlacementUpdatePayload>
  /** Create a new home placement */
  textWithThumbnailPlacementCreate: Maybe<TextWithThumbnailPlacementCreatePayload>
  /** Update an existing text_with_thumbnail placement placement */
  textWithThumbnailPlacementUpdate: Maybe<TextWithThumbnailPlacementUpdatePayload>
  /** Delete an existing visibility condition */
  visibilityConditionDelete: Maybe<VisibilityConditionDeletePayload>
  /** Create a WhitelistedPostalCodes visibility condition */
  whitelistedPostalCodesVisibilityConditionCreate: Maybe<WhitelistedPostalCodesVisibilityConditionCreatePayload>
  /** Update an existing WhitelistedPostalCodes visibility condition */
  whitelistedPostalCodesVisibilityConditionUpdate: Maybe<WhitelistedPostalCodesVisibilityConditionUpdatePayload>
  /** Update the wizard progress for the currently logged in account */
  wizardProgressUpdate: Maybe<WizardProgressUpdatePayload>
}

export type MutationRetailerAislesUpdateRetailerAisleTemplateArgs = {
  input?: Maybe<UpdateRetailerAisleTemplateRequestInput>
}

export type MutationRetailerStoreHoursUpdateStoreHoursArgs = {
  input?: Maybe<UpdateStoreHoursRequestInput>
}

export type MutationContentManagementServiceCreatePlacementArgs = {
  input?: Maybe<CreatePlacementRequestInput>
}

export type MutationRetailerSettingsServiceUpdateStagingSettingsArgs = {
  input?: Maybe<UpdateStagingSettingsRequestInput>
}

export type MutationRetailerSettingsServiceUpdateParkingSettingsArgs = {
  input?: Maybe<UpdateParkingSettingsRequestInput>
}

export type MutationRetailerSettingsServiceDeleteImageArgs = {
  input?: Maybe<DeleteImageRequestInput>
}

export type MutationValueBasedOverrideServiceCreateValueBasedOverrideArgs = {
  input?: Maybe<CreateValueBasedOverrideRequestInput>
}

export type MutationConfigurableItemsServicePublishRppConfigurableItemsArgs = {
  input?: Maybe<PublishRppConfigurableItemsRequestInput>
}

export type MutationDemeterServiceUpdateAuditTaskArgs = {
  input?: Maybe<UpdateAuditTaskRequestInput>
}

export type MutationDemeterServiceUpdateAuditBatchArgs = {
  input?: Maybe<UpdateAuditBatchRequestInput>
}

export type MutationApiIntegrationsServiceUpdateApiSettingArgs = {
  input?: Maybe<UpdateApiSettingRequestInput>
}

export type MutationApiIntegrationsServiceDeleteApiSettingArgs = {
  input?: Maybe<DeleteApiSettingRequestInput>
}

export type MutationAvailabilityUpsertStoreHoursByDayOfWeekArgs = {
  input?: Maybe<UpsertStoreHoursByDayOfWeekRequestInput>
}

export type MutationAvailabilityUpdateStoreHoursByDateArgs = {
  input?: Maybe<UpdateStoreHoursByDateRequestInput>
}

export type MutationOrderServiceCancelOrderArgs = {
  input?: Maybe<CancelOrderRequestInput>
}

export type MutationOrderServiceRescheduleOrderArgs = {
  input?: Maybe<RescheduleOrderRequestInput>
}

export type MutationOrderServiceCreateLastmileOrderFromDashboardArgs = {
  input?: Maybe<CreateLastmileOrderFromDashboardRequestInput>
}

export type MutationOrderServiceReopenLastmileOrderArgs = {
  input?: Maybe<ReopenLastmileOrderRequestInput>
}

export type MutationBotEnterpriseAccountUpsertArgs = {
  givenName: Scalars['String']
  surname: Scalars['String']
  email: Scalars['String']
  partnerIds?: Maybe<Array<Scalars['ID']>>
  retailerIds?: Maybe<Array<Scalars['ID']>>
  role: BotAccountAssignableRoleEnum
  readOnly?: Maybe<Scalars['Boolean']>
}

export type MutationCallbackConfigurationUpdateArgs = {
  id: Scalars['ID']
  updatedCallbackConfiguration: CallbackConfigurationInput
}

export type MutationCatalogCodeLookupBatchCreateArgs = {
  codeLookupsData: Array<CodeLookupDataInput>
}

export type MutationCatalogImportProcessCodeLookupCreateArgs = {
  workflowId: Scalars['ID']
  codeLookupsData: Array<ImportProcessCodeLookupDataInput>
  codeLookupType: ImportProcessCodeLookupTypeEnum
  source?: Maybe<Scalars['String']>
}

export type MutationCatalogWorkflowCreateArgs = {
  retailerId: Scalars['ID']
  workflowType: WorkflowTypeEnum
}

export type MutationCatalogWorkflowDeleteArgs = {
  id: Scalars['ID']
}

export type MutationCatalogWorkflowEventCreateArgs = {
  workflowId: Scalars['ID']
  workflowEventCreationInput: WorkflowEventCreationInput
}

export type MutationCatalogWorkflowEventCreateBulkRemoveChangesetNewProductRequestsArgs = {
  workflowId: Scalars['ID']
  changesetNewProductRequestIdsFilter?: Maybe<Array<Scalars['ID']>>
  aisleIdFilter?: Maybe<Scalars['ID']>
  departmentIdFilter?: Maybe<Scalars['ID']>
  classifiedCodeFilter?: Maybe<Scalars['String']>
}

export type MutationCatalogWorkflowEventCreateBulkRemoveChangesetProductsArgs = {
  workflowId: Scalars['ID']
  changesetProductIdsFilter?: Maybe<Array<Scalars['ID']>>
  aisleIdFilter?: Maybe<Scalars['ID']>
  departmentIdFilter?: Maybe<Scalars['ID']>
  classifiedCodeFilter?: Maybe<Scalars['String']>
  statusFilter?: Maybe<ChangesetProductStatusEnum>
}

export type MutationCatalogWorkflowEventCreateBulkRemoveImportProcessCodeLookupsArgs = {
  workflowId: Scalars['ID']
  importProcessIdFilter?: Maybe<Scalars['ID']>
  importProcessCodeLookupIdsFilter?: Maybe<Array<Scalars['ID']>>
  importProcessCodeLookupTypeFilter?: Maybe<ImportProcessCodeLookupTypeEnum>
  importProcessCodeLookupStateFilter?: Maybe<ImportProcessCodeLookupStateEnum>
  importProcessCodeLookupStatusFilter?: Maybe<ImportProcessCodeLookupStatusEnum>
  hasAssociatedNewProductRequestFilter?: Maybe<Scalars['Boolean']>
}

export type MutationCatalogWorkflowEventCreateBulkUpdateChangesetProductsArgs = {
  workflowId: Scalars['ID']
  changesetProductIdsFilter?: Maybe<Array<Scalars['ID']>>
  aisleIdFilter?: Maybe<Scalars['ID']>
  departmentIdFilter?: Maybe<Scalars['ID']>
  classifiedCodeFilter?: Maybe<Scalars['String']>
  statusFilter?: Maybe<ChangesetProductStatusEnum>
  updatedAisleId?: Maybe<Scalars['ID']>
  updatedDepartmentId?: Maybe<Scalars['ID']>
  updatedCostUnit?: Maybe<CostUnitEnum>
  updatedPricePerCostUnit?: Maybe<Scalars['Float']>
}

export type MutationCatalogWorkflowSubmitArgs = {
  workflowId: Scalars['ID']
}

export type MutationCollectionCreateArgs = {
  collectionName: Scalars['String']
  startDate?: Maybe<Scalars['String']>
  endDate?: Maybe<Scalars['String']>
  parentId?: Maybe<Scalars['ID']>
  retailerIds?: Maybe<Array<Scalars['ID']>>
  collectionType: CollectionTypeEnum
  active?: Maybe<Scalars['Boolean']>
  activeAdminOnly?: Maybe<Scalars['Boolean']>
  image?: Maybe<Scalars['String']>
  childrenIds?: Maybe<Array<Scalars['ID']>>
  headerData?: Maybe<CollectionHeaderInput>
  storefrontBannerData?: Maybe<CollectionStorefrontBannerInput>
  subjectsData?: Maybe<Array<CollectionSubjectInput>>
}

export type MutationCollectionDeleteArgs = {
  collectionId: Scalars['ID']
}

export type MutationCollectionUpdateArgs = {
  collectionId: Scalars['ID']
  collectionName?: Maybe<Scalars['String']>
  startDate?: Maybe<Scalars['String']>
  endDate?: Maybe<Scalars['String']>
  parentId?: Maybe<Scalars['ID']>
  retailerIds?: Maybe<Array<Scalars['ID']>>
  collectionType?: Maybe<CollectionTypeEnum>
  active?: Maybe<Scalars['Boolean']>
  activeAdminOnly?: Maybe<Scalars['Boolean']>
  image?: Maybe<Scalars['String']>
  childrenIds?: Maybe<Array<Scalars['ID']>>
  headerData?: Maybe<CollectionHeaderInput>
  storefrontBannerData?: Maybe<CollectionStorefrontBannerInput>
  subjectsData?: Maybe<Array<CollectionSubjectInput>>
}

export type MutationDayOfWeekVisibilityConditionCreateArgs = {
  dayOfWeekVisibilityConditionData: DayOfWeekInput
}

export type MutationDayOfWeekVisibilityConditionUpdateArgs = {
  dayOfWeekVisibilityConditionData: DayOfWeekInput
}

export type MutationEnterpriseAccountAccountSetupArgs = {
  rawToken: Scalars['String']
  password: Scalars['String']
  givenName?: Maybe<Scalars['String']>
  surname?: Maybe<Scalars['String']>
  phone?: Maybe<Scalars['String']>
}

export type MutationEnterpriseAccountAuthenticateEmailPasswordArgs = {
  email: Scalars['String']
  password: Scalars['String']
  reCaptchaToken?: Maybe<Scalars['String']>
}

export type MutationEnterpriseAccountAuthenticatePreflightArgs = {
  email: Scalars['String']
}

export type MutationEnterpriseAccountCreateArgs = {
  givenName: Scalars['String']
  surname: Scalars['String']
  phone?: Maybe<Scalars['String']>
  title?: Maybe<Scalars['String']>
  roleIds: Array<Scalars['ID']>
  partnerIds: Array<Scalars['ID']>
  retailerIds: Array<Scalars['ID']>
  retailerLocationIds: Array<Scalars['ID']>
  hasAllPartnersFullAccess: Scalars['Boolean']
  hasFullPartnerAccess: Scalars['Boolean']
  hasFullRetailerAccess: Scalars['Boolean']
  email: Scalars['String']
}

export type MutationEnterpriseAccountRequestAccountSetupEmailArgs = {
  email: Scalars['String']
  reCaptchaToken: Scalars['String']
}

export type MutationEnterpriseAccountRequestEmailVerificationArgs = {
  email: Scalars['String']
  reCaptchaToken: Scalars['String']
}

export type MutationEnterpriseAccountRequestPasswordResetArgs = {
  email: Scalars['String']
  reCaptchaToken: Scalars['String']
}

export type MutationEnterpriseAccountResetPasswordArgs = {
  rawToken: Scalars['String']
  password: Scalars['String']
}

export type MutationEnterpriseAccountSetDisabledArgs = {
  accountCanonicalId: Scalars['ID']
  value: Scalars['Boolean']
}

export type MutationEnterpriseAccountSignUpEmailPasswordArgs = {
  email: Scalars['String']
  password: Scalars['String']
  givenName?: Maybe<Scalars['String']>
  surname?: Maybe<Scalars['String']>
  phone?: Maybe<Scalars['String']>
  reCaptchaToken: Scalars['String']
}

export type MutationEnterpriseAccountUpdateArgs = {
  givenName: Scalars['String']
  surname: Scalars['String']
  phone?: Maybe<Scalars['String']>
  title?: Maybe<Scalars['String']>
  roleIds: Array<Scalars['ID']>
  partnerIds: Array<Scalars['ID']>
  retailerIds: Array<Scalars['ID']>
  retailerLocationIds: Array<Scalars['ID']>
  hasAllPartnersFullAccess: Scalars['Boolean']
  hasFullPartnerAccess: Scalars['Boolean']
  hasFullRetailerAccess: Scalars['Boolean']
  canonicalId: Scalars['ID']
}

export type MutationEnterpriseAccountVerifyEmailArgs = {
  rawToken: Scalars['String']
}

export type MutationExpressMembershipVisibilityConditionCreateArgs = {
  expressMembershipVisibilityConditionData: ExpressMembershipInput
}

export type MutationExpressMembershipVisibilityConditionUpdateArgs = {
  expressMembershipVisibilityConditionData: ExpressMembershipInput
}

export type MutationExpressNonmemberLongTermHoldoutVisibilityConditionCreateArgs = {
  expressNonmemberLongTermHoldoutVisibilityConditionData: ExpressNonmemberLongTermHoldoutInput
}

export type MutationFeatureTourUpdateArgs = {
  name: Scalars['String']
  status: Status
}

export type MutationHeroBannerPlacementCreateArgs = {
  heroBannerPlacementData: HeroBannerPlacementInput
}

export type MutationHeroBannerPlacementUpdateArgs = {
  id: Scalars['ID']
  bannerId: Scalars['ID']
  heroBannerPlacementData: HeroBannerPlacementInput
}

export type MutationImageForwardFlexPlacementCreateArgs = {
  imageForwardFlexPlacementData: ImageForwardFlexPlacementInput
}

export type MutationImageForwardFlexPlacementUpdateArgs = {
  id: Scalars['ID']
  bannerId: Scalars['ID']
  imageForwardFlexPlacementData: ImageForwardFlexPlacementInput
}

export type MutationImageForwardPlacementCreateArgs = {
  imageForwardPlacementData: ImageForwardPlacementInput
}

export type MutationImageForwardPlacementUpdateArgs = {
  id: Scalars['ID']
  bannerId: Scalars['ID']
  imageForwardPlacementData: ImageForwardPlacementInput
}

export type MutationMinimumPlatformVersionVisibilityConditionCreateArgs = {
  minimumPlatformVersionVisibilityConditionData: MinimumPlatformVersionInput
}

export type MutationMinimumPlatformVersionVisibilityConditionUpdateArgs = {
  minimumPlatformVersionVisibilityConditionData: MinimumPlatformVersionInput
}

export type MutationNormalizedReportsMergeArgs = {
  partnerId: Scalars['ID']
  retailerId: Scalars['ID']
  startDate: Scalars['ISO8601Date']
  endDate?: Maybe<Scalars['ISO8601Date']>
  reportType: MergeableReportTypeEnum
}

export type MutationNotificationSubscriptionCreateArgs = {
  retailerId: Scalars['ID']
  accountId: Scalars['ID']
  notificationTypeId: Scalars['ID']
}

export type MutationNotificationSubscriptionDeleteArgs = {
  retailerId: Scalars['ID']
  accountId: Scalars['ID']
  notificationTypeId: Scalars['ID']
}

export type MutationPartnerCallbackCreateArgs = {
  partnerId: Scalars['ID']
  orderId: Scalars['String']
  event: Scalars['String']
}

export type MutationPartnerPickDeviceCreateArgs = {
  warehouseLocationId: Scalars['ID']
  deviceType: DeviceTypeEnum
  firstName: Scalars['String']
  lastName: Scalars['String']
  email: Scalars['String']
  phone?: Maybe<Scalars['String']>
  password?: Maybe<Scalars['String']>
  isPartnerPickStoreManager: Scalars['Boolean']
}

export type MutationPartnerPickDeviceSetStatusArgs = {
  id: Scalars['ID']
  active: Scalars['Boolean']
}

export type MutationPartnerPickDeviceUpdateArgs = {
  id: Scalars['ID']
  warehouseLocationId?: Maybe<Scalars['ID']>
  deviceType?: Maybe<DeviceTypeEnum>
  firstName?: Maybe<Scalars['String']>
  lastName?: Maybe<Scalars['String']>
  email?: Maybe<Scalars['String']>
  phone?: Maybe<Scalars['String']>
  password?: Maybe<Scalars['String']>
  isPartnerPickStoreManager?: Maybe<Scalars['Boolean']>
}

export type MutationPartnerPickRecurringShiftCreateArgs = {
  driverId: Scalars['ID']
  warehouseLocationId: Scalars['ID']
  shiftType: ShiftTypeEnum
  daysOfWeek: Array<Scalars['Int']>
  shiftStartSecondsSinceMidnight: Scalars['Int']
  shiftLengthSeconds: Scalars['Int']
  recurStartDate: Scalars['String']
  recurEndDate?: Maybe<Scalars['String']>
  onCall?: Maybe<Scalars['Boolean']>
}

export type MutationPartnerPickRecurringShiftDeleteArgs = {
  id: Scalars['ID']
  deleteShiftsFromDate: Scalars['String']
}

export type MutationPartnerPickRecurringShiftUpdateArgs = {
  id: Scalars['ID']
  daysOfWeek?: Maybe<Array<Scalars['Int']>>
  shiftStartSecondsSinceMidnight?: Maybe<Scalars['Int']>
  shiftLengthSeconds?: Maybe<Scalars['Int']>
  recurStartDate?: Maybe<Scalars['String']>
  recurEndDate?: Maybe<Scalars['String']>
  onCall?: Maybe<Scalars['Boolean']>
}

export type MutationReportRequestCreateArgs = {
  name: Scalars['String']
  reportId: Scalars['ID']
  associatedObjectId: Scalars['ID']
  associatedObjectType: ReportRequestAssociatedObjectTypeEnum
  filters?: Maybe<ReportFilters>
}

export type MutationRetailerLocationGroupCreateArgs = {
  name: Scalars['String']
  retailerId: Scalars['ID']
  retailerLocationIds?: Maybe<Array<Scalars['ID']>>
}

export type MutationRetailerLocationGroupDeleteArgs = {
  id: Scalars['ID']
}

export type MutationRetailerLocationGroupUpdateArgs = {
  id: Scalars['ID']
  name?: Maybe<Scalars['String']>
  retailerLocationIds?: Maybe<Array<Scalars['ID']>>
}

export type MutationSandboxOrderSimulateEventArgs = {
  orderId: Scalars['String']
  partnerId: Scalars['String']
  simulationEvent: Scalars['String']
  simulationEventArgs?: Maybe<Array<Scalars['String']>>
  callbackEvent?: Maybe<Scalars['String']>
}

export type MutationSecondaryBannerPlacementCreateArgs = {
  secondaryBannerPlacementData: SecondaryBannerPlacementInput
}

export type MutationSecondaryBannerPlacementUpdateArgs = {
  id: Scalars['ID']
  bannerId: Scalars['ID']
  secondaryBannerPlacementData: SecondaryBannerPlacementInput
}

export type MutationShoppedAtRetailerVisibilityConditionCreateArgs = {
  shoppedAtRetailerVisibilityConditionData: ShoppedAtRetailerInput
}

export type MutationShoppedAtRetailerVisibilityConditionUpdateArgs = {
  shoppedAtRetailerVisibilityConditionData: ShoppedAtRetailerInput
}

export type MutationShoppedVisibilityConditionCreateArgs = {
  shoppedVisibilityConditionData: ShoppedInput
}

export type MutationShoppedVisibilityConditionUpdateArgs = {
  shoppedVisibilityConditionData: ShoppedInput
}

export type MutationStorefrontPlacementCreateArgs = {
  retailerId: Scalars['ID']
  storefrontPlacementData: StorefrontPlacementInput
}

export type MutationStorefrontPlacementDeleteArgs = {
  id: Scalars['ID']
  retailerId: Scalars['ID']
}

export type MutationStorefrontPlacementUpdateArgs = {
  id: Scalars['ID']
  retailerId: Scalars['ID']
  bannerId: Scalars['ID']
  storefrontPlacementData: StorefrontPlacementInput
}

export type MutationTextWithThumbnailFlexPlacementCreateArgs = {
  textWithThumbnailFlexPlacementData: TextWithThumbnailFlexPlacementInput
}

export type MutationTextWithThumbnailFlexPlacementUpdateArgs = {
  id: Scalars['ID']
  bannerId: Scalars['ID']
  textWithThumbnailFlexPlacementData: TextWithThumbnailFlexPlacementInput
}

export type MutationTextWithThumbnailPlacementCreateArgs = {
  textWithThumbnailPlacementData: TextWithThumbnailPlacementInput
}

export type MutationTextWithThumbnailPlacementUpdateArgs = {
  id: Scalars['ID']
  bannerId: Scalars['ID']
  textWithThumbnailPlacementData: TextWithThumbnailPlacementInput
}

export type MutationVisibilityConditionDeleteArgs = {
  id: Scalars['ID']
}

export type MutationWhitelistedPostalCodesVisibilityConditionCreateArgs = {
  whitelistedPostalCodesVisibilityConditionData: WhitelistedPostalCodesInput
}

export type MutationWhitelistedPostalCodesVisibilityConditionUpdateArgs = {
  whitelistedPostalCodesVisibilityConditionData: WhitelistedPostalCodesInput
}

export type MutationWizardProgressUpdateArgs = {
  id: Scalars['ID']
  complete?: Maybe<Scalars['Boolean']>
}

export type NavigateToCategorySurface = {
  __typename?: 'NavigateToCategorySurface'
  categorySurfaceType: Maybe<CategorySurfaceType>
}

export type NavigateToCategorySurfaceInput = {
  categorySurfaceType?: Maybe<CategorySurfaceType>
}

export type NavigateToCollection = {
  __typename?: 'NavigateToCollection'
  slug: Maybe<Scalars['String']>
  legacyPath: Maybe<Scalars['String']>
}

export type NavigateToCollectionHub = {
  __typename?: 'NavigateToCollectionHub'
  category: Maybe<Scalars['String']>
}

export type NavigateToCollectionHubInput = {
  category?: Maybe<Scalars['String']>
}

export type NavigateToCollectionInput = {
  slug?: Maybe<Scalars['String']>
  legacyPath?: Maybe<Scalars['String']>
}

export type NavigateToContainerPathViaStoreSelector = {
  __typename?: 'NavigateToContainerPathViaStoreSelector'
  retailers: Maybe<Array<Maybe<RetailerContainerPath>>>
}

export type NavigateToContainerPathViaStoreSelectorInput = {
  retailers?: Maybe<Array<Maybe<RetailerContainerPathInput>>>
}

export type NavigateToCouponRedemption = {
  __typename?: 'NavigateToCouponRedemption'
  couponCode: Maybe<Scalars['String']>
  validateDays: Maybe<Scalars['BigInt']>
  visibleAfterRedeem: Maybe<Scalars['Boolean']>
  landingUrl: Maybe<Scalars['String']>
}

export type NavigateToCouponRedemptionInput = {
  couponCode?: Maybe<Scalars['String']>
  validateDays?: Maybe<Scalars['BigInt']>
  visibleAfterRedeem?: Maybe<Scalars['Boolean']>
  landingUrl?: Maybe<Scalars['String']>
}

export type NavigateToDepartment = {
  __typename?: 'NavigateToDepartment'
  departmentId: Maybe<Scalars['BigInt']>
}

export type NavigateToDepartmentInput = {
  departmentId?: Maybe<Scalars['BigInt']>
}

export type NavigateToPickupStoreSelector = {
  __typename?: 'NavigateToPickupStoreSelector'
  showDistance: Maybe<Scalars['Boolean']>
}

export type NavigateToPickupStoreSelectorInput = {
  showDistance?: Maybe<Scalars['Boolean']>
}

export type NavigateToProduct = {
  __typename?: 'NavigateToProduct'
  productId: Maybe<Scalars['BigInt']>
}

export type NavigateToProductInput = {
  productId?: Maybe<Scalars['BigInt']>
}

export type NavigateToPromoModal = {
  __typename?: 'NavigateToPromoModal'
  discountPolicyId: Maybe<Scalars['BigInt']>
}

export type NavigateToPromoModalInput = {
  discountPolicyId?: Maybe<Scalars['BigInt']>
}

export type NavigateToRetailerCollection = {
  __typename?: 'NavigateToRetailerCollection'
  retailerId: Maybe<Scalars['BigInt']>
  slug: Maybe<Scalars['String']>
}

export type NavigateToRetailerCollectionInput = {
  retailerId?: Maybe<Scalars['BigInt']>
  slug?: Maybe<Scalars['String']>
}

export type NavigateToRetailerCollectionViaStoreSelector = {
  __typename?: 'NavigateToRetailerCollectionViaStoreSelector'
  retailerCollections: Maybe<Array<Maybe<RetailerCollection>>>
}

export type NavigateToRetailerCollectionViaStoreSelectorInput = {
  retailerCollections?: Maybe<Array<Maybe<RetailerCollectionInput>>>
}

export type NavigateToSsaStoreSelector = {
  __typename?: 'NavigateToSsaStoreSelector'
  serviceAreaType: Maybe<Scalars['String']>
}

export type NavigateToSsaStoreSelectorInput = {
  serviceAreaType?: Maybe<Scalars['String']>
}

export type NavigateToStorefront = {
  __typename?: 'NavigateToStorefront'
  retailerId: Maybe<Scalars['BigInt']>
}

export type NavigateToStorefrontInput = {
  retailerId?: Maybe<Scalars['BigInt']>
}

export type NavigateToStoreSelector = {
  __typename?: 'NavigateToStoreSelector'
  retailerIds: Maybe<Array<Maybe<Scalars['BigInt']>>>
}

export type NavigateToStoreSelectorInput = {
  retailerIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>
}

export type NavigateToUrl = {
  __typename?: 'NavigateToUrl'
  url: Maybe<Scalars['String']>
  openInNewTab: Maybe<Scalars['Boolean']>
}

export type NavigateToUrlInput = {
  url?: Maybe<Scalars['String']>
  openInNewTab?: Maybe<Scalars['Boolean']>
}

/** Autogenerated return type of NormalizedReportsMerge */
export type NormalizedReportsMergePayload = {
  __typename?: 'NormalizedReportsMergePayload'
  /** Merge successful */
  success: Scalars['Boolean']
}

export type NormalizedReportsNormalizedReport = {
  __typename?: 'NormalizedReportsNormalizedReport'
  /** Name of the bucket where the report comes from */
  bucketName: Scalars['String']
  /** Date at which the report was created in YYYY-MM-DD format */
  createdAt: Scalars['Time']
  /** Type of the file */
  fileType: Scalars['String']
  /** Name of the file */
  name: Scalars['String']
  /** Type of the report */
  reportType: ReportTypeEnum
  /** File path to the object in the bucket */
  s3Key: Scalars['String']
  /** Size in bytes of the object */
  size: Scalars['Int']
}

/** The connection type for NormalizedReportsNormalizedReport. */
export type NormalizedReportsNormalizedReportConnection = {
  __typename?: 'NormalizedReportsNormalizedReportConnection'
  /** A list of edges. */
  edges: Maybe<Array<Maybe<NormalizedReportsNormalizedReportEdge>>>
  /** Metadata regarding the connection */
  meta: ConnectionMeta
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<NormalizedReportsNormalizedReport>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type NormalizedReportsNormalizedReportEdge = {
  __typename?: 'NormalizedReportsNormalizedReportEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: Maybe<NormalizedReportsNormalizedReport>
}

export type NormalizedReportsNormalizedReportSignedUrl = {
  __typename?: 'NormalizedReportsNormalizedReportSignedUrl'
  /** Signed url for the object */
  signedUrl: Scalars['String']
}

export type NormalizedReportsReportType = {
  __typename?: 'NormalizedReportsReportType'
  /** Report type label */
  label: Scalars['String']
  /** The report type value */
  value: ReportTypeEnum
}

export type NotificationsNotificationType = {
  __typename?: 'NotificationsNotificationType'
  /** Description of notification type, ie: Inventory File Normalization */
  description: Maybe<Scalars['String']>
  id: Scalars['ID']
  /** If the user making the request is eligible to subscribe to this notification */
  isEligible: Scalars['Boolean']
  /** If the user making the request is subscribed to the notification type for the specified retailer */
  isSubscribed: Scalars['Boolean']
  /** Name of notification type, ie: Inventory File Normalization */
  name: Scalars['String']
}

export type NotificationsNotificationTypeAccount = {
  __typename?: 'NotificationsNotificationTypeAccount'
  /** Account ID of user */
  accountId: Scalars['ID']
  /** Email of user */
  email: Scalars['ID']
  /** Given name of user */
  givenName: Scalars['String']
  /** If the user is eligible to subscribe to this notification */
  isEligible: Scalars['Boolean']
  /** If the user is subscribed to the notification type for the specified retailer */
  isSubscribed: Scalars['Boolean']
  /** Surname of user */
  surname: Maybe<Scalars['String']>
}

/** Autogenerated return type of NotificationSubscriptionCreate */
export type NotificationSubscriptionCreatePayload = {
  __typename?: 'NotificationSubscriptionCreatePayload'
  /** Subsription successful */
  success: Scalars['Boolean']
}

/** Autogenerated return type of NotificationSubscriptionDelete */
export type NotificationSubscriptionDeletePayload = {
  __typename?: 'NotificationSubscriptionDeletePayload'
  /** Unsubscribe successful */
  success: Scalars['Boolean']
}

export type Order = {
  __typename?: 'Order'
  id: Maybe<Scalars['BigInt']>
  legacyOrderId: Maybe<Scalars['BigInt']>
  orderReference: Maybe<Scalars['String']>
  retailerReferenceId: Maybe<Scalars['String']>
  clientConfigurationId: Maybe<Scalars['BigInt']>
  creationDate: Maybe<Scalars['DateTime']>
  userId: Maybe<Scalars['BigInt']>
  shoppedRetailerLocationId: Maybe<Scalars['BigInt']>
  closestRetailerLocationId: Maybe<Scalars['BigInt']>
  checkoutRetailerLocationId: Maybe<Scalars['BigInt']>
  fulfillmentWindow: Maybe<OrderFulfillmentWindow>
  workflowState: Maybe<WorkflowState>
  fulfillmentType: Maybe<InstacartCustomersSharedV1FulfillmentTypeWrapperFulfillmentType>
  retailerId: Maybe<Scalars['BigInt']>
  zoneId: Maybe<Scalars['BigInt']>
  customerOrderNumber: Maybe<Scalars['BigInt']>
  communicationLocale: Maybe<Scalars['String']>
  shopperOriginatedData: Maybe<ShopperOriginatedData>
  retailerExternalOrderId: Maybe<Scalars['String']>
  loyaltyNumber: Maybe<Scalars['String']>
  storeConfigurationId: Maybe<Scalars['BigInt']>
  userBirthday: Maybe<GoogleTypeDate>
  countryId: Maybe<Scalars['BigInt']>
  serviceOptionId: Maybe<Scalars['BigInt']>
  expressSubscriptionId: Maybe<Scalars['BigInt']>
  plannedDeliveryStartedAt: Maybe<Scalars['DateTime']>
  plannedDeliveredAt: Maybe<Scalars['DateTime']>
}

export enum OrderBy {
  Default = 'DEFAULT',
  Total = 'TOTAL',
  Growth = 'GROWTH',
  GrowthPercentage = 'GROWTH_PERCENTAGE',
}

export enum OrderDirection {
  None = 'NONE',
  Asc = 'ASC',
  Desc = 'DESC',
}

export type OrderFulfillmentWindow = {
  __typename?: 'OrderFulfillmentWindow'
  windowStart: Maybe<Scalars['DateTime']>
  windowEnd: Maybe<Scalars['DateTime']>
}

export enum OrderStatusCriteria {
  OrderStatusCriteriaUnspecified = 'ORDER_STATUS_CRITERIA_UNSPECIFIED',
  New = 'NEW',
  InProgress = 'IN_PROGRESS',
  Complete = 'COMPLETE',
  Canceled = 'CANCELED',
}

export type OrderSummary = {
  __typename?: 'OrderSummary'
  id: Maybe<Scalars['BigInt']>
  legacyOrderId: Maybe<Scalars['BigInt']>
  orderReference: Maybe<Scalars['String']>
  externalId: Maybe<Scalars['String']>
  fulfillmentDate: Maybe<Scalars['DateTime']>
  creationDate: Maybe<Scalars['DateTime']>
  userId: Maybe<Scalars['BigInt']>
  totalAmount: Maybe<GoogleTypeMoney>
  retailerLocationId: Maybe<Scalars['BigInt']>
  workflowState: Maybe<WorkflowState>
  fulfillmentType: Maybe<InstacartCustomersSharedV1FulfillmentTypeWrapperFulfillmentType>
}

export type OverrideHours = {
  __typename?: 'OverrideHours'
  date: Maybe<GoogleTypeDate>
  serviceType: Maybe<RetailerServiceType>
  startTime: Maybe<GoogleTypeTimeOfDay>
  endTime: Maybe<GoogleTypeTimeOfDay>
  description: Maybe<Scalars['String']>
}

export type OverrideHoursInput = {
  date?: Maybe<GoogleTypeDateInput>
  serviceType?: Maybe<RetailerServiceType>
  startTime?: Maybe<GoogleTypeTimeOfDayInput>
  endTime?: Maybe<GoogleTypeTimeOfDayInput>
  description?: Maybe<Scalars['String']>
}

export enum OverrideType {
  OverrideTypeUnknown = 'OVERRIDE_TYPE_UNKNOWN',
  OverrideTypeReplace = 'OVERRIDE_TYPE_REPLACE',
  OverrideTypeExclude = 'OVERRIDE_TYPE_EXCLUDE',
}

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo'
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']>
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']>
}

export type PaginationInput = {
  limit?: Maybe<GoogleProtobufUInt64ValueInput>
  offset?: Maybe<GoogleProtobufUInt64ValueInput>
}

export type Partner = {
  __typename?: 'Partner'
  /** The callback configurations belonging to this partner */
  callbackConfigurations: Maybe<Array<PartnerCallbackConfiguration>>
  /** The client configuration belonging to this partner if it exists */
  clientConfiguration: Maybe<PartnerClientConfiguration>
  /** A unique identifier for the partner */
  id: Scalars['ID']
  /** The name of the partner */
  name: Scalars['String']
  /** The retailers belonging to this partner */
  retailers: Array<Retailer>
  /** A sandbox order belonging to the partner */
  sandboxOrder: Maybe<PartnerSandboxOrder>
}

export type PartnerSandboxOrderArgs = {
  id: Scalars['String']
}

export type PartnerCallbackConfiguration = {
  __typename?: 'PartnerCallbackConfiguration'
  /** The access token TTL */
  accessTokenTtl: Scalars['Int']
  /** The authentication URI */
  authUri: Scalars['String']
  /** The possible statuses to enable */
  availableStatuses: Array<Scalars['String']>
  /** The callback URI */
  callbackUri: Scalars['String']
  /** The client id */
  credentialsClientId: Scalars['String']
  /** The client credentials_client_secret */
  credentialsClientSecret: Scalars['String']
  /** The environment that the configuration belongs to */
  environment: Scalars['String']
  /** A unique identifier for the callback configuration */
  id: Scalars['ID']
  /** The enabled statusers */
  statusesOfInterest: Array<Scalars['String']>
}

/** Autogenerated return type of PartnerCallbackConfigurationUpdate */
export type PartnerCallbackConfigurationUpdatePayload = {
  __typename?: 'PartnerCallbackConfigurationUpdatePayload'
  /** The updated callback configuration */
  callbackConfiguration: PartnerCallbackConfiguration
}

/** Autogenerated return type of PartnerCallbackCreate */
export type PartnerCallbackCreatePayload = {
  __typename?: 'PartnerCallbackCreatePayload'
  /** The response(s) from the callback */
  callbackResponse: Array<PartnerCallbackResponse>
}

export type PartnerCallbackResponse = {
  __typename?: 'PartnerCallbackResponse'
  /** The body that was sent */
  body: Scalars['String']
  /** The headers that were sent */
  headers: Scalars['String']
  /** The type of the notification log */
  logType: Scalars['String']
  /** The response body */
  responseBody: Scalars['String']
  /** The response code */
  responseCode: Scalars['String']
  /** The time when the callback was sent */
  timestamp: Scalars['String']
  /** The url the callback was sent to */
  url: Scalars['String']
}

export type PartnerClientConfiguration = {
  __typename?: 'PartnerClientConfiguration'
  /** Does the partner have access to project shield */
  accessProjectShield: Scalars['String']
}

/** The connection type for Partner. */
export type PartnerConnection = {
  __typename?: 'PartnerConnection'
  /** A list of edges. */
  edges: Maybe<Array<Maybe<PartnerEdge>>>
  /** Metadata regarding the connection */
  meta: ConnectionMeta
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Partner>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type PartnerEdge = {
  __typename?: 'PartnerEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: Maybe<Partner>
}

export type PartnerPickCapacityGetCapacityRecommendationsResponse = {
  __typename?: 'PartnerPickCapacityGetCapacityRecommendationsResponse'
  allowedRecommendationTypes: Array<RecommendationTypeEnum>
  recommendations: Array<PartnerPickCapacityRecommendation>
}

export type PartnerPickCapacityRecommendation = {
  __typename?: 'PartnerPickCapacityRecommendation'
  date: Scalars['ISO8601Date']
  endsAt: Scalars['ISO8601DateTime']
  id: Scalars['ID']
  recommendationType: RecommendationTypeEnum
  retailerLocationId: Scalars['ID']
  shiftType: ShiftTypeEnum
  startsAt: Scalars['ISO8601DateTime']
}

/** Autogenerated return type of PartnerPickDeviceCreate */
export type PartnerPickDeviceCreatePayload = {
  __typename?: 'PartnerPickDeviceCreatePayload'
  /** The newly created device */
  partnerPickDevice: PartnerPickDevicesDevice
}

export type PartnerPickDevicesDevice = {
  __typename?: 'PartnerPickDevicesDevice'
  /** Status for the device */
  active: Scalars['Boolean']
  /** Type of device */
  deviceType: DeviceTypeEnum
  /** Email address for the device */
  email: Scalars['String']
  /** First name for the device */
  firstName: Scalars['String']
  /** A unique identifier for the device */
  id: Scalars['ID']
  /** Whether the device belongs to a store manager */
  isPartnerPickStoreManager: Scalars['Boolean']
  /** Last name for the device */
  lastName: Scalars['String']
  /** marqeta cards metatdata for the device */
  marqetaCardsMetadata: Maybe<PartnerPickDevicesMarqetaCardsMetadata>
  /** Phone number for the device */
  phone: Scalars['String']
}

export type PartnerPickDevicesDeviceSearch = {
  __typename?: 'PartnerPickDevicesDeviceSearch'
  devices: Array<PartnerPickDevicesDevice>
  meta: HubPaginationMeta
}

/** Autogenerated return type of PartnerPickDeviceSetStatus */
export type PartnerPickDeviceSetStatusPayload = {
  __typename?: 'PartnerPickDeviceSetStatusPayload'
  /** The updated device */
  partnerPickDevice: PartnerPickDevicesDevice
}

export type PartnerPickDevicesMarqetaCardsMetadata = {
  __typename?: 'PartnerPickDevicesMarqetaCardsMetadata'
  digital: Maybe<Scalars['Int']>
  inactive: Maybe<Scalars['Int']>
  physical: Maybe<Scalars['Int']>
  suspended: Maybe<Scalars['Int']>
  terminated: Maybe<Scalars['Int']>
}

/** Autogenerated return type of PartnerPickDeviceUpdate */
export type PartnerPickDeviceUpdatePayload = {
  __typename?: 'PartnerPickDeviceUpdatePayload'
  /** The updated device */
  partnerPickDevice: PartnerPickDevicesDevice
}

/** Autogenerated return type of PartnerPickRecurringShiftCreate */
export type PartnerPickRecurringShiftCreatePayload = {
  __typename?: 'PartnerPickRecurringShiftCreatePayload'
  /** The newly created recurring shift */
  partnerPickRecurringShift: PartnerPickRecurringShiftsRecurringShift
}

/** Autogenerated return type of PartnerPickRecurringShiftDelete */
export type PartnerPickRecurringShiftDeletePayload = {
  __typename?: 'PartnerPickRecurringShiftDeletePayload'
  errorMessage: Maybe<Scalars['String']>
  /** Whether the deletion succeeded or not */
  success: Scalars['True']
}

export type PartnerPickRecurringShiftsConflict = {
  __typename?: 'PartnerPickRecurringShiftsConflict'
  recurringShiftConflicts: Array<PartnerPickRecurringShiftsRecurringShiftConflict>
  singleShiftConflicts: Array<PartnerPickRecurringShiftsSingleShiftConflict>
}

export type PartnerPickRecurringShiftsRecurringShift = {
  __typename?: 'PartnerPickRecurringShiftsRecurringShift'
  /** an array of Ruby Date wday that a shift recurs on (0-6, Sunday is zero) */
  daysOfWeek: Array<Scalars['Int']>
  driverId: Scalars['ID']
  driverShiftId: Maybe<Scalars['ID']>
  id: Scalars['ID']
  onCall: Maybe<Scalars['Boolean']>
  recurEndDate: Maybe<Scalars['ISO8601Date']>
  recurStartDate: Maybe<Scalars['ISO8601Date']>
  shiftLengthSeconds: Scalars['Int']
  shiftStartSecondsSinceMidnight: Scalars['Int']
  shiftType: ShiftTypeEnum
}

export type PartnerPickRecurringShiftsRecurringShiftConflict = {
  __typename?: 'PartnerPickRecurringShiftsRecurringShiftConflict'
  /** Days of the week when a shift occurs, represented as an Int (0-6). Sunday is 0 */
  daysOfWeek: Array<Scalars['Int']>
  id: Scalars['ID']
  shiftLengthSeconds: Scalars['Int']
  shiftStartSecondsSinceMidnight: Scalars['Int']
  shiftType: ShiftTypeEnum
}

export type PartnerPickRecurringShiftsSingleShiftConflict = {
  __typename?: 'PartnerPickRecurringShiftsSingleShiftConflict'
  date: Scalars['ISO8601Date']
  endsAt: Scalars['ISO8601DateTime']
  id: Scalars['ID']
  shiftType: ShiftTypeEnum
  startsAt: Scalars['ISO8601DateTime']
}

/** Autogenerated return type of PartnerPickRecurringShiftUpdate */
export type PartnerPickRecurringShiftUpdatePayload = {
  __typename?: 'PartnerPickRecurringShiftUpdatePayload'
  /** The updated recurring shift */
  partnerPickRecurringShift: PartnerPickRecurringShiftsRecurringShift
}

export type PartnerSandboxOrder = {
  __typename?: 'PartnerSandboxOrder'
  /** The logs from callback attempts for the sandbox order */
  callbackLogs: Maybe<Array<PartnerSandboxOrderCallbackLog>>
  /** Timestamp when the sandbox order was created */
  createdAt: Scalars['String']
  /** Timestamp when the sandbox order was delivered */
  deliveredAt: Maybe<Scalars['String']>
  /** A unique identifier for the sandbox order */
  id: Scalars['ID']
  /** Items within the sandbox order */
  items: Array<PartnerSandboxOrderItem>
  /** Events that can be simulated on this order */
  simulationEvents: Array<PartnerSandboxOrderSimulationEvent>
  /** The fulfillment status of the sandbox order */
  status: Scalars['String']
  /** Timestamp when the sandbox order delivery window ends */
  windowEndsAt: Scalars['String']
  /** Timestamp when the sandbox order delivery window starts */
  windowStartsAt: Scalars['String']
}

export type PartnerSandboxOrderCallbackLog = {
  __typename?: 'PartnerSandboxOrderCallbackLog'
  /** The event that the callback is for */
  event: Scalars['String']
  /** The response for the callback */
  logs: Maybe<Array<PartnerCallbackResponse>>
}

export type PartnerSandboxOrderItem = {
  __typename?: 'PartnerSandboxOrderItem'
  /** Retailer reference code to identify the item */
  itemRrc: Maybe<Scalars['String']>
  /** Universal product code to identify the item */
  itemUpc: Maybe<Scalars['String']>
  /** The unique line number decided by the partner */
  lineNum: Scalars['String']
  /** The quantity of items for the order */
  qty: Scalars['Float']
  /** The quantity unit the quantity value is in */
  qtyUnit: Scalars['String']
  /** Whether or not this item was replaced during fulfillment */
  replaced: Scalars['Boolean']
}

/** Autogenerated return type of PartnerSandboxOrderSimulateEvent */
export type PartnerSandboxOrderSimulateEventPayload = {
  __typename?: 'PartnerSandboxOrderSimulateEventPayload'
  /** The order that went through simulation */
  sandboxOrder: PartnerSandboxOrder
}

export type PartnerSandboxOrderSimulationEvent = {
  __typename?: 'PartnerSandboxOrderSimulationEvent'
  /** Arguments required when simulating this event */
  arguments: Array<Scalars['String']>
  /** The name of this simulation event */
  event: Scalars['String']
  /** The ID of the sandbox order these simulation events belong to */
  orderId: Scalars['String']
  /** The result when this event is simulated */
  outcome: PartnerSandboxOrderSimulationEventOutcome
}

export type PartnerSandboxOrderSimulationEventOutcome = {
  __typename?: 'PartnerSandboxOrderSimulationEventOutcome'
  /** A callback that will be triggered when the event is simulated */
  callback: Maybe<Scalars['String']>
  /** The status the order will be when the event is simulated */
  orderStatus: Scalars['String']
}

export enum PickingModelEnum {
  /** Partner managed */
  Retailer = 'RETAILER',
  /** Full service shoppers */
  FullService = 'FULL_SERVICE',
  /** In store shoppers */
  Iss = 'ISS',
}

export enum PickupType {
  PickupTypeUnknown = 'PICKUP_TYPE_UNKNOWN',
  PickupTypeInStore = 'PICKUP_TYPE_IN_STORE',
  PickupTypeCurbside = 'PICKUP_TYPE_CURBSIDE',
}

export type Placement = {
  __typename?: 'Placement'
  id: Maybe<Scalars['BigInt']>
  platform: Maybe<Array<Maybe<PlatformType>>>
  startDate: Maybe<Scalars['DateTime']>
  endDate: Maybe<Scalars['DateTime']>
  createdAt: Maybe<Scalars['DateTime']>
  updatedAt: Maybe<Scalars['DateTime']>
  retailerId: Maybe<Scalars['BigInt']>
  type: Maybe<Scalars['String']>
  internalName: Maybe<Scalars['String']>
  banner: Maybe<BannerType>
  status: Maybe<Status>
  timezone: Maybe<Scalars['String']>
  layout: Maybe<Layout>
  teamOwner: Maybe<Scalars['String']>
  userOwner: Maybe<Scalars['BigInt']>
  rank: Maybe<Scalars['BigInt']>
  experimentName: Maybe<Scalars['String']>
  experimentVariant: Maybe<Scalars['String']>
  experimentMethod: Maybe<ExperimentMethod>
  enabled: Maybe<Scalars['Boolean']>
  banners: Maybe<Array<Maybe<BannerType>>>
  cardList: Maybe<CardList>
}

export type PlacementDestinationInput = {
  /** What the corresponding target refers to */
  type: PlacementDestinationTypeEnum
  /** The target destination of interacting with the placement. Can be an ID of a product/collection/department, or a URL */
  target: Scalars['String']
}

export enum PlacementDestinationTypeEnum {
  /** The placement links to an external url */
  External = 'EXTERNAL',
  /** The placement links to a product */
  Product = 'PRODUCT',
  /** The placement links to a collection */
  Collection = 'COLLECTION',
  /** The placement links to a collection hub */
  CollectionHub = 'COLLECTION_HUB',
  /** The placement links to a department */
  Department = 'DEPARTMENT',
  /** The placement links to a storefront */
  Storefront = 'STOREFRONT',
  /** The placement links to a store selector */
  StoreSelector = 'STORE_SELECTOR',
  /** The placement links to the pickup store selector */
  PickupStoreselector = 'PICKUP_STORESELECTOR',
  /** The placement links to the SSA store selector */
  SsaStoreselector = 'SSA_STORESELECTOR',
  /** The placement links to containers via a store selector */
  ContainerPathViaStoreSelector = 'CONTAINER_PATH_VIA_STORE_SELECTOR',
  /** The placement does not have an action */
  DoNotNavigate = 'DO_NOT_NAVIGATE',
  /** Unfamiliar Banner Action */
  Unknown = 'UNKNOWN',
}

export type PlacementExperimentInput = {
  /** Name of the Experiment */
  name: Scalars['String']
  /** Variant of the Experiment for which placement should be visible */
  variant: Scalars['String']
  /** Experiment Assignment or Lookup */
  accessMethod?: Maybe<PlacementExperimentMethodEnum>
}

export enum PlacementExperimentMethodEnum {
  /** Not specified */
  ExperimentMethodUnspecified = 'EXPERIMENT_METHOD_UNSPECIFIED',
  /** Whether variant assignment should happen */
  Assign = 'ASSIGN',
  /** Whether a variant lookup should occur */
  Lookup = 'LOOKUP',
  /** Whether a variant preview should occur */
  Preview = 'PREVIEW',
}

export type PlacementFilterInput = {
  /** A term to use to search for a placement */
  searchTerm?: Maybe<Scalars['String']>
  /** The platform(s) the placement is configured for (Eg. [MOBILE, WEB]) */
  platform?: Maybe<Array<PlacementPlatformEnum>>
  /** The current status of the placement (Eg. ACTIVE) */
  status?: Maybe<PlacementStatusEnum>
  /** The type of the placement (Eg. TEXT) */
  type?: Maybe<PlacementTypeEnum>
}

export type PlacementImagesInput = {
  /** The image url of the placement to display for large viewports */
  large: Scalars['Url']
  /** The image url of the placement to display for small viewports */
  small: Scalars['Url']
}

export type PlacementInput = {
  id?: Maybe<Scalars['BigInt']>
  platform?: Maybe<Array<Maybe<PlatformType>>>
  startDate?: Maybe<Scalars['DateTime']>
  endDate?: Maybe<Scalars['DateTime']>
  createdAt?: Maybe<Scalars['DateTime']>
  updatedAt?: Maybe<Scalars['DateTime']>
  retailerId?: Maybe<Scalars['BigInt']>
  type?: Maybe<Scalars['String']>
  internalName?: Maybe<Scalars['String']>
  banner?: Maybe<BannerTypeInput>
  status?: Maybe<Status>
  timezone?: Maybe<Scalars['String']>
  layout?: Maybe<Layout>
  teamOwner?: Maybe<Scalars['String']>
  userOwner?: Maybe<Scalars['BigInt']>
  rank?: Maybe<Scalars['BigInt']>
  experimentName?: Maybe<Scalars['String']>
  experimentVariant?: Maybe<Scalars['String']>
  experimentMethod?: Maybe<ExperimentMethod>
  enabled?: Maybe<Scalars['Boolean']>
  banners?: Maybe<Array<Maybe<BannerTypeInput>>>
  cardList?: Maybe<CardListInput>
}

export enum PlacementPlatformEnum {
  /** This placement should display on mobile */
  Mobile = 'MOBILE',
  /** This placement should display on web */
  Web = 'WEB',
  /** This placement should display on ios */
  Ios = 'IOS',
  /** This placement should display on android */
  Android = 'ANDROID',
}

export type PlacementScheduleInput = {
  /** When the placement should become active */
  startDate: Scalars['Time']
  /** When the placement should stop being active */
  endDate?: Maybe<Scalars['Time']>
  /** The timezone in which the banner will stop being active at midnight */
  timezone: Scalars['String']
}

export type PlacementSortInput = {
  /** The field to sort on */
  field: PlacementSortInputFieldEnum
  /** The direction to sort */
  direction?: Maybe<PlacementSortInputDirectionEnum>
}

export enum PlacementSortInputDirectionEnum {
  /** Sort the results in ascending order */
  Asc = 'ASC',
  /** Sort the results in descending order */
  Desc = 'DESC',
}

export enum PlacementSortInputFieldEnum {
  /** Sort the results based on the status of the placement */
  Status = 'STATUS',
  /** Sort the results based on the status of the placement */
  CreatedAt = 'CREATED_AT',
}

export type PlacementsResponse = {
  __typename?: 'PlacementsResponse'
  placements: Maybe<Array<Maybe<Placement>>>
}

export enum PlacementStatusEnum {
  /** The placement is currently active */
  Active = 'ACTIVE',
  /** The placement is not currently active */
  Inactive = 'INACTIVE',
  /** The placement is currently the live banner */
  Live = 'LIVE',
}

export enum PlacementTypeEnum {
  /** This placement displays an image */
  Image = 'IMAGE',
  /** This placement displays text */
  Text = 'TEXT',
  /** This placement displays a TextWithThumbnail Home Announcement Banner */
  TextWithThumbnail = 'TEXT_WITH_THUMBNAIL',
  /** This placement displays an ImageForward Home Announcement Banner */
  ImageForward = 'IMAGE_FORWARD',
  /** This placement displays an ImageForward Home Announcement Banner */
  Unknown = 'UNKNOWN',
  /** This placement displays a TextWithThumbnailFlex Home Announcement Banner */
  TextWithThumbnailFlex = 'TEXT_WITH_THUMBNAIL_FLEX',
  /** This placement displays a ImageForwardFlex Home Announcement Banner */
  ImageForwardFlex = 'IMAGE_FORWARD_FLEX',
  /** This placement displays a HeroBanner Home Announcement Banner */
  HeroBanner = 'HERO_BANNER',
  /** This placement displays a SecondaryBanner Home Announcement Banner */
  SecondaryBanner = 'SECONDARY_BANNER',
}

export enum PlatformType {
  Web = 'WEB',
  Mobile = 'MOBILE',
  Ios = 'IOS',
  Android = 'ANDROID',
}

export type ProductCategoryTaxonomy = {
  __typename?: 'ProductCategoryTaxonomy'
  l1: Maybe<Scalars['String']>
  l2: Maybe<Scalars['String']>
  l3: Maybe<Scalars['String']>
  l4: Maybe<Scalars['String']>
  l5: Maybe<Scalars['String']>
  l6: Maybe<Scalars['String']>
}

export type ProductId = {
  __typename?: 'ProductId'
  productId: Maybe<Scalars['BigInt']>
  locale: Maybe<Scalars['String']>
}

export type ProductIdInput = {
  productId?: Maybe<Scalars['BigInt']>
  locale?: Maybe<Scalars['String']>
}

export type ProductRetailerFileData = {
  __typename?: 'ProductRetailerFileData'
  prfdId: Maybe<Scalars['String']>
}

export type ProductSource = {
  __typename?: 'ProductSource'
  name: Maybe<Scalars['String']>
  description: Maybe<Scalars['String']>
  sourceLevel: Maybe<SourceLevel>
  defaultPriority: Maybe<Scalars['BigInt']>
}

export type PublishRppConfigurableItemsRequestInput = {
  retailerId?: Maybe<Scalars['BigInt']>
  productId?: Maybe<Scalars['BigInt']>
  configurableProducts?: Maybe<Scalars['String']>
  userId?: Maybe<Scalars['BigInt']>
}

export type PublishRppConfigurableItemsResponse = {
  __typename?: 'PublishRppConfigurableItemsResponse'
  success: Maybe<Scalars['Boolean']>
}

export type Query = {
  __typename?: 'Query'
  storePerformanceServiceGetAggregatedStorePerformance: Maybe<StorePerformanceResponse>
  historicalStorePerformanceServiceGetAggregatedHistoricalStorePerformance: Maybe<HistoricalStorePerformanceResponse>
  retailerAislesGetRetailerAisleTemplate: Maybe<GetRetailerAisleTemplateResponse>
  retailerAislesGetRetailerLocationByLayout: Maybe<GetRetailerLocationByLayoutResponse>
  retailerStoreHoursGetStoreHours: Maybe<GetStoreHoursResponse>
  retailerStoreHoursGetStoreHoursUpdateTasks: Maybe<GetStoreHoursUpdateTasksResponse>
  contentManagementServiceGetPlacements: Maybe<PlacementsResponse>
  catalogToolsApiServiceGetRetailerProductData: Maybe<GetRetailerProductDataResponse>
  catalogToolsApiServiceGetLocalesByRetailer: Maybe<GetLocalesByRetailerResponse>
  catalogToolsApiServiceDownloadCatalogSearchResults: Maybe<DownloadCatalogSearchResultsResponse>
  insightsPortalServiceGetInsightsPortalSchemaMetadata: Maybe<InsightsPortalSchemaMetadataResponse>
  insightsPortalServiceGetInsightsPortalFilterOptions: Maybe<InsightsPortalFilterOptionsResponse>
  insightsPortalServiceGetInsightsPortalMetricValues: Maybe<InsightsPortalMetricValuesResponse>
  insightsPortalServiceGetInsightsPortalGroupMetricValue: Maybe<InsightsPortalGroupMetricValueResponse>
  insightsPortalServiceGetInsightsPortalGroupComparison: Maybe<InsightsPortalGroupComparisonResponse>
  insightsPortalServiceGetInsightsPortalSnowflakeHeartbeat: Maybe<InsightsPortalSnowflakeHeartbeatResponse>
  retailerSettingsServiceGetStagingSettings: Maybe<GetStagingSettingsResponse>
  retailerSettingsServiceGetParkingSettings: Maybe<GetParkingSettingsResponse>
  retailerSettingsServiceGetIsGrocer: Maybe<GetIsGrocerResponse>
  retailerSettingsServiceGetPickupSettingsMetadata: Maybe<GetPickupSettingsMetadataResponse>
  productSourceServiceGetProductSources: Maybe<GetProductSourcesResponse>
  valueBasedOverrideServiceGetValueBasedOverrides: Maybe<GetValueBasedOverridesResponse>
  managedAttributeDefinitionServiceGetManagedAttributeDefinitions: Maybe<GetManagedAttributeDefinitionsResponse>
  configurableItemsServiceGetRppConfigurableItems: Maybe<GetRppConfigurableItemsResponse>
  demeterServiceGetAuditTask: Maybe<GetAuditTaskResponse>
  demeterServiceGetAuditBatch: Maybe<GetAuditBatchResponse>
  demeterServiceListAuditBatches: Maybe<ListAuditBatchesResponse>
  demeterServiceListAuditWorkflows: Maybe<ListAuditWorkflowsResponse>
  apiIntegrationsServiceGetApiSettings: Maybe<GetApiSettingsResponse>
  apiIntegrationsServiceGetAuthenticationUrl: Maybe<GetAuthenticationUrlResponse>
  availabilityGetStoreHoursByDayOfWeek: Maybe<GetStoreHoursByDayOfWeekResponse>
  availabilityGetStoreHoursByDate: Maybe<GetStoreHoursByDateResponse>
  productsServiceGetLegacyElasticsearch: Maybe<LegacyElasticsearchResponse>
  productsServiceGetLegacyProducts: Maybe<LegacyProducts>
  retailerToolsServiceGetRetailerProducts: Maybe<GetRetailerProductsResponse>
  retailerToolsServiceGetItems: Maybe<GetItemsResponse>
  retailerToolsServiceGetCustomersContext: Maybe<GetCustomersContextResponse>
  orderServiceGetOrder: Maybe<GetOrderResponse>
  orderServiceGetDashboardOrder: Maybe<GetDashboardOrderResponse>
  orderServiceGetOrderLocation: Maybe<GetOrderLocationResponse>
  ordersServiceListOrders: Maybe<ListOrdersResponse>
  /** The access control details for the account */
  accessControlConfiguration: AccessControlConfiguration
  /** Check if an account token (reset password or verify email) is valid */
  accountTokenValidate: TokensValidation
  /** Fetch list of users eligible to subscribe to an event. Also indicates if they are currently subscribed. */
  accountsByNotificationType: Array<NotificationsNotificationTypeAccount>
  /** Retrieve a paginated list of top products */
  analyticsTopProducts: SnowflakeTopProductsResult
  /** Fetch a specific aisle by id */
  catalogAisle: CatalogAisle
  /** Fetch a specific catalog changeset new-product-request by id */
  catalogChangesetNewProductRequest: CatalogChangesetNewProductRequest
  /** Search for catalog changeset new-products-requests matching a set of criteria */
  catalogChangesetNewProductRequestSearch: CatalogChangesetNewProductRequestConnection
  /** Fetch a specific catalog changeset product by id */
  catalogChangesetProduct: CatalogChangesetProduct
  /** Search for catalog changeset products matching a set of criteria */
  catalogChangesetProductSearch: CatalogChangesetProductConnection
  /** Fetch a specific code lookup batch by id */
  catalogCodeLookupBatch: CatalogCodeLookupBatch
  /** Search for catalog code lookups matching a set of criteria */
  catalogCodeLookupSearch: CatalogCodeLookupConnection
  /** Fetch a specific department by id */
  catalogDepartment: CatalogDepartment
  /** Fetch a specific catalog import process by id */
  catalogImportProcess: CatalogImportProcess
  /** Fetch a specific catalog import process code-lookup by id */
  catalogImportProcessCodeLookup: CatalogImportProcessCodeLookup
  /** Search for catalog import process code lookups matching a set of criteria */
  catalogImportProcessCodeLookupSearch: CatalogImportProcessCodeLookupConnection
  /** Search for catalog import processes matching a set of criteria */
  catalogImportProcessSearch: CatalogImportProcessConnection
  /** Retrieve products by IDs */
  catalogProducts: Array<CatalogProduct>
  /** Retrieve a retailer-product by its ID */
  catalogRetailerProduct: CatalogRetailerProduct
  /** Search for retailer-products matching a set of criteria */
  catalogRetailerProductSearch: CatalogRetailerProductConnection
  /** Fetch a signed url for an S3 report */
  catalogSearchDownloadSignedUrl: CatalogSearchDownloadsCatalogSearchDownloadSignedUrl
  /** Fetch a specific catalog workflow by id */
  catalogWorkflow: CatalogWorkflow
  /** Search for catalog workflows matching a set of criteria */
  catalogWorkflowSearch: CatalogWorkflowConnection
  /** Fetch a specific collection by id */
  collection: CollectionsCollection
  /** Fetch a list of collections allowed to be a child */
  collectionChildrenSearch: CollectionsCollectionConnection
  /** Fetch a list of collections allowed to be a parent */
  collectionParentSearch: CollectionsCollectionConnection
  /** Fetch a list of collections */
  collectionSearch: CollectionsCollectionConnection
  /** The currently authenticated account */
  currentEnterpriseAccount: EnterpriseAccount
  /** Check if user has access to the given arguments */
  currentEnterpriseAccountAuthorizationCheck: AccessControlAuthorizationAuthorizationCheck
  /** Fetch an EnterpriseAccount by its canonical id */
  enterpriseAccount: EnterpriseAccount
  /** Search for EnterpriseAccounts matching a set of criteria */
  enterpriseAccountSearch: EnterpriseAccountConnection
  /** Fetch a list of feature tours and their statuses for the current user */
  featureTours: Array<EnterpriseFeatureTour>
  /** Check the health of the server */
  healthCheck: HealthCheck
  /** Fetch a list of Marketplace Home placements */
  homePlacementSearch: Array<HomePlacement>
  /** Check if user has access to the given arguments */
  insightsPortalAuthorizationCheck: AccessControlAuthorizationAuthorizationCheck
  /** Fetch a signed url for a single S3 report */
  normalizedReportSignedUrl: NormalizedReportsNormalizedReportSignedUrl
  /** Fetch a list of S3 report types */
  normalizedReportTypes: Array<NormalizedReportsReportType>
  /** Fetch a list of S3 reports */
  normalizedReportsSearch: NormalizedReportsNormalizedReportConnection
  /** Fetch list of notification types for a retailer */
  notificationTypesForCurrentAccountOnRetailer: Array<NotificationsNotificationType>
  /** Fetch a specific partner by id */
  partner: Partner
  /** Fetch a specific partner pick device by id */
  partnerPickDevice: PartnerPickDevicesDevice
  /** Fetch list of partner pick devices */
  partnerPickDeviceSearch: PartnerPickDevicesDeviceSearch
  /** Fetch capacity recommendations for a given retailer location and date */
  partnerPickGetCapacityRecommendations: PartnerPickCapacityGetCapacityRecommendationsResponse
  /** Check if recurring_shift being created will conflict with existing shifts */
  partnerPickRecurringShiftConflictCheck: PartnerPickRecurringShiftsConflict
  /** Search for partners matching a set of criteria */
  partnerSearch: PartnerConnection
  /** Fetches multiple partners by their ids */
  partners: Array<Partner>
  /** Retrieve pickup retailer location groups that belong to a specific retailer */
  pickupRetailerLocationGroup: Array<RetailersPickupRetailerLocationGroup>
  /** Retrieve a list of reports requested by the retailer */
  reportRequests: ReportsReportRequestConnection
  /** Retrieve a report view by report view id */
  reportView: ReportViewsInterface
  /** Retrieve a list of available reports to request */
  reports: Array<ReportsReport>
  /** Fetch a specific retailer by id */
  retailer: Retailer
  /** Fetch a specific retailer location by id */
  retailerLocation: RetailerLocation
  /** Retrieve a retailer location group by id */
  retailerLocationGroup: RetailersRetailerLocationGroup
  /** Retrieve retailer location groups that belong to a specific retailer */
  retailerLocationGroupsByRetailer: RetailersRetailerLocationGroupConnection
  /** Search for retailer locations matching a set of criteria */
  retailerLocationSearch: RetailerLocationConnection
  /** Search for retailer locations matching a set of criteria - returns an array instead of a connection type */
  retailerLocationSearchArray: Array<RetailerLocation>
  /** Search for retailers matching a set of criteria */
  retailerSearch: RetailerConnection
  /** Search for roles */
  roleSearch: Array<EnterpriseRole>
  /** Fetch a storefront placement by id */
  storefrontPlacement: ContentManagementStorefrontPlacement
  /** Fetch a list of storefront placements */
  storefrontPlacementSearch: ContentManagementStorefrontPlacementConnection
  /** Fetch taxonomy nodes */
  taxonomyNodes: Array<CatalogTaxonomyNode>
  /** Fetch visibility conditions */
  visibilityConditionSearch: Array<VisibilityCondition>
  /** Returns a WelcomeModal that should be shown to current user */
  welcomeModal: EnterpriseWelcomeModal
  /** Find progress of wizard for given partner/retailer/location and type */
  wizardProgress: Maybe<WizardsWizardProgress>
  /** Retrieve Configuration Information */
  legacyConfiguration: LegacyConfigurationType
  /** Retrieve the current partner user */
  legacyCurrentPartnerUser: LegacyPartnerUserType
  /** Check the health of the server */
  legacyHealthCheck: LegacyHealthCheckType
  /** Query a Partner by id */
  legacyPartner: LegacyPartnerType
  /** Query search impression image coverage */
  legacySearchImpressionImageCoverage: LegacySearchImpressionImageCoverageType
  /** Generate missing images report */
  legacySearchImpressionMissingImagesReport: LegacySearchImpressionMissingImagesReportType
  /** Query a Warehouse by id */
  legacyWarehouse: LegacyWarehouseType
  /** Query a WarehouseLocation by id */
  legacyWarehouseLocation: LegacyWarehouseLocationType
}

export type QueryStorePerformanceServiceGetAggregatedStorePerformanceArgs = {
  input?: Maybe<StorePerformanceRequestInput>
}

export type QueryHistoricalStorePerformanceServiceGetAggregatedHistoricalStorePerformanceArgs = {
  input?: Maybe<HistoricalStorePerformanceRequestInput>
}

export type QueryRetailerAislesGetRetailerAisleTemplateArgs = {
  input?: Maybe<GetRetailerAisleTemplateRequestInput>
}

export type QueryRetailerAislesGetRetailerLocationByLayoutArgs = {
  input?: Maybe<GetRetailerLocationByLayoutRequestInput>
}

export type QueryRetailerStoreHoursGetStoreHoursArgs = {
  input?: Maybe<GetStoreHoursRequestInput>
}

export type QueryRetailerStoreHoursGetStoreHoursUpdateTasksArgs = {
  input?: Maybe<GetStoreHoursUpdateTasksRequestInput>
}

export type QueryContentManagementServiceGetPlacementsArgs = {
  input?: Maybe<GetPlacementsRequestInput>
}

export type QueryCatalogToolsApiServiceGetRetailerProductDataArgs = {
  input?: Maybe<GetRetailerProductDataRequestInput>
}

export type QueryCatalogToolsApiServiceGetLocalesByRetailerArgs = {
  input?: Maybe<GetLocalesByRetailerRequestInput>
}

export type QueryCatalogToolsApiServiceDownloadCatalogSearchResultsArgs = {
  input?: Maybe<DownloadCatalogSearchResultsRequestInput>
}

export type QueryInsightsPortalServiceGetInsightsPortalSchemaMetadataArgs = {
  input?: Maybe<InsightsPortalSchemaMetadataRequestInput>
}

export type QueryInsightsPortalServiceGetInsightsPortalFilterOptionsArgs = {
  input?: Maybe<InsightsPortalFilterOptionsRequestInput>
}

export type QueryInsightsPortalServiceGetInsightsPortalMetricValuesArgs = {
  input?: Maybe<InsightsPortalMetricValuesRequestInput>
}

export type QueryInsightsPortalServiceGetInsightsPortalGroupMetricValueArgs = {
  input?: Maybe<InsightsPortalGroupMetricValueRequestInput>
}

export type QueryInsightsPortalServiceGetInsightsPortalGroupComparisonArgs = {
  input?: Maybe<InsightsPortalGroupComparisonRequestInput>
}

export type QueryInsightsPortalServiceGetInsightsPortalSnowflakeHeartbeatArgs = {
  input?: Maybe<InsightsPortalSnowflakeHeartbeatRequestInput>
}

export type QueryRetailerSettingsServiceGetStagingSettingsArgs = {
  input?: Maybe<GetStagingSettingsRequestInput>
}

export type QueryRetailerSettingsServiceGetParkingSettingsArgs = {
  input?: Maybe<GetParkingSettingsRequestInput>
}

export type QueryRetailerSettingsServiceGetIsGrocerArgs = {
  input?: Maybe<GetIsGrocerRequestInput>
}

export type QueryRetailerSettingsServiceGetPickupSettingsMetadataArgs = {
  input?: Maybe<GetPickupSettingsMetadataRequestInput>
}

export type QueryProductSourceServiceGetProductSourcesArgs = {
  input?: Maybe<GetProductSourcesRequestInput>
}

export type QueryValueBasedOverrideServiceGetValueBasedOverridesArgs = {
  input?: Maybe<GetValueBasedOverridesRequestInput>
}

export type QueryManagedAttributeDefinitionServiceGetManagedAttributeDefinitionsArgs = {
  input?: Maybe<GetManagedAttributeDefinitionsRequestInput>
}

export type QueryConfigurableItemsServiceGetRppConfigurableItemsArgs = {
  input?: Maybe<GetRppConfigurableItemsRequestInput>
}

export type QueryDemeterServiceGetAuditTaskArgs = {
  input?: Maybe<GetAuditTaskRequestInput>
}

export type QueryDemeterServiceGetAuditBatchArgs = {
  input?: Maybe<GetAuditBatchRequestInput>
}

export type QueryDemeterServiceListAuditBatchesArgs = {
  input?: Maybe<ListAuditBatchesRequestInput>
}

export type QueryDemeterServiceListAuditWorkflowsArgs = {
  input?: Maybe<ListAuditWorkflowsRequestInput>
}

export type QueryApiIntegrationsServiceGetApiSettingsArgs = {
  input?: Maybe<GetApiSettingsRequestInput>
}

export type QueryApiIntegrationsServiceGetAuthenticationUrlArgs = {
  input?: Maybe<GetAuthenticationUrlRequestInput>
}

export type QueryAvailabilityGetStoreHoursByDayOfWeekArgs = {
  input?: Maybe<GetStoreHoursByDayOfWeekRequestInput>
}

export type QueryAvailabilityGetStoreHoursByDateArgs = {
  input?: Maybe<GetStoreHoursByDateRequestInput>
}

export type QueryProductsServiceGetLegacyElasticsearchArgs = {
  input?: Maybe<GetLegacyElasticsearchRequestInput>
}

export type QueryProductsServiceGetLegacyProductsArgs = {
  input?: Maybe<GetLegacyProductsRequestInput>
}

export type QueryRetailerToolsServiceGetRetailerProductsArgs = {
  input?: Maybe<GetRetailerProductsRequestInput>
}

export type QueryRetailerToolsServiceGetItemsArgs = {
  input?: Maybe<GetItemsRequestInput>
}

export type QueryRetailerToolsServiceGetCustomersContextArgs = {
  input?: Maybe<GetCustomersContextRequestInput>
}

export type QueryOrderServiceGetOrderArgs = {
  input?: Maybe<GetOrderRequestInput>
}

export type QueryOrderServiceGetDashboardOrderArgs = {
  input?: Maybe<GetDashboardOrderRequestInput>
}

export type QueryOrderServiceGetOrderLocationArgs = {
  input?: Maybe<GetOrderLocationRequestInput>
}

export type QueryOrdersServiceListOrdersArgs = {
  input?: Maybe<ListOrdersRequestInput>
}

export type QueryAccountTokenValidateArgs = {
  rawToken: Scalars['String']
  tokenType: TokenTypeEnum
}

export type QueryAccountsByNotificationTypeArgs = {
  retailerId: Scalars['ID']
  notificationTypeId: Scalars['ID']
  excludeInternalUsers?: Maybe<Scalars['Boolean']>
}

export type QueryAnalyticsTopProductsArgs = {
  retailerId: Scalars['ID']
  startAt?: Maybe<Scalars['ISO8601Date']>
  endAt?: Maybe<Scalars['ISO8601Date']>
  page?: Maybe<Scalars['Int']>
  limit?: Maybe<Scalars['Int']>
}

export type QueryCatalogAisleArgs = {
  id: Scalars['ID']
}

export type QueryCatalogChangesetNewProductRequestArgs = {
  id: Scalars['ID']
}

export type QueryCatalogChangesetNewProductRequestSearchArgs = {
  workflowId?: Maybe<Scalars['ID']>
  aisleId?: Maybe<Scalars['ID']>
  departmentId?: Maybe<Scalars['ID']>
  classifiedCode?: Maybe<Scalars['String']>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export type QueryCatalogChangesetProductArgs = {
  id: Scalars['ID']
}

export type QueryCatalogChangesetProductSearchArgs = {
  workflowId?: Maybe<Scalars['ID']>
  aisleId?: Maybe<Scalars['ID']>
  departmentId?: Maybe<Scalars['ID']>
  classifiedCode?: Maybe<Scalars['String']>
  status?: Maybe<ChangesetProductStatusEnum>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export type QueryCatalogCodeLookupBatchArgs = {
  id: Scalars['ID']
}

export type QueryCatalogCodeLookupSearchArgs = {
  batchId?: Maybe<Scalars['ID']>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export type QueryCatalogDepartmentArgs = {
  id: Scalars['ID']
}

export type QueryCatalogImportProcessArgs = {
  id: Scalars['ID']
}

export type QueryCatalogImportProcessCodeLookupArgs = {
  id: Scalars['ID']
}

export type QueryCatalogImportProcessCodeLookupSearchArgs = {
  workflowId?: Maybe<Scalars['ID']>
  importProcessId?: Maybe<Scalars['ID']>
  importProcessCodeLookupType?: Maybe<ImportProcessCodeLookupTypeEnum>
  importProcessCodeLookupState?: Maybe<ImportProcessCodeLookupStateEnum>
  importProcessCodeLookupStatus?: Maybe<ImportProcessCodeLookupStatusEnum>
  hasAssociatedNewProductRequest?: Maybe<Scalars['Boolean']>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export type QueryCatalogImportProcessSearchArgs = {
  workflowId?: Maybe<Scalars['ID']>
  importProcessOwnerId?: Maybe<Scalars['ID']>
  importProcessType?: Maybe<ImportProcessTypeEnum>
  importProcessState?: Maybe<ImportProcessStateEnum>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export type QueryCatalogProductsArgs = {
  ids: Array<Scalars['ID']>
}

export type QueryCatalogRetailerProductArgs = {
  id: Scalars['ID']
}

export type QueryCatalogRetailerProductSearchArgs = {
  searchType: Scalars['String']
  searchTerm: Scalars['String']
  retailerId: Scalars['ID']
  available?: Maybe<Scalars['Boolean']>
  departmentIds?: Maybe<Array<Scalars['ID']>>
  aisleIds?: Maybe<Array<Scalars['ID']>>
  searchLimit?: Maybe<Scalars['Int']>
  localeCode?: Maybe<Scalars['String']>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export type QueryCatalogSearchDownloadSignedUrlArgs = {
  s3Key: Scalars['String']
}

export type QueryCatalogWorkflowArgs = {
  id: Scalars['ID']
}

export type QueryCatalogWorkflowSearchArgs = {
  retailerId?: Maybe<Scalars['ID']>
  workflowOwnerId?: Maybe<Scalars['ID']>
  workflowType?: Maybe<WorkflowTypeEnum>
  workflowStates?: Maybe<Array<WorkflowStateEnum>>
  workflowState?: Maybe<WorkflowStateEnum>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export type QueryCollectionArgs = {
  id: Scalars['ID']
  retailerId?: Maybe<Scalars['ID']>
}

export type QueryCollectionChildrenSearchArgs = {
  collectionId?: Maybe<Scalars['ID']>
  retailerId?: Maybe<Scalars['ID']>
  collectionName?: Maybe<Scalars['String']>
  active?: Maybe<Scalars['Boolean']>
  contentType?: Maybe<CollectionContentTypeEnum>
  collectionTypes: Array<CollectionTypeEnum>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export type QueryCollectionParentSearchArgs = {
  collectionId?: Maybe<Scalars['ID']>
  retailerId?: Maybe<Scalars['ID']>
  collectionTypes: Array<CollectionTypeEnum>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export type QueryCollectionSearchArgs = {
  retailerId?: Maybe<Scalars['ID']>
  collectionName?: Maybe<Scalars['String']>
  active?: Maybe<Scalars['Boolean']>
  contentType?: Maybe<CollectionContentTypeEnum>
  collectionTypes: Array<CollectionTypeEnum>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export type QueryCurrentEnterpriseAccountAuthorizationCheckArgs = {
  permissions?: Maybe<Array<Scalars['String']>>
  retailerIds?: Maybe<Array<Scalars['ID']>>
  partnerIds?: Maybe<Array<Scalars['ID']>>
  retailerLocationIds?: Maybe<Array<Scalars['ID']>>
  accountFlippers?: Maybe<Array<Scalars['String']>>
  requireWriteAccess?: Maybe<Scalars['Boolean']>
}

export type QueryEnterpriseAccountArgs = {
  canonicalId?: Maybe<Scalars['ID']>
}

export type QueryEnterpriseAccountSearchArgs = {
  email?: Maybe<Scalars['String']>
  roleId?: Maybe<Scalars['ID']>
  partnerId?: Maybe<Scalars['ID']>
  retailerId?: Maybe<Scalars['ID']>
  showDisabled?: Maybe<Scalars['Boolean']>
  canonicalIds?: Maybe<Array<Scalars['ID']>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export type QueryHealthCheckArgs = {
  metricsToken?: Maybe<Scalars['String']>
}

export type QueryHomePlacementSearchArgs = {
  placementId?: Maybe<Scalars['ID']>
  sort?: Maybe<PlacementSortInput>
  filter?: Maybe<PlacementFilterInput>
}

export type QueryInsightsPortalAuthorizationCheckArgs = {
  permissions?: Maybe<Array<Scalars['String']>>
  retailerIds?: Maybe<Array<Scalars['ID']>>
  partnerIds?: Maybe<Array<Scalars['ID']>>
  retailerLocationIds?: Maybe<Array<Scalars['ID']>>
}

export type QueryNormalizedReportSignedUrlArgs = {
  bucketName: Scalars['String']
  s3Key: Scalars['String']
}

export type QueryNormalizedReportTypesArgs = {
  partnerId: Scalars['ID']
}

export type QueryNormalizedReportsSearchArgs = {
  partnerId: Scalars['ID']
  retailerId: Scalars['ID']
  startDate: Scalars['ISO8601Date']
  endDate?: Maybe<Scalars['ISO8601Date']>
  reportType?: Maybe<ReportTypeEnum>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export type QueryNotificationTypesForCurrentAccountOnRetailerArgs = {
  retailerId: Scalars['ID']
}

export type QueryPartnerArgs = {
  id: Scalars['ID']
}

export type QueryPartnerPickDeviceArgs = {
  id: Scalars['ID']
}

export type QueryPartnerPickDeviceSearchArgs = {
  warehouseLocationId: Scalars['ID']
  active?: Maybe<Scalars['Boolean']>
  limit: Scalars['Int']
  offset: Scalars['Int']
}

export type QueryPartnerPickGetCapacityRecommendationsArgs = {
  retailerLocationId: Scalars['ID']
  date: Scalars['ISO8601Date']
}

export type QueryPartnerPickRecurringShiftConflictCheckArgs = {
  driverId: Scalars['ID']
  warehouseLocationId: Scalars['ID']
  daysOfWeek: Array<Scalars['Int']>
  shiftStartSecondsSinceMidnight: Scalars['Int']
  shiftLengthSeconds: Scalars['Int']
  recurStartDate?: Maybe<Scalars['String']>
  recurEndDate?: Maybe<Scalars['String']>
  existingRecurringShiftId?: Maybe<Scalars['ID']>
  existingDriverShiftId?: Maybe<Scalars['ID']>
}

export type QueryPartnerSearchArgs = {
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export type QueryPartnersArgs = {
  ids: Array<Scalars['ID']>
}

export type QueryPickupRetailerLocationGroupArgs = {
  retailerId: Scalars['ID']
  includeInactive?: Maybe<Scalars['Boolean']>
}

export type QueryReportRequestsArgs = {
  retailerId: Scalars['ID']
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export type QueryReportViewArgs = {
  reportViewId: Scalars['ID']
}

export type QueryRetailerArgs = {
  id: Scalars['ID']
}

export type QueryRetailerLocationArgs = {
  id: Scalars['ID']
}

export type QueryRetailerLocationGroupArgs = {
  id: Scalars['ID']
}

export type QueryRetailerLocationGroupsByRetailerArgs = {
  retailerId: Scalars['ID']
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export type QueryRetailerLocationSearchArgs = {
  retailerId?: Maybe<Scalars['ID']>
  pickup?: Maybe<Scalars['Boolean']>
  includeInactiveLocations?: Maybe<Scalars['Boolean']>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export type QueryRetailerLocationSearchArrayArgs = {
  retailerId?: Maybe<Scalars['ID']>
  pickup?: Maybe<Scalars['Boolean']>
  includeInactiveLocations?: Maybe<Scalars['Boolean']>
}

export type QueryRetailerSearchArgs = {
  partnerId?: Maybe<Scalars['ID']>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export type QueryStorefrontPlacementArgs = {
  id: Scalars['ID']
  retailerId: Scalars['ID']
}

export type QueryStorefrontPlacementSearchArgs = {
  retailerId: Scalars['ID']
  sort?: Maybe<PlacementSortInput>
  filter?: Maybe<PlacementFilterInput>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export type QueryVisibilityConditionSearchArgs = {
  placementId?: Maybe<Scalars['ID']>
  visibilityConditionId?: Maybe<Scalars['ID']>
}

export type QueryWelcomeModalArgs = {
  partnerId?: Maybe<Scalars['ID']>
  retailerId?: Maybe<Scalars['ID']>
  retailerLocationId?: Maybe<Scalars['ID']>
}

export type QueryWizardProgressArgs = {
  partnerId?: Maybe<Scalars['ID']>
  retailerId?: Maybe<Scalars['ID']>
  retailerLocationId: Scalars['ID']
  wizardType: WizardTypeEnum
}

export type QueryLegacyPartnerArgs = {
  id: Scalars['ID']
}

export type QueryLegacySearchImpressionImageCoverageArgs = {
  startAt: Scalars['LegacyDate']
  endAt: Scalars['LegacyDate']
  warehouseId: Scalars['ID']
  storeGroupId?: Maybe<Scalars['ID']>
  warehouseLocationIds?: Maybe<Array<Scalars['ID']>>
}

export type QueryLegacySearchImpressionMissingImagesReportArgs = {
  warehouseId: Scalars['ID']
}

export type QueryLegacyWarehouseArgs = {
  id: Scalars['ID']
}

export type QueryLegacyWarehouseLocationArgs = {
  id: Scalars['ID']
}

export enum RecommendationTypeEnum {
  DemandSurge = 'DEMAND_SURGE',
  NoRunner = 'NO_RUNNER',
}

export type RegularHours = {
  __typename?: 'RegularHours'
  dayOfWeek: Maybe<GoogleTypeDayOfWeek>
  serviceType: Maybe<RetailerServiceType>
  startTime: Maybe<GoogleTypeTimeOfDay>
  endTime: Maybe<GoogleTypeTimeOfDay>
}

export type RegularHoursInput = {
  dayOfWeek?: Maybe<GoogleTypeDayOfWeek>
  serviceType?: Maybe<RetailerServiceType>
  startTime?: Maybe<GoogleTypeTimeOfDayInput>
  endTime?: Maybe<GoogleTypeTimeOfDayInput>
}

export type RemoteUserInput = {
  appName?: Maybe<Scalars['String']>
  userId?: Maybe<Scalars['String']>
  userName?: Maybe<Scalars['String']>
  contextJson?: Maybe<Scalars['String']>
}

export type ReopenLastmileOrderRequestInput = {
  requestContext?: Maybe<InstacartTypesV1RequestContextInput>
  userId?: Maybe<Scalars['BigInt']>
  order?: Maybe<InstacartEnterpriseBobaCoreTypesV1ReopenLastmileOrderParamsInput>
  partnerId?: Maybe<Scalars['BigInt']>
  retailerId?: Maybe<Scalars['BigInt']>
  modificationEvent?: Maybe<InstacartEnterpriseBobaCoreTypesV1ModificationEventInput>
}

export type ReopenLastmileOrderResponse = {
  __typename?: 'ReopenLastmileOrderResponse'
  order: Maybe<InstacartEnterpriseBobaCoreTypesV1Order>
}

/** A report filter definition */
export type ReportFilterDefinitionsInterface = {
  /** Type of filter */
  filterType: ReportFilterTypeEnum
  /** Whether this filter is required */
  required: Scalars['Boolean']
  /** Identifier for this filter */
  slug: Scalars['String']
}

/** Report Filters */
export type ReportFilters = {
  dateRange?: Maybe<DateRange>
  retailerLocations?: Maybe<RetailerLocations>
}

export enum ReportFilterTypeEnum {
  /** A filter that allows selection of a date range. */
  DateRange = 'DATE_RANGE',
  /** A filter that allows selection of a list of retailer locations. */
  RetailerLocations = 'RETAILER_LOCATIONS',
}

/** Report filter values */
export type ReportFilterValuesInterface = {
  /** Type of filter */
  filterType: ReportFilterTypeEnum
  /** Identifier for this filter */
  slug: Scalars['String']
}

export enum ReportRequestAssociatedObjectTypeEnum {
  /** Retailer type of associated object */
  Retailer = 'Retailer',
}

/** Autogenerated return type of ReportRequestCreate */
export type ReportRequestCreatePayload = {
  __typename?: 'ReportRequestCreatePayload'
  /** The newly created report request */
  reportRequest: Maybe<ReportsReportRequest>
}

export enum ReportRequestStateEnum {
  /** A report request that is new and not yet processed */
  New = 'NEW',
  /** A report request that is currently being processed */
  InProgress = 'IN_PROGRESS',
  /** A report request that has been successfully processed */
  Complete = 'COMPLETE',
  /** A report request that has failed processing */
  Failed = 'FAILED',
}

export type ReportsReport = {
  __typename?: 'ReportsReport'
  /** The time at which the report was created */
  createdAt: Scalars['Time']
  /** A unique identifier for the each report */
  id: Scalars['ID']
  /** A url-friendly ID for this report */
  slug: Scalars['String']
  supportedFilters: Array<ReportFilterDefinitionsInterface>
  /** The time at which the report was updated */
  updatedAt: Scalars['Time']
}

export type ReportsReportFilterDefinitionsDateRange = ReportFilterDefinitionsInterface & {
  __typename?: 'ReportsReportFilterDefinitionsDateRange'
  /** Type of filter */
  filterType: ReportFilterTypeEnum
  /** Maximum date allowed */
  maxDate: Scalars['ISO8601Date']
  /** Minimum date */
  minDate: Scalars['ISO8601Date']
  /** Whether this filter is required */
  required: Scalars['Boolean']
  /** Identifier for this filter */
  slug: Scalars['String']
}

export type ReportsReportFilterDefinitionsRetailerLocations = ReportFilterDefinitionsInterface & {
  __typename?: 'ReportsReportFilterDefinitionsRetailerLocations'
  /** Type of filter */
  filterType: ReportFilterTypeEnum
  /** Whether this filter is required */
  required: Scalars['Boolean']
  /** Identifier for this filter */
  slug: Scalars['String']
}

export type ReportsReportFilterValuesDateRange = ReportFilterValuesInterface & {
  __typename?: 'ReportsReportFilterValuesDateRange'
  /** End date of date range */
  endDate: Scalars['ISO8601Date']
  /** Type of filter */
  filterType: ReportFilterTypeEnum
  /** Identifier for this filter */
  slug: Scalars['String']
  /** Start date of date range */
  startDate: Scalars['ISO8601Date']
}

export type ReportsReportFilterValuesRetailerLocations = ReportFilterValuesInterface & {
  __typename?: 'ReportsReportFilterValuesRetailerLocations'
  /** Type of filter */
  filterType: ReportFilterTypeEnum
  /** A retailer location group ID */
  retailerLocationGroupId: Maybe<Scalars['ID']>
  /** A list of retailer location IDs */
  retailerLocationIds: Maybe<Array<Scalars['ID']>>
  /** Identifier for this filter */
  slug: Scalars['String']
}

export type ReportsReportRequest = {
  __typename?: 'ReportsReportRequest'
  /** The time at which the report request was created */
  createdAt: Scalars['Time']
  enterpriseAccount: Maybe<EnterpriseAccount>
  /** The state the report request is currently in */
  generationState: ReportRequestStateEnum
  /** A unique identifier for the report request */
  id: Scalars['ID']
  /** The name of the report request */
  name: Scalars['String']
  report: ReportsReport
  reportFilters: Array<ReportFilterValuesInterface>
  reportViews: Array<ReportViewsInterface>
  /** The time at which the report request was updated */
  updatedAt: Scalars['Time']
}

/** The connection type for ReportsReportRequest. */
export type ReportsReportRequestConnection = {
  __typename?: 'ReportsReportRequestConnection'
  /** A list of edges. */
  edges: Maybe<Array<Maybe<ReportsReportRequestEdge>>>
  /** Metadata regarding the connection */
  meta: ConnectionMeta
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<ReportsReportRequest>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type ReportsReportRequestEdge = {
  __typename?: 'ReportsReportRequestEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: Maybe<ReportsReportRequest>
}

export type ReportsReportViewsCsv = ReportViewsInterface & {
  __typename?: 'ReportsReportViewsCsv'
  /** download URL for the report view */
  downloadUrl: Maybe<Scalars['String']>
  /** A unique identifier for the report view */
  id: Scalars['ID']
}

export enum ReportTypeEnum {
  /** General weekly updates */
  WeeklyRetailerUpdate = 'WEEKLY_RETAILER_UPDATE',
  /** Out of stock items */
  OutOfStock = 'OUT_OF_STOCK',
  /** Order ratings */
  OrderRatings = 'ORDER_RATINGS',
  /** Top items */
  TopItems = 'TOP_ITEMS',
  /** Live Issue */
  LiveIssue = 'LIVE_ISSUE',
  /** Live Issue */
  UnataExpressWeekly = 'UNATA_EXPRESS_WEEKLY',
  /** Live Issue */
  RunnerHours = 'RUNNER_HOURS',
  /** Replacements and refunds */
  ReplacementsAndRefunds = 'REPLACEMENTS_AND_REFUNDS',
  /** Store level performance */
  StoreLevelPartnerPerformanceReport = 'STORE_LEVEL_PARTNER_PERFORMANCE_REPORT',
  /** Associate level performance */
  AssociateLevelPartnerPerformanceReport = 'ASSOCIATE_LEVEL_PARTNER_PERFORMANCE_REPORT',
  /** Monthly DLOG report */
  DlogMonthly = 'DLOG_MONTHLY',
  /** Monthly MLOG report */
  MlogMonthly = 'MLOG_MONTHLY',
  /** UUID Compliance */
  UuidCompliance = 'UUID_COMPLIANCE',
  /** Distribution System Report */
  DistributionSystemReport = 'DISTRIBUTION_SYSTEM_REPORT',
  /** Shopper Breaks */
  ShopperBreaks = 'SHOPPER_BREAKS',
  /** Retailer Pickup */
  RetailerPickup = 'RETAILER_PICKUP',
  /** Retailer Tax Logs */
  RetailerTaxLogs = 'RETAILER_TAX_LOGS',
  /** Taxes Paid at POS */
  TaxesPaidAtPos = 'TAXES_PAID_AT_POS',
  /** Ads report daily */
  AdsDaily = 'ADS_DAILY',
  /** Ads report weekly */
  AdsWeekly = 'ADS_WEEKLY',
  /** Ads report monthly */
  AdsMonthly = 'ADS_MONTHLY',
  /** Merged: Retailer Tax Logs */
  MergedRetailerTaxLogs = 'MERGED_RETAILER_TAX_LOGS',
  /** Merged: Taxes Paid at POS */
  MergedTaxesPaidAtPos = 'MERGED_TAXES_PAID_AT_POS',
  /** Daily Ultrafast Dashboard */
  DailyUltrafastDashboard = 'DAILY_ULTRAFAST_DASHBOARD',
}

/** A generated view of the report data */
export type ReportViewsInterface = {
  /** A unique identifier for the report view */
  id: Scalars['ID']
}

export type RescheduleOrderRequestInput = {
  requestContext?: Maybe<InstacartTypesV1RequestContextInput>
  userId?: Maybe<Scalars['BigInt']>
  order?: Maybe<InstacartEnterpriseBobaCoreTypesV1RescheduleOrderParamsInput>
  partnerId?: Maybe<Scalars['BigInt']>
  retailerId?: Maybe<Scalars['BigInt']>
  modificationEvent?: Maybe<InstacartEnterpriseBobaCoreTypesV1ModificationEventInput>
}

export type RescheduleOrderResponse = {
  __typename?: 'RescheduleOrderResponse'
  order: Maybe<InstacartEnterpriseBobaCoreTypesV1Order>
}

export type Retailer = {
  __typename?: 'Retailer'
  /** An array of the retailer's departments */
  departments: Array<CatalogDepartment>
  /** A url for header-specific version of the logo */
  headerLogoUrl: Maybe<Scalars['String']>
  /** A unique identifier for the retailer */
  id: Scalars['ID']
  /** Whether or not the retailer is on pbi */
  isPbi: Scalars['Boolean']
  /** The name of the retailer */
  name: Scalars['String']
  /** The partner that this retailer belongs to */
  partner: Partner
  /** The store configuration for the pbi retailer */
  pbiConfiguration: Maybe<ContentManagementPbiConfiguration>
  /** The locations belonging to this retailer */
  retailerLocations: RetailerLocationConnection
  /** The warehouse slug for a retailer */
  slug: Scalars['String']
  /** A url for tiny version of the logo */
  tinyLogoUrl: Maybe<Scalars['String']>
  /** A url for the white label landing page */
  whiteLabelLandingPageUrl: Maybe<Scalars['String']>
}

export type RetailerRetailerLocationsArgs = {
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export type RetailerCollection = {
  __typename?: 'RetailerCollection'
  retailerId: Maybe<Scalars['BigInt']>
  slug: Maybe<Scalars['String']>
}

export type RetailerCollectionInput = {
  retailerId?: Maybe<Scalars['BigInt']>
  slug?: Maybe<Scalars['String']>
}

/** The connection type for Retailer. */
export type RetailerConnection = {
  __typename?: 'RetailerConnection'
  /** A list of edges. */
  edges: Maybe<Array<Maybe<RetailerEdge>>>
  /** Metadata regarding the connection */
  meta: ConnectionMeta
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Retailer>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type RetailerContainerPath = {
  __typename?: 'RetailerContainerPath'
  retailerId: Maybe<Scalars['BigInt']>
  containerPath: Maybe<Scalars['String']>
}

export type RetailerContainerPathInput = {
  retailerId?: Maybe<Scalars['BigInt']>
  containerPath?: Maybe<Scalars['String']>
}

/** An edge in a connection. */
export type RetailerEdge = {
  __typename?: 'RetailerEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: Maybe<Retailer>
}

export type RetailerLocale = {
  __typename?: 'RetailerLocale'
  retailerId: Maybe<Scalars['BigInt']>
  localeId: Maybe<Scalars['BigInt']>
  localeCode: Maybe<Scalars['String']>
}

export type RetailerLocation = {
  __typename?: 'RetailerLocation'
  /** The location's city */
  city: Maybe<Scalars['String']>
  /** Represents the set of 'Fullfillment Models' (how fulfillment is facilitated for the location) */
  fulfillmentModels: Maybe<Array<FulfillmentModelEnum>>
  /** A unique identifier for the retailer location */
  id: Scalars['ID']
  /** The retailer-assigned location code */
  locationCode: Maybe<Scalars['String']>
  /** The name of the retailer location */
  name: Maybe<Scalars['String']>
  /** Identifies if the location does partner run alcohol delivery */
  partnerAlcoholDelivery: Scalars['Boolean']
  /** Represents the 'Picking Model' (how picking is facilitated for the location) */
  pickingModel: Maybe<PickingModelEnum>
  /** A flag representing whether pickup is enabled */
  pickup: Scalars['Boolean']
  /** Identifies if the location does platform only deliveries */
  platformOnlyEnabled: Maybe<Scalars['Boolean']>
  /** The retailer that this location belongs to */
  retailer: Retailer
  /** The location's state */
  state: Maybe<Scalars['String']>
  /** The location's street (including street #) */
  street: Maybe<Scalars['String']>
  /** The location's zip code or postal code */
  zipCode: Maybe<Scalars['String']>
  /** The location's ZIP+4 (US-specific) */
  zipPlusFour: Maybe<Scalars['String']>
}

export type RetailerLocationAisle = {
  __typename?: 'RetailerLocationAisle'
  retailerLocationName: Maybe<Scalars['String']>
  retailerLocationId: Maybe<Scalars['BigInt']>
  aisleCount: Maybe<Scalars['BigInt']>
}

/** The connection type for RetailerLocation. */
export type RetailerLocationConnection = {
  __typename?: 'RetailerLocationConnection'
  /** A list of edges. */
  edges: Maybe<Array<Maybe<RetailerLocationEdge>>>
  /** Metadata regarding the connection */
  meta: ConnectionMeta
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<RetailerLocation>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type RetailerLocationEdge = {
  __typename?: 'RetailerLocationEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: Maybe<RetailerLocation>
}

export type RetailerLocationFlags = {
  __typename?: 'RetailerLocationFlags'
  active: Maybe<Scalars['Boolean']>
  available: Maybe<Scalars['Boolean']>
  serviceable: Maybe<Scalars['Boolean']>
  closed: Maybe<Scalars['Boolean']>
}

/** Autogenerated return type of RetailerLocationGroupCreate */
export type RetailerLocationGroupCreatePayload = {
  __typename?: 'RetailerLocationGroupCreatePayload'
  /** The newly created group */
  retailerLocationGroup: RetailersRetailerLocationGroup
}

/** Autogenerated return type of RetailerLocationGroupDelete */
export type RetailerLocationGroupDeletePayload = {
  __typename?: 'RetailerLocationGroupDeletePayload'
  /** A status which is true if no errors were encountered */
  success: Scalars['True']
}

/** Autogenerated return type of RetailerLocationGroupUpdate */
export type RetailerLocationGroupUpdatePayload = {
  __typename?: 'RetailerLocationGroupUpdatePayload'
  /** The updated group */
  retailerLocationGroup: RetailersRetailerLocationGroup
}

export type RetailerLocationInfo = {
  __typename?: 'RetailerLocationInfo'
  name: Maybe<Scalars['String']>
  street: Maybe<Scalars['String']>
  retailerName: Maybe<Scalars['String']>
}

/** Attributes for a retailer location filter */
export type RetailerLocations = {
  /** A list of retailer location IDs */
  retailerLocationIds?: Maybe<Array<Scalars['ID']>>
  /** A retailer location group ID */
  retailerLocationGroupId?: Maybe<Scalars['ID']>
}

export type RetailerProduct = {
  __typename?: 'RetailerProduct'
  aisles: Maybe<Array<Maybe<Aisle>>>
  alcoholic: Maybe<Scalars['Boolean']>
  brandId: Maybe<Scalars['BigInt']>
  brandName: Maybe<Scalars['String']>
  departments: Maybe<Array<Maybe<Department>>>
  details: Maybe<Scalars['String']>
  fatFree: Maybe<Scalars['Boolean']>
  glutenFree: Maybe<Scalars['Boolean']>
  hasImage: Maybe<Scalars['Boolean']>
  imageList: Maybe<Array<Maybe<ImageInfo>>>
  ingredients: Maybe<Scalars['String']>
  kosher: Maybe<Scalars['Boolean']>
  localeCode: Maybe<Scalars['String']>
  lowFat: Maybe<Scalars['Boolean']>
  organic: Maybe<Scalars['Boolean']>
  originalName: Maybe<Scalars['String']>
  primaryAisleId: Maybe<Scalars['BigInt']>
  primaryDepartmentId: Maybe<Scalars['BigInt']>
  primaryImageUrl: Maybe<Scalars['String']>
  productCategoryTaxonomy: Maybe<ProductCategoryTaxonomy>
  productCodes: Maybe<Array<Maybe<Scalars['String']>>>
  productDisplayName: Maybe<Scalars['String']>
  productId: Maybe<Scalars['BigInt']>
  retailerId: Maybe<Scalars['BigInt']>
  retailerReferenceCode: Maybe<Scalars['String']>
  score: Maybe<Scalars['Float']>
  seasonality: Maybe<Scalars['JSONObject']>
  size: Maybe<Scalars['String']>
  storeBrand: Maybe<Scalars['Boolean']>
  sugarFree: Maybe<Scalars['Boolean']>
  unitCount: Maybe<Scalars['BigInt']>
  vegan: Maybe<Scalars['Boolean']>
  vegetarian: Maybe<Scalars['Boolean']>
  createdAt: Maybe<Scalars['DateTime']>
  aisleName: Maybe<Scalars['String']>
  atkinsDiet: Maybe<Scalars['Boolean']>
  bottle: Maybe<Scalars['Boolean']>
  calories: Maybe<Scalars['Float']>
  carbFree: Maybe<Scalars['Boolean']>
  carbohydrate: Maybe<Scalars['Float']>
  cchGroupCode: Maybe<Scalars['String']>
  cchItemCode: Maybe<Scalars['String']>
  coldPrepared: Maybe<Scalars['Boolean']>
  containsFlour: Maybe<Scalars['Boolean']>
  dairyFree: Maybe<Scalars['Boolean']>
  description: Maybe<Scalars['String']>
  directions: Maybe<Scalars['String']>
  highCarb: Maybe<Scalars['Boolean']>
  highFat: Maybe<Scalars['Boolean']>
  highProtein: Maybe<Scalars['Boolean']>
  isOrganic: Maybe<Scalars['Boolean']>
  ketoDiet: Maybe<Scalars['Boolean']>
  kidFriendly: Maybe<Scalars['Boolean']>
  lactoseFree: Maybe<Scalars['Boolean']>
  lowCarb: Maybe<Scalars['Boolean']>
  lowSodium: Maybe<Scalars['Boolean']>
  lowSugar: Maybe<Scalars['Boolean']>
  name: Maybe<Scalars['String']>
  paleoDiet: Maybe<Scalars['Boolean']>
  prepSlicedRepackagedPasteurizedByRetailer: Maybe<Scalars['Boolean']>
  productCategory: Maybe<Scalars['String']>
  productTags: Maybe<Scalars['String']>
  prop65Text: Maybe<Scalars['String']>
  requireReheating: Maybe<Scalars['Boolean']>
  requiresKeepFrozen: Maybe<Scalars['Boolean']>
  requiresRefrigeration: Maybe<Scalars['Boolean']>
  sizeUom: Maybe<Scalars['String']>
  suggestedIncrementalWeight: Maybe<Scalars['Float']>
  vertexTaxOverrideAttribute: Maybe<Scalars['String']>
  weightWatchers: Maybe<Scalars['Boolean']>
  wholeGrain: Maybe<Scalars['Boolean']>
}

export type RetailerProductData = {
  __typename?: 'RetailerProductData'
  retailerId: Maybe<Scalars['BigInt']>
  productId: Maybe<Scalars['BigInt']>
  maxPriceCents: Maybe<Scalars['BigInt']>
  minPriceCents: Maybe<Scalars['BigInt']>
  itemsCount: Maybe<Scalars['BigInt']>
  availableItemsCount: Maybe<Scalars['BigInt']>
  visibleItemsCount: Maybe<Scalars['BigInt']>
  generatedAt: Maybe<Scalars['DateTime']>
}

export type RetailerProductId = {
  __typename?: 'RetailerProductId'
  productId: Maybe<Scalars['BigInt']>
  retailerId: Maybe<Scalars['BigInt']>
}

export type RetailerProductIdInput = {
  productId?: Maybe<Scalars['BigInt']>
  retailerId?: Maybe<Scalars['BigInt']>
}

export enum RetailerServiceType {
  ServiceTypeUndefined = 'SERVICE_TYPE_UNDEFINED',
  Delivery = 'DELIVERY',
  Pickup = 'PICKUP',
}

export type RetailersPickupRetailerLocationGroup = {
  __typename?: 'RetailersPickupRetailerLocationGroup'
  /** A unique identifier for the location group */
  id: Scalars['ID']
  /** A name for this location group */
  name: Scalars['String']
  /** The identifier for the retailer which all locations in the group belong to */
  retailerId: Scalars['ID']
  /** The retailer locations associated with the group */
  retailerLocations: Array<RetailerLocation>
}

export type RetailersRetailerLocationGroup = {
  __typename?: 'RetailersRetailerLocationGroup'
  /** A unique identifier for the location group */
  id: Scalars['ID']
  /** A name for this location group */
  name: Scalars['String']
  /** The identifier for the retailer which all locations in the group belong to */
  retailerId: Scalars['ID']
  /** The ids for the retailer locations associated with the group */
  retailerLocationIds: Array<Scalars['ID']>
  /** The retailer locations associated with the group */
  retailerLocations: RetailerLocationConnection
  /** The time at which the group was last updated */
  updatedAt: Scalars['Time']
}

export type RetailersRetailerLocationGroupRetailerLocationsArgs = {
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

/** The connection type for RetailersRetailerLocationGroup. */
export type RetailersRetailerLocationGroupConnection = {
  __typename?: 'RetailersRetailerLocationGroupConnection'
  /** A list of edges. */
  edges: Maybe<Array<Maybe<RetailersRetailerLocationGroupEdge>>>
  /** Metadata regarding the connection */
  meta: ConnectionMeta
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<RetailersRetailerLocationGroup>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type RetailersRetailerLocationGroupEdge = {
  __typename?: 'RetailersRetailerLocationGroupEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: Maybe<RetailersRetailerLocationGroup>
}

export type SecondaryBanner = {
  __typename?: 'SecondaryBanner'
  id: Maybe<Scalars['BigInt']>
  variant: Maybe<BannerVariant>
  title: Maybe<Scalars['String']>
  titleColorHex: Maybe<Scalars['String']>
  subTitle: Maybe<Scalars['String']>
  subTitleColorHex: Maybe<Scalars['String']>
  cta: Maybe<Scalars['String']>
  mobileImageUrl: Maybe<Scalars['String']>
  desktopImageUrl: Maybe<Scalars['String']>
  placementId: Maybe<Scalars['BigInt']>
  ctaAction: Maybe<BannerAction>
  backgroundColorHex: Maybe<Scalars['String']>
  ctaColorHex: Maybe<Scalars['String']>
  ctaBackgroundColorHex: Maybe<Scalars['String']>
  secondaryText: Maybe<Scalars['String']>
  secondaryTextColorHex: Maybe<Scalars['String']>
  clientVisibilityConditions: Maybe<Array<Maybe<ClientVisibilityCondition>>>
}

export type SecondaryBannerInput = {
  id?: Maybe<Scalars['BigInt']>
  variant?: Maybe<BannerVariant>
  title?: Maybe<Scalars['String']>
  titleColorHex?: Maybe<Scalars['String']>
  subTitle?: Maybe<Scalars['String']>
  subTitleColorHex?: Maybe<Scalars['String']>
  cta?: Maybe<Scalars['String']>
  mobileImageUrl?: Maybe<Scalars['String']>
  desktopImageUrl?: Maybe<Scalars['String']>
  placementId?: Maybe<Scalars['BigInt']>
  ctaAction?: Maybe<BannerActionInput>
  backgroundColorHex?: Maybe<Scalars['String']>
  ctaColorHex?: Maybe<Scalars['String']>
  ctaBackgroundColorHex?: Maybe<Scalars['String']>
  secondaryText?: Maybe<Scalars['String']>
  secondaryTextColorHex?: Maybe<Scalars['String']>
  clientVisibilityConditions?: Maybe<Array<Maybe<ClientVisibilityConditionInput>>>
}

/** Autogenerated return type of SecondaryBannerPlacementCreate */
export type SecondaryBannerPlacementCreatePayload = {
  __typename?: 'SecondaryBannerPlacementCreatePayload'
  /** The newly created secondary_banner placement */
  secondaryBannerPlacement: ContentManagementSecondaryBannerPlacement
}

export type SecondaryBannerPlacementInput = {
  /** The name of the placement */
  name: Scalars['String']
  /** The images on the banner */
  images: GenericImagesInput
  /** Where interacting with the placement leads */
  destination?: Maybe<PlacementDestinationInput>
  /** When the placement begins and ends */
  scheduling: PlacementScheduleInput
  /** The style and text of the button within the placement */
  button: ConfigurableButtonInput
  /** The style and text of the heading */
  headingText: ConfigurableTextInput
  /** The style and text of the subheading */
  subheadingText: ConfigurableTextInput
  /** The style and text of the secondary text */
  secondaryText?: Maybe<ConfigurableTextInput>
  /** The platform which this placement should be displayed */
  platform: Array<PlacementPlatformEnum>
  /** The type of this placement */
  type: PlacementTypeEnum
  /** The color of the background for text placements (Eg. #FFFFFF) */
  backgroundColor: Scalars['String']
  /** The priority rank of the placement */
  rank?: Maybe<Scalars['Int']>
  /** Information of Experiment associated with the placement */
  experiment?: Maybe<PlacementExperimentInput>
  enabled?: Maybe<Scalars['Boolean']>
}

/** Autogenerated return type of SecondaryBannerPlacementUpdate */
export type SecondaryBannerPlacementUpdatePayload = {
  __typename?: 'SecondaryBannerPlacementUpdatePayload'
  /** The updated secondary_banner placement */
  secondaryBannerPlacement: ContentManagementSecondaryBannerPlacement
}

export enum ShiftTypeEnum {
  PickingOnly = 'PICKING_ONLY',
  Runner = 'RUNNER',
  FullService = 'FULL_SERVICE',
}

export type ShoppedAtRetailerInput = {
  /** A unique identifier of the visibility condition */
  id?: Maybe<Scalars['ID']>
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID']
  /** Id of the Retailer */
  retailerId: Scalars['Int']
  /** Whether the user should have shopped at the retailer */
  hasShopped: Scalars['Boolean']
  /** Number of days in the past to check */
  numberOfDays?: Maybe<Scalars['Int']>
  /** Id of the country where the check is to be performed */
  countryId?: Maybe<Scalars['Int']>
  /** Id of the store configuraiton for which the check is to be performed */
  storeConfigurationId?: Maybe<Scalars['Int']>
}

/** Autogenerated return type of ShoppedAtRetailerVisibilityConditionCreate */
export type ShoppedAtRetailerVisibilityConditionCreatePayload = {
  __typename?: 'ShoppedAtRetailerVisibilityConditionCreatePayload'
  /** The newly created shopped_at_retailer visibility condition */
  shoppedAtRetailerVisibilityCondition: ContentManagementVisibilityConditionShoppedAtRetailer
}

/** Autogenerated return type of ShoppedAtRetailerVisibilityConditionUpdate */
export type ShoppedAtRetailerVisibilityConditionUpdatePayload = {
  __typename?: 'ShoppedAtRetailerVisibilityConditionUpdatePayload'
  /** The newly created shopped_at_retailer visibility condition */
  shoppedAtRetailerVisibilityCondition: ContentManagementVisibilityConditionShoppedAtRetailer
}

export type ShoppedInput = {
  /** A unique identifier of the visibility condition */
  id?: Maybe<Scalars['ID']>
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID']
  /** Whether the user should have shopped at the retailer */
  hasShopped: Scalars['Boolean']
  /** Number of days in the past to check */
  numberOfDays?: Maybe<Scalars['Int']>
  /** Number of times in the past to check */
  numberOfTimes?: Maybe<Scalars['Int']>
  /** Id of the country where the check is to be performed */
  countryId?: Maybe<Scalars['Int']>
  /** Id of the store configuraiton for which the check is to be performed */
  storeConfigurationId?: Maybe<Scalars['Int']>
}

/** Autogenerated return type of ShoppedVisibilityConditionCreate */
export type ShoppedVisibilityConditionCreatePayload = {
  __typename?: 'ShoppedVisibilityConditionCreatePayload'
  /** The newly created shopped visibility condition */
  shoppedVisibilityCondition: ContentManagementVisibilityConditionShopped
}

/** Autogenerated return type of ShoppedVisibilityConditionUpdate */
export type ShoppedVisibilityConditionUpdatePayload = {
  __typename?: 'ShoppedVisibilityConditionUpdatePayload'
  /** The newly created shopped visibility condition */
  shoppedVisibilityCondition: ContentManagementVisibilityConditionShopped
}

export type ShopperOriginatedData = {
  __typename?: 'ShopperOriginatedData'
  customerBagCount: Maybe<GoogleProtobufInt32Value>
}

export enum ShopperType {
  ShopperTypeUnknown = 'SHOPPER_TYPE_UNKNOWN',
  ShopperTypePartnerPick = 'SHOPPER_TYPE_PARTNER_PICK',
  ShopperTypeFss = 'SHOPPER_TYPE_FSS',
}

export type SnowflakeTopProductsItem = {
  __typename?: 'SnowflakeTopProductsItem'
  /** Availability of the product, denoted as percentage */
  availabilityPercentage: Scalars['Float']
  /** Name of the department the product belongs to */
  department: Scalars['String']
  /** How often an item was found, denoted as percentage */
  foundRatePercentage: Scalars['Float']
  /** Total GMV for the product */
  gmv: Scalars['Float']
  /** Unique identifier */
  id: Scalars['ID']
  /** The image url for the product */
  imageUrl: Scalars['String']
  /** Total number of items this ordered for this product */
  orderedItems: Scalars['Int']
  /** The product's name */
  productName: Scalars['String']
  /** How often an item was refunded, denoted as percentage */
  refundRatePercentage: Scalars['Float']
}

export type SnowflakeTopProductsResult = {
  __typename?: 'SnowflakeTopProductsResult'
  /** A list of top items */
  topProducts: Array<SnowflakeTopProductsItem>
  /** Total number of results */
  totalCount: Scalars['Int']
}

export enum SourceLevel {
  SourceLevelUnknown = 'SOURCE_LEVEL_UNKNOWN',
  SourceLevelProduct = 'SOURCE_LEVEL_PRODUCT',
  SourceLevelRetailerProduct = 'SOURCE_LEVEL_RETAILER_PRODUCT',
  SourceLevelMulti = 'SOURCE_LEVEL_MULTI',
}

export enum Status {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Live = 'LIVE',
  /** The tour has not been seen by the user */
  Pending = 'PENDING',
  /** The tour has been displayed to the user, but not finished */
  Shown = 'SHOWN',
  /** The tour has been finished by the user */
  Completed = 'COMPLETED',
}

export type StorefrontPlacementBannerInput = {
  /** A unique identifier of the banner associated with the placement */
  id?: Maybe<Scalars['ID']>
  /** The possible placement images to display */
  images: PlacementImagesInput
  /** the alt text for the placement images */
  imageAltText: Scalars['String']
  /** The style and text of the button within the placement */
  button: ConfigurableButtonInput
  /** The style and text of the heading */
  headingText: ConfigurableTextInput
  /** The style and text of the subheading */
  subheadingText: ConfigurableTextInput
  /** The style and text of the description */
  descriptionText: ConfigurableTextInput
  /** The color of the background for text placements (Eg. #FFFFFF) */
  backgroundColor: Scalars['String']
  /** The banner's locale (not used right now) */
  locale: BannerLocaleEnum
}

/** Autogenerated return type of StorefrontPlacementCreate */
export type StorefrontPlacementCreatePayload = {
  __typename?: 'StorefrontPlacementCreatePayload'
  /** The newly created storefront storefront placement */
  storefrontPlacement: ContentManagementStorefrontPlacement
}

/** Autogenerated return type of StorefrontPlacementDelete */
export type StorefrontPlacementDeletePayload = {
  __typename?: 'StorefrontPlacementDeletePayload'
  /** Whether deleting the storefront placement succeeded or not */
  success: Scalars['Boolean']
}

export type StorefrontPlacementInput = {
  /** The name of the placement */
  name: Scalars['String']
  /** The possible placement images to display */
  images: PlacementImagesInput
  /** the alt text for the placement images */
  imageAltText: Scalars['String']
  /** Where interacting with the placement leads */
  destination?: Maybe<PlacementDestinationInput>
  /** When the placement begins and ends */
  scheduling: PlacementScheduleInput
  /** The style and text of the button within the placement */
  button: ConfigurableButtonInput
  /** The style and text of the heading */
  headingText: ConfigurableTextInput
  /** The style and text of the subheading */
  subheadingText: ConfigurableTextInput
  /** The style and text of the description */
  descriptionText: ConfigurableTextInput
  /** The platform which this placement should be displayed */
  platform: Array<PlacementPlatformEnum>
  /** The type of this placement */
  type: PlacementTypeEnum
  /** The color of the background for text placements (Eg. #FFFFFF) */
  backgroundColor: Scalars['String']
  /** The banners configured to the placement */
  banners?: Maybe<Array<StorefrontPlacementBannerInput>>
}

/** Autogenerated return type of StorefrontPlacementUpdate */
export type StorefrontPlacementUpdatePayload = {
  __typename?: 'StorefrontPlacementUpdatePayload'
  /** The updated storefront placement */
  storefrontPlacement: ContentManagementStorefrontPlacement
}

export type StoreHours = {
  __typename?: 'StoreHours'
  retailerLocationId: Maybe<Scalars['BigInt']>
  regularHours: Maybe<Array<Maybe<RegularHours>>>
  overrideHours: Maybe<Array<Maybe<OverrideHours>>>
}

export type StoreHoursByDate = {
  __typename?: 'StoreHoursByDate'
  retailerLocationId: Maybe<Scalars['BigInt']>
  zoneId: Maybe<Scalars['BigInt']>
  retailerId: Maybe<Scalars['BigInt']>
  date: Maybe<GoogleTypeDate>
  startsAt: Maybe<GoogleTypeTimeOfDay>
  endsAt: Maybe<GoogleTypeTimeOfDay>
  retailerLocationFlags: Maybe<RetailerLocationFlags>
  updatedAt: Maybe<Scalars['DateTime']>
  createdAt: Maybe<Scalars['DateTime']>
}

export type StoreHoursByDayOfWeek = {
  __typename?: 'StoreHoursByDayOfWeek'
  retailerLocationId: Maybe<Scalars['BigInt']>
  zoneId: Maybe<Scalars['BigInt']>
  retailerId: Maybe<Scalars['BigInt']>
  dayOfWeek: Maybe<GoogleTypeDayOfWeek>
  startsAt: Maybe<GoogleTypeTimeOfDay>
  endsAt: Maybe<GoogleTypeTimeOfDay>
  retailerLocationFlags: Maybe<RetailerLocationFlags>
  updatedAt: Maybe<Scalars['DateTime']>
  createdAt: Maybe<Scalars['DateTime']>
}

export type StoreHoursUpdateTask = {
  __typename?: 'StoreHoursUpdateTask'
  id: Maybe<Scalars['BigInt']>
  updatedRetailerLocationIds: Maybe<Array<Maybe<Scalars['BigInt']>>>
  status: Maybe<TaskStatus>
  createdAt: Maybe<Scalars['DateTime']>
  completedAt: Maybe<Scalars['DateTime']>
  updateSource: Maybe<Scalars['String']>
}

export type StorePerformanceRecord = {
  __typename?: 'StorePerformanceRecord'
  warehouseLocationId: Maybe<Scalars['BigInt']>
  scheduledHours: Maybe<InstacartTypesV1BigDecimal>
  recommendedHours: Maybe<InstacartTypesV1BigDecimal>
  understaffedHours: Maybe<InstacartTypesV1BigDecimal>
  overstaffedHours: Maybe<InstacartTypesV1BigDecimal>
  scheduledGaps: Maybe<Scalars['Int']>
  scheduledDevices: Maybe<Scalars['Int']>
  name: Maybe<Scalars['String']>
}

export type StorePerformanceRequestInput = {
  warehouseLocationIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>
  startDate?: Maybe<GoogleTypeDateInput>
  endDate?: Maybe<GoogleTypeDateInput>
  warehouseId?: Maybe<Scalars['BigInt']>
}

export type StorePerformanceResponse = {
  __typename?: 'StorePerformanceResponse'
  warehouseId: Maybe<Scalars['BigInt']>
  updatedAt: Maybe<Scalars['DateTime']>
  metric: Maybe<Array<Maybe<StorePerformanceRecord>>>
}

export type StringsInput = {
  values?: Maybe<Array<Maybe<Scalars['String']>>>
}

export type TaskComponent = {
  __typename?: 'TaskComponent'
  type: Maybe<Scalars['String']>
  name: Maybe<Scalars['String']>
  intComment: Maybe<Scalars['String']>
  extComment: Maybe<Scalars['String']>
  explicitAuditFailed: Maybe<Scalars['Boolean']>
}

export type TaskComponentInput = {
  type?: Maybe<Scalars['String']>
  name?: Maybe<Scalars['String']>
  intComment?: Maybe<Scalars['String']>
  extComment?: Maybe<Scalars['String']>
  explicitAuditFailed?: Maybe<Scalars['Boolean']>
}

export enum TaskStatus {
  TaskStatusUndefined = 'TASK_STATUS_UNDEFINED',
  Queued = 'QUEUED',
  Running = 'RUNNING',
  CompletedSuccess = 'COMPLETED_SUCCESS',
  CompletedFailure = 'COMPLETED_FAILURE',
}

export type TextWithThumbnail = {
  __typename?: 'TextWithThumbnail'
  id: Maybe<Scalars['BigInt']>
  variant: Maybe<BannerVariant>
  title: Maybe<Scalars['String']>
  titleColorHex: Maybe<Scalars['String']>
  subTitle: Maybe<Scalars['String']>
  subTitleColorHex: Maybe<Scalars['String']>
  cta: Maybe<Scalars['String']>
  imageUrl: Maybe<Scalars['String']>
  backgroundImageUrl: Maybe<Scalars['String']>
  placementId: Maybe<Scalars['BigInt']>
  ctaAction: Maybe<BannerAction>
  backgroundColorHex: Maybe<Scalars['String']>
  ctaColorHex: Maybe<Scalars['String']>
  ctaBackgroundColorHex: Maybe<Scalars['String']>
}

export type TextWithThumbnailFlex = {
  __typename?: 'TextWithThumbnailFlex'
  id: Maybe<Scalars['BigInt']>
  variant: Maybe<BannerVariant>
  title: Maybe<Scalars['String']>
  titleColorHex: Maybe<Scalars['String']>
  subTitle: Maybe<Scalars['String']>
  subTitleColorHex: Maybe<Scalars['String']>
  cta: Maybe<Scalars['String']>
  imageUrl: Maybe<Scalars['String']>
  backgroundImageUrl: Maybe<Scalars['String']>
  placementId: Maybe<Scalars['BigInt']>
  ctaAction: Maybe<BannerAction>
  backgroundColorHex: Maybe<Scalars['String']>
  ctaColorHex: Maybe<Scalars['String']>
  ctaBackgroundColorHex: Maybe<Scalars['String']>
  visibilityConditions: Maybe<Array<Maybe<ClientVisibilityCondition>>>
}

export type TextWithThumbnailFlexInput = {
  id?: Maybe<Scalars['BigInt']>
  variant?: Maybe<BannerVariant>
  title?: Maybe<Scalars['String']>
  titleColorHex?: Maybe<Scalars['String']>
  subTitle?: Maybe<Scalars['String']>
  subTitleColorHex?: Maybe<Scalars['String']>
  cta?: Maybe<Scalars['String']>
  imageUrl?: Maybe<Scalars['String']>
  backgroundImageUrl?: Maybe<Scalars['String']>
  placementId?: Maybe<Scalars['BigInt']>
  ctaAction?: Maybe<BannerActionInput>
  backgroundColorHex?: Maybe<Scalars['String']>
  ctaColorHex?: Maybe<Scalars['String']>
  ctaBackgroundColorHex?: Maybe<Scalars['String']>
  visibilityConditions?: Maybe<Array<Maybe<ClientVisibilityConditionInput>>>
}

/** Autogenerated return type of TextWithThumbnailFlexPlacementCreate */
export type TextWithThumbnailFlexPlacementCreatePayload = {
  __typename?: 'TextWithThumbnailFlexPlacementCreatePayload'
  /** The newly created text_with_thumbnail placement */
  textWithThumbnailFlexPlacement: ContentManagementTextWithThumbnailFlexPlacement
}

export type TextWithThumbnailFlexPlacementInput = {
  /** The name of the placement */
  name: Scalars['String']
  /** The images on the banner */
  images: TextWithThumbnailImagesInput
  /** Where interacting with the placement leads */
  destination?: Maybe<PlacementDestinationInput>
  /** When the placement begins and ends */
  scheduling: PlacementScheduleInput
  /** The style and text of the button within the placement */
  button: ConfigurableButtonInput
  /** The style and text of the heading */
  headingText: ConfigurableTextInput
  /** The style and text of the subheading */
  subheadingText: ConfigurableTextInput
  /** The platform which this placement should be displayed */
  platform: Array<PlacementPlatformEnum>
  /** The type of this placement */
  type: PlacementTypeEnum
  /** The color of the background for text placements (Eg. #FFFFFF) */
  backgroundColor: Scalars['String']
  /** The priority rank of the placement */
  rank?: Maybe<Scalars['Int']>
  /** Information of Experiment associated with the placement */
  experiment?: Maybe<PlacementExperimentInput>
  enabled?: Maybe<Scalars['Boolean']>
}

/** Autogenerated return type of TextWithThumbnailFlexPlacementUpdate */
export type TextWithThumbnailFlexPlacementUpdatePayload = {
  __typename?: 'TextWithThumbnailFlexPlacementUpdatePayload'
  /** The updated text_with_thumbnail_flex placement */
  textWithThumbnailFlexPlacement: ContentManagementTextWithThumbnailFlexPlacement
}

export type TextWithThumbnailImagesInput = {
  /** The image url of logo image */
  logo: Scalars['Url']
  /** The image url of the background image */
  background?: Maybe<Scalars['Url']>
}

export type TextWithThumbnailInput = {
  id?: Maybe<Scalars['BigInt']>
  variant?: Maybe<BannerVariant>
  title?: Maybe<Scalars['String']>
  titleColorHex?: Maybe<Scalars['String']>
  subTitle?: Maybe<Scalars['String']>
  subTitleColorHex?: Maybe<Scalars['String']>
  cta?: Maybe<Scalars['String']>
  imageUrl?: Maybe<Scalars['String']>
  backgroundImageUrl?: Maybe<Scalars['String']>
  placementId?: Maybe<Scalars['BigInt']>
  ctaAction?: Maybe<BannerActionInput>
  backgroundColorHex?: Maybe<Scalars['String']>
  ctaColorHex?: Maybe<Scalars['String']>
  ctaBackgroundColorHex?: Maybe<Scalars['String']>
}

/** Autogenerated return type of TextWithThumbnailPlacementCreate */
export type TextWithThumbnailPlacementCreatePayload = {
  __typename?: 'TextWithThumbnailPlacementCreatePayload'
  /** The newly created text_with_thumbnail placement */
  textWithThumbnailPlacement: ContentManagementTextWithThumbnailPlacement
}

export type TextWithThumbnailPlacementInput = {
  /** The name of the placement */
  name: Scalars['String']
  /** The images on the banner */
  images: TextWithThumbnailImagesInput
  /** Where interacting with the placement leads */
  destination?: Maybe<PlacementDestinationInput>
  /** When the placement begins and ends */
  scheduling: PlacementScheduleInput
  /** The style and text of the button within the placement */
  button: ConfigurableButtonInput
  /** The style and text of the heading */
  headingText: ConfigurableTextInput
  /** The style and text of the subheading */
  subheadingText: ConfigurableTextInput
  /** The platform which this placement should be displayed */
  platform: Array<PlacementPlatformEnum>
  /** The type of this placement */
  type: PlacementTypeEnum
  /** The color of the background for text placements (Eg. #FFFFFF) */
  backgroundColor: Scalars['String']
  /** The priority rank of the placement */
  rank?: Maybe<Scalars['Int']>
  /** Information of Experiment associated with the placement */
  experiment?: Maybe<PlacementExperimentInput>
  enabled?: Maybe<Scalars['Boolean']>
}

/** Autogenerated return type of TextWithThumbnailPlacementUpdate */
export type TextWithThumbnailPlacementUpdatePayload = {
  __typename?: 'TextWithThumbnailPlacementUpdatePayload'
  /** The updated text_with_thumbnail placement */
  textWithThumbnailPlacement: ContentManagementTextWithThumbnailPlacement
}

export type TimeOfDay = {
  __typename?: 'TimeOfDay'
  startHour: Maybe<Scalars['BigInt']>
  startMinute: Maybe<Scalars['BigInt']>
  endHour: Maybe<Scalars['BigInt']>
  endMinute: Maybe<Scalars['BigInt']>
}

export type TimeOfDayInput = {
  startHour?: Maybe<Scalars['BigInt']>
  startMinute?: Maybe<Scalars['BigInt']>
  endHour?: Maybe<Scalars['BigInt']>
  endMinute?: Maybe<Scalars['BigInt']>
}

export type TokensValidation = {
  __typename?: 'TokensValidation'
  /** Whether the token is valid */
  valid: Scalars['Boolean']
}

export enum TokenTypeEnum {
  /** Email Verification Token Type */
  EmailVerification = 'email_verification',
  /** Password Reset Token Type */
  PasswordReset = 'password_reset',
}

export type UnknownBanner = {
  __typename?: 'UnknownBanner'
  id: Maybe<Scalars['BigInt']>
}

export type UnknownBannerInput = {
  id?: Maybe<Scalars['BigInt']>
}

export type UpdateApiSettingRequestInput = {
  id?: Maybe<Scalars['BigInt']>
  partnerId?: Maybe<Scalars['BigInt']>
  retailerId?: Maybe<Scalars['BigInt']>
  apiType?: Maybe<Scalars['String']>
  cron?: Maybe<Scalars['String']>
  integrationType?: Maybe<Scalars['String']>
  enabled?: Maybe<Scalars['Boolean']>
}

export type UpdateApiSettingResponse = {
  __typename?: 'UpdateApiSettingResponse'
  id: Maybe<Scalars['BigInt']>
  partnerId: Maybe<Scalars['BigInt']>
  apiType: Maybe<Scalars['String']>
  cron: Maybe<Scalars['String']>
  integrationType: Maybe<Scalars['String']>
  enabled: Maybe<Scalars['Boolean']>
}

export type UpdateAuditBatchRequestInput = {
  client?: Maybe<Scalars['String']>
  batchUuid?: Maybe<Scalars['String']>
  action?: Maybe<Scalars['String']>
  overrideDueDate?: Maybe<Scalars['DateTime']>
  changeSampleSizeValue?: Maybe<Scalars['BigInt']>
  version?: Maybe<Scalars['BigInt']>
}

export type UpdateAuditBatchResponse = {
  __typename?: 'UpdateAuditBatchResponse'
  message: Maybe<Scalars['String']>
  version: Maybe<Scalars['BigInt']>
  state: Maybe<Scalars['String']>
  completedAt: Maybe<Scalars['DateTime']>
}

export type UpdateAuditTaskRequestInput = {
  client?: Maybe<Scalars['String']>
  taskUuid?: Maybe<Scalars['String']>
  state?: Maybe<Scalars['String']>
  intComment?: Maybe<Scalars['String']>
  extComment?: Maybe<Scalars['String']>
  version?: Maybe<Scalars['BigInt']>
  taskComponents?: Maybe<Array<Maybe<TaskComponentInput>>>
}

export type UpdateAuditTaskResponse = {
  __typename?: 'UpdateAuditTaskResponse'
  message: Maybe<Scalars['String']>
  version: Maybe<Scalars['BigInt']>
  batchVersion: Maybe<Scalars['BigInt']>
}

export type UpdateParkingSettingsRequestInput = {
  retailerLocationId?: Maybe<Scalars['BigInt']>
  type?: Maybe<PickupType>
  setDefault?: Maybe<Scalars['Boolean']>
  instruction?: Maybe<Scalars['String']>
  imageConfigs?: Maybe<Array<Maybe<ImageConfigInput>>>
}

export type UpdateParkingSettingsResponse = {
  __typename?: 'UpdateParkingSettingsResponse'
  retailerLocationConfig: Maybe<RetailerLocationInfo>
  instruction: Maybe<Scalars['String']>
  imageConfigs: Maybe<Array<Maybe<ImageConfig>>>
  errors: Maybe<Array<Maybe<Scalars['String']>>>
}

export type UpdateRetailerAisleTemplateRequestInput = {
  retailerLocationIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>
  shopperType?: Maybe<ShopperType>
  aisleOrders?: Maybe<Array<Maybe<AisleOrderInput>>>
}

export type UpdateRetailerAisleTemplateResponse = {
  __typename?: 'UpdateRetailerAisleTemplateResponse'
  updated: Maybe<Scalars['Boolean']>
  errors: Maybe<Array<Maybe<Scalars['String']>>>
}

export type UpdateStagingSettingsRequestInput = {
  retailerLocationId?: Maybe<Scalars['BigInt']>
  shelf?: Maybe<StringsInput>
  fridge?: Maybe<StringsInput>
  freezer?: Maybe<StringsInput>
  imageUrl?: Maybe<Scalars['String']>
  instruction?: Maybe<Scalars['String']>
}

export type UpdateStagingSettingsResponse = {
  __typename?: 'UpdateStagingSettingsResponse'
  retailerLocationConfig: Maybe<RetailerLocationInfo>
  shelf: Maybe<Array<Maybe<Scalars['String']>>>
  fridge: Maybe<Array<Maybe<Scalars['String']>>>
  freezer: Maybe<Array<Maybe<Scalars['String']>>>
  imageUrl: Maybe<Scalars['String']>
  instruction: Maybe<Scalars['String']>
  errors: Maybe<Array<Maybe<Scalars['String']>>>
}

export type UpdateStoreHoursByDateInputInput = {
  retailerLocationId?: Maybe<Scalars['BigInt']>
  date?: Maybe<GoogleTypeDateInput>
  startsAt?: Maybe<GoogleTypeTimeOfDayInput>
  endsAt?: Maybe<GoogleTypeTimeOfDayInput>
}

export type UpdateStoreHoursByDateRequestInput = {
  storeHoursToUpdate?: Maybe<Array<Maybe<UpdateStoreHoursByDateInputInput>>>
}

export type UpdateStoreHoursByDateResponse = {
  __typename?: 'UpdateStoreHoursByDateResponse'
  updatedStoreHours: Maybe<Array<Maybe<StoreHoursByDate>>>
}

export type UpdateStoreHoursRequestInput = {
  retailerId?: Maybe<Scalars['BigInt']>
  retailerLocationIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>
  updateRegularHours?: Maybe<Array<Maybe<RegularHoursInput>>>
  upsertOverrideHours?: Maybe<Array<Maybe<OverrideHoursInput>>>
  clearOverrideHoursByType?: Maybe<Array<Maybe<RetailerServiceType>>>
  updateSource?: Maybe<Scalars['String']>
}

export type UpdateStoreHoursResponse = {
  __typename?: 'UpdateStoreHoursResponse'
  taskId: Maybe<Scalars['BigInt']>
}

export type UpsertStoreHoursByDayOfWeekInputInput = {
  retailerLocationId?: Maybe<Scalars['BigInt']>
  dayOfWeek?: Maybe<GoogleTypeDayOfWeek>
  startsAt?: Maybe<GoogleTypeTimeOfDayInput>
  endsAt?: Maybe<GoogleTypeTimeOfDayInput>
}

export type UpsertStoreHoursByDayOfWeekRequestInput = {
  storeHoursToUpdate?: Maybe<Array<Maybe<UpsertStoreHoursByDayOfWeekInputInput>>>
}

export type UpsertStoreHoursByDayOfWeekResponse = {
  __typename?: 'UpsertStoreHoursByDayOfWeekResponse'
  updatedStoreHours: Maybe<Array<Maybe<StoreHoursByDayOfWeek>>>
}

export type ValueBasedOverrideRequestInput = {
  entityId?: Maybe<EntityIdInput>
  attributeName?: Maybe<Scalars['String']>
  overrideType?: Maybe<OverrideType>
  sourceValue?: Maybe<Scalars['String']>
  overrideValue?: Maybe<Scalars['String']>
  createdBy?: Maybe<RemoteUserInput>
  createdWhy?: Maybe<Scalars['String']>
  sourceType?: Maybe<Scalars['String']>
  ticketUrl?: Maybe<Scalars['String']>
  expiryDate?: Maybe<Scalars['DateTime']>
}

export type ValueBasedOverrideResponse = {
  __typename?: 'ValueBasedOverrideResponse'
  rowId: Maybe<Scalars['BigInt']>
  entityId: Maybe<EntityId>
  attributeName: Maybe<Scalars['String']>
  overrideType: Maybe<OverrideType>
  sourceValue: Maybe<Scalars['String']>
  overrideValue: Maybe<Scalars['String']>
  createdByJson: Maybe<Scalars['String']>
  createdWhy: Maybe<Scalars['String']>
  sourceType: Maybe<Scalars['String']>
  ticketUrl: Maybe<Scalars['String']>
  expiryDate: Maybe<Scalars['DateTime']>
  createdAt: Maybe<Scalars['DateTime']>
}

/** Union of the Types of Visibility Conditions which may be returned */
export type VisibilityCondition =
  | ContentManagementVisibilityConditionDayOfWeek
  | ContentManagementVisibilityConditionExpressMembership
  | ContentManagementVisibilityConditionExpressNonmemberLongTermHoldout
  | ContentManagementVisibilityConditionMinimumPlatformVersion
  | ContentManagementVisibilityConditionShopped
  | ContentManagementVisibilityConditionShoppedAtRetailer
  | ContentManagementVisibilityConditionUnknownVisibilityCondition
  | ContentManagementVisibilityConditionWhitelistedPostalCodes

/** Autogenerated return type of VisibilityConditionDelete */
export type VisibilityConditionDeletePayload = {
  __typename?: 'VisibilityConditionDeletePayload'
  /** Whether deleting the visibility condition succeeded or not */
  success: Scalars['Boolean']
}

export type WhitelistedPostalCodesInput = {
  /** A unique identifier of the visibility condition */
  id?: Maybe<Scalars['ID']>
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID']
  /** List of postal codes */
  postalCodes: Array<Scalars['String']>
}

/** Autogenerated return type of WhitelistedPostalCodesVisibilityConditionCreate */
export type WhitelistedPostalCodesVisibilityConditionCreatePayload = {
  __typename?: 'WhitelistedPostalCodesVisibilityConditionCreatePayload'
  /** The newly created whitelisted_postal_codes visibility condition */
  whitelistedPostalCodesVisibilityCondition: ContentManagementVisibilityConditionWhitelistedPostalCodes
}

/** Autogenerated return type of WhitelistedPostalCodesVisibilityConditionUpdate */
export type WhitelistedPostalCodesVisibilityConditionUpdatePayload = {
  __typename?: 'WhitelistedPostalCodesVisibilityConditionUpdatePayload'
  /** The newly created whitelisted_postal_codes visibility condition */
  whitelistedPostalCodesVisibilityCondition: ContentManagementVisibilityConditionWhitelistedPostalCodes
}

/** Autogenerated return type of WizardProgressUpdate */
export type WizardProgressUpdatePayload = {
  __typename?: 'WizardProgressUpdatePayload'
  /** A status which is true if no errors were encountered while performing the update */
  success: Scalars['True']
}

export enum WizardStatusEnum {
  InProgress = 'IN_PROGRESS',
  Completed = 'COMPLETED',
}

export type WizardsWizardProgress = {
  __typename?: 'WizardsWizardProgress'
  id: Scalars['ID']
  status: WizardStatusEnum
  wizardType: WizardTypeEnum
}

export enum WizardTypeEnum {
  PickupSettingsOnboarding = 'PICKUP_SETTINGS_ONBOARDING',
}

/** Event type and payload [attributes] for creating a workflow event */
export type WorkflowEventCreationInput = {
  /** The kind of workflow event which should be created */
  workflowEventType: WorkflowEventTypeEnum
  /** The event payload attributes associated with this workflow event */
  workflowEventPayload: WorkflowEventPayloadInput
}

/** Payload attributes for creating a workflow event - note that this lists the allowed attributes for all event payloads */
export type WorkflowEventPayloadInput = {
  /** The id for the the product associated with this event */
  productId?: Maybe<Scalars['ID']>
  /** The id for the import process code-lookup associated with this event */
  importProcessCodeLookupId?: Maybe<Scalars['ID']>
  /** The id for the changeset product associated with this event */
  changesetProductId?: Maybe<Scalars['ID']>
  /** The id for the aisle that the product should be added to */
  aisleId?: Maybe<Scalars['ID']>
  /** The id for the department that the product should be added to */
  departmentId?: Maybe<Scalars['ID']>
  /** The cost unit which should be set for the product - (each, lb, ...) */
  costUnit?: Maybe<CostUnitEnum>
  /** The price which should be set for the product - (12.99) */
  pricePerCostUnit?: Maybe<Scalars['Float']>
  /** The classified code/type associated with the product (contains UPC details) */
  classificationInfo?: Maybe<ClassificationInfoInput>
  /** The name which should be set for the product - `Hershey's Extra Large Chocolate Bar` */
  name?: Maybe<Scalars['String']>
  /** The brand which should be set for the product - `Hershey's` */
  brand?: Maybe<Scalars['String']>
  /** Details about the product, e.g. `Brown, overripe bananas, suitable for baking` */
  description?: Maybe<Scalars['String']>
  /** The size of the product - (`12 kg`, `14 oz`, ...) */
  size?: Maybe<Scalars['String']>
  /** Is the product taxable? - (true, false) */
  taxable?: Maybe<Scalars['Boolean']>
  /** Is the product alcoholic? - (true, false) */
  alcoholic?: Maybe<Scalars['Boolean']>
  /** Is the product kosher? - (true, false) */
  kosher?: Maybe<Scalars['Boolean']>
  /** Is the product sugar_free? - (true, false) */
  sugarFree?: Maybe<Scalars['Boolean']>
  /** Is the product fat_free? - (true, false) */
  fatFree?: Maybe<Scalars['Boolean']>
  /** Is the product low_fat? - (true, false) */
  lowFat?: Maybe<Scalars['Boolean']>
  /** Is the product vegan? - (true, false) */
  vegan?: Maybe<Scalars['Boolean']>
  /** Is the product gluten_free? - (true, false) */
  glutenFree?: Maybe<Scalars['Boolean']>
  /** Is the product organic? - (true, false) */
  organic?: Maybe<Scalars['Boolean']>
  /** Is the product vegetarian? - (true, false) */
  vegetarian?: Maybe<Scalars['Boolean']>
  /** An absolute url representing the 'primary' angle - `https://www.example.com/etc` */
  imageUrlPrimary?: Maybe<Scalars['Url']>
  /** An absolute url representing the 'left' angle - `https://www.example.com/etc` */
  imageUrlLeft?: Maybe<Scalars['Url']>
  /** An absolute url representing the 'right' angle - `https://www.example.com/etc` */
  imageUrlRight?: Maybe<Scalars['Url']>
  /** An absolute url representing the 'back' angle - `https://www.example.com/etc` */
  imageUrlBack?: Maybe<Scalars['Url']>
  /** An absolute url representing the 'top' angle - `https://www.example.com/etc` */
  imageUrlTop?: Maybe<Scalars['Url']>
  /** An absolute url representing the 'ingredients' angle - `https://www.example.com/etc` */
  imageUrlIngredients?: Maybe<Scalars['Url']>
  /** An absolute url representing the 'nutrition' angle - `https://www.example.com/etc` */
  imageUrlNutrition?: Maybe<Scalars['Url']>
  /** An absolute url representing the 'supplement facts' angle - `https://www.example.com/etc` */
  imageUrlSupplementFacts?: Maybe<Scalars['Url']>
  /** An absolute url representing the 'drug facts' angle - `https://www.example.com/etc` */
  imageUrlDrugFacts?: Maybe<Scalars['Url']>
  /** An absolute url representing the 'lifestyle' angle - `https://www.example.com/etc` */
  imageUrlLifestyle?: Maybe<Scalars['Url']>
}

export enum WorkflowEventTypeEnum {
  /** Import a product from the global catalog into our workflow */
  ImportGlobalProduct = 'IMPORT_GLOBAL_PRODUCT',
  /** Set the aisle for an imported changeset product */
  SetProductAisle = 'SET_PRODUCT_AISLE',
  /** Set the department for an imported changeset product */
  SetProductDepartment = 'SET_PRODUCT_DEPARTMENT',
  /** Set the cost unit for an imported changeset product - (each, lb, ...) */
  SetProductCostUnit = 'SET_PRODUCT_COST_UNIT',
  /** Set the price for an imported changeset product - (12.99) */
  SetProductPricePerCostUnit = 'SET_PRODUCT_PRICE_PER_COST_UNIT',
  /** Create or update a 'New-Product-Request' (A request to add a new product to Instacart's catalog) */
  UpsertNewProductRequest = 'UPSERT_NEW_PRODUCT_REQUEST',
}

export enum WorkflowState {
  WorkflowStateUnspecified = 'WORKFLOW_STATE_UNSPECIFIED',
  BrandNew = 'BRAND_NEW',
  PendingIdentityVerification = 'PENDING_IDENTITY_VERIFICATION',
  PendingReschedule = 'PENDING_RESCHEDULE',
  Notified = 'NOTIFIED',
  Acknowledged = 'ACKNOWLEDGED',
  Picking = 'PICKING',
  RxPicking = 'RX_PICKING',
  VerifyingReplacements = 'VERIFYING_REPLACEMENTS',
  StagingForCbt = 'STAGING_FOR_CBT',
  Checkout = 'CHECKOUT',
  RxCheckout = 'RX_CHECKOUT',
  ReceiptSanityCheck = 'RECEIPT_SANITY_CHECK',
  CustomerSamples = 'CUSTOMER_SAMPLES',
  BagsCheck = 'BAGS_CHECK',
  StagedForCbt = 'STAGED_FOR_CBT',
  StagedForDelivery = 'STAGED_FOR_DELIVERY',
  WaitingForDelivery = 'WAITING_FOR_DELIVERY',
  AcknowledgedForDelivery = 'ACKNOWLEDGED_FOR_DELIVERY',
  AtStore = 'AT_STORE',
  BagsVerified = 'BAGS_VERIFIED',
  Delivering = 'DELIVERING',
  Returning = 'RETURNING',
  Staged = 'STAGED',
  Delivered = 'DELIVERED',
  Canceled = 'CANCELED',
  RunnerAwaiting = 'RUNNER_AWAITING',
  RunnerNotFound = 'RUNNER_NOT_FOUND',
  AcknowledgedForRunning = 'ACKNOWLEDGED_FOR_RUNNING',
}

export enum WorkflowStateEnum {
  /** A workflow that is currently in-progress, and is editable */
  Draft = 'DRAFT',
  /** A workflow that has been submitted, and is no longer editable */
  Submitted = 'SUBMITTED',
  /** A workflow that has been sent to the catalog successfully */
  Completed = 'COMPLETED',
  /** A workflow that has been sent to the catalog, with one or more items failing to imprt */
  CompletedWithError = 'COMPLETED_WITH_ERROR',
}

export enum WorkflowTypeEnum {
  /** An add-to-catalog type workflow */
  AddToCatalog = 'ADD_TO_CATALOG',
}

export type FeatureTourUpdateMutationVariables = {
  name: Scalars['String']
  status: Status
}

export type FeatureTourUpdateMutation = { __typename?: 'Mutation' } & {
  featureTourUpdate: Maybe<
    { __typename?: 'FeatureTourUpdatePayload' } & Pick<FeatureTourUpdatePayload, 'success'>
  >
}

export type FetchFeatureToursQueryVariables = {}

export type FetchFeatureToursQuery = { __typename?: 'Query' } & {
  featureTours: Array<
    { __typename?: 'EnterpriseFeatureTour' } & Pick<
      EnterpriseFeatureTour,
      'name' | 'status' | 'lastShownAt'
    >
  >
}

export type GetIsGrocerMeshQueryVariables = {
  retailerLocationId: Scalars['BigInt']
}

export type GetIsGrocerMeshQuery = { __typename?: 'Query' } & {
  retailerSettingsServiceGetIsGrocer: Maybe<
    { __typename?: 'GetIsGrocerResponse' } & Pick<GetIsGrocerResponse, 'isGrocer'>
  >
}

export type GetParkingSettingsMeshQueryVariables = {
  retailerLocationId: Scalars['BigInt']
  type?: Maybe<PickupType>
}

export type GetParkingSettingsMeshQuery = { __typename?: 'Query' } & {
  retailerSettingsServiceGetParkingSettings: Maybe<
    { __typename?: 'GetParkingSettingsResponse' } & Pick<
      GetParkingSettingsResponse,
      'instruction' | 'errors'
    > & {
        imageConfigs: Maybe<
          Array<Maybe<{ __typename?: 'ImageConfig' } & Pick<ImageConfig, 'id' | 'caption' | 'url'>>>
        >
      }
  >
}

export type GetPickupSettingsMetadataQueryVariables = {
  retailerLocationId: Scalars['BigInt']
}

export type GetPickupSettingsMetadataQuery = { __typename?: 'Query' } & {
  retailerSettingsServiceGetPickupSettingsMetadata: Maybe<
    { __typename?: 'GetPickupSettingsMetadataResponse' } & Pick<
      GetPickupSettingsMetadataResponse,
      'errors' | 'isCurbsidePickupEnabled' | 'isReadyForPickup' | 'isSettingsOnboardingComplete'
    > & {
        pickupEnableDate: Maybe<
          { __typename?: 'GoogleTypeDate' } & Pick<GoogleTypeDate, 'year' | 'day' | 'month'>
        >
      }
  >
}

export type GetStagingAreaSettingsMeshQueryVariables = {
  retailerLocationId: Scalars['BigInt']
}

export type GetStagingAreaSettingsMeshQuery = { __typename?: 'Query' } & {
  retailerSettingsServiceGetStagingSettings: Maybe<
    { __typename?: 'GetStagingSettingsResponse' } & Pick<
      GetStagingSettingsResponse,
      'shelf' | 'fridge' | 'freezer' | 'instruction' | 'imageUrl'
    >
  >
}

export type UpdateParkingSettingsMutationVariables = {
  retailerLocationId: Scalars['BigInt']
  type?: Maybe<PickupType>
  instructions?: Maybe<Scalars['String']>
  images?: Maybe<Array<Maybe<ImageConfigInput>>>
  setDefault?: Maybe<Scalars['Boolean']>
}

export type UpdateParkingSettingsMutation = { __typename?: 'Mutation' } & {
  retailerSettingsServiceUpdateParkingSettings: Maybe<
    { __typename?: 'UpdateParkingSettingsResponse' } & Pick<
      UpdateParkingSettingsResponse,
      'instruction' | 'errors'
    > & {
        imageConfigs: Maybe<
          Array<Maybe<{ __typename?: 'ImageConfig' } & Pick<ImageConfig, 'id' | 'caption' | 'url'>>>
        >
      }
  >
}

export type UpdateStagingAreaSettingsMeshMutationVariables = {
  retailerLocationId: Scalars['BigInt']
  shelf?: Maybe<StringsInput>
  freezer?: Maybe<StringsInput>
  fridge?: Maybe<StringsInput>
  imageUrl?: Maybe<Scalars['String']>
  instructions?: Maybe<Scalars['String']>
}

export type UpdateStagingAreaSettingsMeshMutation = { __typename?: 'Mutation' } & {
  retailerSettingsServiceUpdateStagingSettings: Maybe<
    { __typename?: 'UpdateStagingSettingsResponse' } & Pick<
      UpdateStagingSettingsResponse,
      'shelf' | 'fridge' | 'freezer' | 'instruction' | 'imageUrl'
    >
  >
}

export const FeatureTourUpdateDocument = gql`
  mutation featureTourUpdate($name: String!, $status: Status!) {
    featureTourUpdate(name: $name, status: $status) {
      success
    }
  }
`

/**
 * __useFeatureTourUpdateMutation__
 *
 * To run a mutation, you first call `useFeatureTourUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFeatureTourUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [featureTourUpdateMutation, { data, loading, error }] = useFeatureTourUpdateMutation({
 *   variables: {
 *      name: // value for 'name'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useFeatureTourUpdateMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    FeatureTourUpdateMutation,
    FeatureTourUpdateMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    FeatureTourUpdateMutation,
    FeatureTourUpdateMutationVariables
  >(FeatureTourUpdateDocument, baseOptions)
}
export type FeatureTourUpdateMutationHookResult = ReturnType<typeof useFeatureTourUpdateMutation>
export type FeatureTourUpdateMutationResult =
  ApolloReactCommon.MutationResult<FeatureTourUpdateMutation>
export type FeatureTourUpdateMutationOptions = ApolloReactCommon.BaseMutationOptions<
  FeatureTourUpdateMutation,
  FeatureTourUpdateMutationVariables
>
export const FetchFeatureToursDocument = gql`
  query fetchFeatureTours {
    featureTours {
      name
      status
      lastShownAt
    }
  }
`

/**
 * __useFetchFeatureToursQuery__
 *
 * To run a query within a React component, call `useFetchFeatureToursQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchFeatureToursQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchFeatureToursQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchFeatureToursQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    FetchFeatureToursQuery,
    FetchFeatureToursQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<FetchFeatureToursQuery, FetchFeatureToursQueryVariables>(
    FetchFeatureToursDocument,
    baseOptions
  )
}
export function useFetchFeatureToursLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    FetchFeatureToursQuery,
    FetchFeatureToursQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<FetchFeatureToursQuery, FetchFeatureToursQueryVariables>(
    FetchFeatureToursDocument,
    baseOptions
  )
}
export type FetchFeatureToursQueryHookResult = ReturnType<typeof useFetchFeatureToursQuery>
export type FetchFeatureToursLazyQueryHookResult = ReturnType<typeof useFetchFeatureToursLazyQuery>
export type FetchFeatureToursQueryResult = ApolloReactCommon.QueryResult<
  FetchFeatureToursQuery,
  FetchFeatureToursQueryVariables
>
export const GetIsGrocerMeshDocument = gql`
  query getIsGrocerMesh($retailerLocationId: BigInt!) {
    retailerSettingsServiceGetIsGrocer(input: { retailerLocationId: $retailerLocationId }) {
      isGrocer
    }
  }
`

/**
 * __useGetIsGrocerMeshQuery__
 *
 * To run a query within a React component, call `useGetIsGrocerMeshQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIsGrocerMeshQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIsGrocerMeshQuery({
 *   variables: {
 *      retailerLocationId: // value for 'retailerLocationId'
 *   },
 * });
 */
export function useGetIsGrocerMeshQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetIsGrocerMeshQuery,
    GetIsGrocerMeshQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<GetIsGrocerMeshQuery, GetIsGrocerMeshQueryVariables>(
    GetIsGrocerMeshDocument,
    baseOptions
  )
}
export function useGetIsGrocerMeshLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetIsGrocerMeshQuery,
    GetIsGrocerMeshQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<GetIsGrocerMeshQuery, GetIsGrocerMeshQueryVariables>(
    GetIsGrocerMeshDocument,
    baseOptions
  )
}
export type GetIsGrocerMeshQueryHookResult = ReturnType<typeof useGetIsGrocerMeshQuery>
export type GetIsGrocerMeshLazyQueryHookResult = ReturnType<typeof useGetIsGrocerMeshLazyQuery>
export type GetIsGrocerMeshQueryResult = ApolloReactCommon.QueryResult<
  GetIsGrocerMeshQuery,
  GetIsGrocerMeshQueryVariables
>
export const GetParkingSettingsMeshDocument = gql`
  query getParkingSettingsMesh($retailerLocationId: BigInt!, $type: PickupType) {
    retailerSettingsServiceGetParkingSettings(
      input: { retailerLocationId: $retailerLocationId, type: $type }
    ) {
      imageConfigs {
        id
        caption
        url
      }
      instruction
      errors
    }
  }
`

/**
 * __useGetParkingSettingsMeshQuery__
 *
 * To run a query within a React component, call `useGetParkingSettingsMeshQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetParkingSettingsMeshQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetParkingSettingsMeshQuery({
 *   variables: {
 *      retailerLocationId: // value for 'retailerLocationId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetParkingSettingsMeshQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetParkingSettingsMeshQuery,
    GetParkingSettingsMeshQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    GetParkingSettingsMeshQuery,
    GetParkingSettingsMeshQueryVariables
  >(GetParkingSettingsMeshDocument, baseOptions)
}
export function useGetParkingSettingsMeshLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetParkingSettingsMeshQuery,
    GetParkingSettingsMeshQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    GetParkingSettingsMeshQuery,
    GetParkingSettingsMeshQueryVariables
  >(GetParkingSettingsMeshDocument, baseOptions)
}
export type GetParkingSettingsMeshQueryHookResult = ReturnType<
  typeof useGetParkingSettingsMeshQuery
>
export type GetParkingSettingsMeshLazyQueryHookResult = ReturnType<
  typeof useGetParkingSettingsMeshLazyQuery
>
export type GetParkingSettingsMeshQueryResult = ApolloReactCommon.QueryResult<
  GetParkingSettingsMeshQuery,
  GetParkingSettingsMeshQueryVariables
>
export const GetPickupSettingsMetadataDocument = gql`
  query getPickupSettingsMetadata($retailerLocationId: BigInt!) {
    retailerSettingsServiceGetPickupSettingsMetadata(
      input: { retailerLocationId: $retailerLocationId }
    ) {
      errors
      isCurbsidePickupEnabled
      isReadyForPickup
      isSettingsOnboardingComplete
      pickupEnableDate {
        year
        day
        month
      }
    }
  }
`

/**
 * __useGetPickupSettingsMetadataQuery__
 *
 * To run a query within a React component, call `useGetPickupSettingsMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPickupSettingsMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPickupSettingsMetadataQuery({
 *   variables: {
 *      retailerLocationId: // value for 'retailerLocationId'
 *   },
 * });
 */
export function useGetPickupSettingsMetadataQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetPickupSettingsMetadataQuery,
    GetPickupSettingsMetadataQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    GetPickupSettingsMetadataQuery,
    GetPickupSettingsMetadataQueryVariables
  >(GetPickupSettingsMetadataDocument, baseOptions)
}
export function useGetPickupSettingsMetadataLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetPickupSettingsMetadataQuery,
    GetPickupSettingsMetadataQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    GetPickupSettingsMetadataQuery,
    GetPickupSettingsMetadataQueryVariables
  >(GetPickupSettingsMetadataDocument, baseOptions)
}
export type GetPickupSettingsMetadataQueryHookResult = ReturnType<
  typeof useGetPickupSettingsMetadataQuery
>
export type GetPickupSettingsMetadataLazyQueryHookResult = ReturnType<
  typeof useGetPickupSettingsMetadataLazyQuery
>
export type GetPickupSettingsMetadataQueryResult = ApolloReactCommon.QueryResult<
  GetPickupSettingsMetadataQuery,
  GetPickupSettingsMetadataQueryVariables
>
export const GetStagingAreaSettingsMeshDocument = gql`
  query getStagingAreaSettingsMesh($retailerLocationId: BigInt!) {
    retailerSettingsServiceGetStagingSettings(input: { retailerLocationId: $retailerLocationId }) {
      shelf
      fridge
      freezer
      instruction
      imageUrl
    }
  }
`

/**
 * __useGetStagingAreaSettingsMeshQuery__
 *
 * To run a query within a React component, call `useGetStagingAreaSettingsMeshQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStagingAreaSettingsMeshQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStagingAreaSettingsMeshQuery({
 *   variables: {
 *      retailerLocationId: // value for 'retailerLocationId'
 *   },
 * });
 */
export function useGetStagingAreaSettingsMeshQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetStagingAreaSettingsMeshQuery,
    GetStagingAreaSettingsMeshQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    GetStagingAreaSettingsMeshQuery,
    GetStagingAreaSettingsMeshQueryVariables
  >(GetStagingAreaSettingsMeshDocument, baseOptions)
}
export function useGetStagingAreaSettingsMeshLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetStagingAreaSettingsMeshQuery,
    GetStagingAreaSettingsMeshQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    GetStagingAreaSettingsMeshQuery,
    GetStagingAreaSettingsMeshQueryVariables
  >(GetStagingAreaSettingsMeshDocument, baseOptions)
}
export type GetStagingAreaSettingsMeshQueryHookResult = ReturnType<
  typeof useGetStagingAreaSettingsMeshQuery
>
export type GetStagingAreaSettingsMeshLazyQueryHookResult = ReturnType<
  typeof useGetStagingAreaSettingsMeshLazyQuery
>
export type GetStagingAreaSettingsMeshQueryResult = ApolloReactCommon.QueryResult<
  GetStagingAreaSettingsMeshQuery,
  GetStagingAreaSettingsMeshQueryVariables
>
export const UpdateParkingSettingsDocument = gql`
  mutation updateParkingSettings(
    $retailerLocationId: BigInt!
    $type: PickupType
    $instructions: String
    $images: [ImageConfigInput]
    $setDefault: Boolean
  ) {
    retailerSettingsServiceUpdateParkingSettings(
      input: {
        retailerLocationId: $retailerLocationId
        type: $type
        instruction: $instructions
        imageConfigs: $images
        setDefault: $setDefault
      }
    ) {
      imageConfigs {
        id
        caption
        url
      }
      instruction
      errors
    }
  }
`

/**
 * __useUpdateParkingSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateParkingSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateParkingSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateParkingSettingsMutation, { data, loading, error }] = useUpdateParkingSettingsMutation({
 *   variables: {
 *      retailerLocationId: // value for 'retailerLocationId'
 *      type: // value for 'type'
 *      instructions: // value for 'instructions'
 *      images: // value for 'images'
 *      setDefault: // value for 'setDefault'
 *   },
 * });
 */
export function useUpdateParkingSettingsMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateParkingSettingsMutation,
    UpdateParkingSettingsMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    UpdateParkingSettingsMutation,
    UpdateParkingSettingsMutationVariables
  >(UpdateParkingSettingsDocument, baseOptions)
}
export type UpdateParkingSettingsMutationHookResult = ReturnType<
  typeof useUpdateParkingSettingsMutation
>
export type UpdateParkingSettingsMutationResult =
  ApolloReactCommon.MutationResult<UpdateParkingSettingsMutation>
export type UpdateParkingSettingsMutationOptions = ApolloReactCommon.BaseMutationOptions<
  UpdateParkingSettingsMutation,
  UpdateParkingSettingsMutationVariables
>
export const UpdateStagingAreaSettingsMeshDocument = gql`
  mutation updateStagingAreaSettingsMesh(
    $retailerLocationId: BigInt!
    $shelf: StringsInput
    $freezer: StringsInput
    $fridge: StringsInput
    $imageUrl: String
    $instructions: String
  ) {
    retailerSettingsServiceUpdateStagingSettings(
      input: {
        retailerLocationId: $retailerLocationId
        shelf: $shelf
        freezer: $freezer
        fridge: $fridge
        imageUrl: $imageUrl
        instruction: $instructions
      }
    ) {
      shelf
      fridge
      freezer
      instruction
      imageUrl
    }
  }
`

/**
 * __useUpdateStagingAreaSettingsMeshMutation__
 *
 * To run a mutation, you first call `useUpdateStagingAreaSettingsMeshMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStagingAreaSettingsMeshMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStagingAreaSettingsMeshMutation, { data, loading, error }] = useUpdateStagingAreaSettingsMeshMutation({
 *   variables: {
 *      retailerLocationId: // value for 'retailerLocationId'
 *      shelf: // value for 'shelf'
 *      freezer: // value for 'freezer'
 *      fridge: // value for 'fridge'
 *      imageUrl: // value for 'imageUrl'
 *      instructions: // value for 'instructions'
 *   },
 * });
 */
export function useUpdateStagingAreaSettingsMeshMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateStagingAreaSettingsMeshMutation,
    UpdateStagingAreaSettingsMeshMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    UpdateStagingAreaSettingsMeshMutation,
    UpdateStagingAreaSettingsMeshMutationVariables
  >(UpdateStagingAreaSettingsMeshDocument, baseOptions)
}
export type UpdateStagingAreaSettingsMeshMutationHookResult = ReturnType<
  typeof useUpdateStagingAreaSettingsMeshMutation
>
export type UpdateStagingAreaSettingsMeshMutationResult =
  ApolloReactCommon.MutationResult<UpdateStagingAreaSettingsMeshMutation>
export type UpdateStagingAreaSettingsMeshMutationOptions = ApolloReactCommon.BaseMutationOptions<
  UpdateStagingAreaSettingsMeshMutation,
  UpdateStagingAreaSettingsMeshMutationVariables
>
